const GlanceAgent = (function () {
  /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
  var COMPILED = !0,
    goog = goog || {};
  goog.global = this || self;
  goog.exportPath_ = function (
    $name$$,
    $object$$,
    $overwriteImplicit$$,
    $cur_objectToExportTo$$
  ) {
    $name$$ = $name$$.split('.');
    $cur_objectToExportTo$$ = $cur_objectToExportTo$$ || goog.global;
    $name$$[0] in $cur_objectToExportTo$$ ||
      'undefined' == typeof $cur_objectToExportTo$$.execScript ||
      $cur_objectToExportTo$$.execScript('var ' + $name$$[0]);
    for (var $part$$; $name$$.length && ($part$$ = $name$$.shift()); ) {
      if ($name$$.length || void 0 === $object$$) {
        $cur_objectToExportTo$$ =
          $cur_objectToExportTo$$[$part$$] &&
          $cur_objectToExportTo$$[$part$$] !== Object.prototype[$part$$]
            ? $cur_objectToExportTo$$[$part$$]
            : ($cur_objectToExportTo$$[$part$$] = {});
      } else {
        if (
          !$overwriteImplicit$$ &&
          goog.isObject($object$$) &&
          goog.isObject($cur_objectToExportTo$$[$part$$])
        ) {
          for (var $prop$$ in $object$$) {
            $object$$.hasOwnProperty($prop$$) &&
              ($cur_objectToExportTo$$[$part$$][$prop$$] = $object$$[$prop$$]);
          }
        } else {
          $cur_objectToExportTo$$[$part$$] = $object$$;
        }
      }
    }
  };
  goog.define = function ($name$$, $defaultValue$jscomp$2_value$$) {
    if (!COMPILED) {
      var $uncompiledDefines$$ = goog.global.CLOSURE_UNCOMPILED_DEFINES,
        $defines$$ = goog.global.CLOSURE_DEFINES;
      $uncompiledDefines$$ &&
      void 0 === $uncompiledDefines$$.nodeType &&
      Object.prototype.hasOwnProperty.call($uncompiledDefines$$, $name$$)
        ? ($defaultValue$jscomp$2_value$$ = $uncompiledDefines$$[$name$$])
        : $defines$$ &&
          void 0 === $defines$$.nodeType &&
          Object.prototype.hasOwnProperty.call($defines$$, $name$$) &&
          ($defaultValue$jscomp$2_value$$ = $defines$$[$name$$]);
    }
    return $defaultValue$jscomp$2_value$$;
  };
  goog.FEATURESET_YEAR = 2012;
  goog.DEBUG = !0;
  goog.LOCALE = 'en';
  goog.TRUSTED_SITE = !0;
  goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
  goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
  goog.provide = function ($name$$) {
    if (goog.isInModuleLoader_()) {
      throw Error('goog.provide cannot be used within a module.');
    }
    if (!COMPILED && goog.isProvided_($name$$)) {
      throw Error('Namespace "' + $name$$ + '" already declared.');
    }
    goog.constructNamespace_($name$$);
  };
  goog.constructNamespace_ = function (
    $name$$,
    $object$$,
    $overwriteImplicit$$
  ) {
    if (!COMPILED) {
      delete goog.implicitNamespaces_[$name$$];
      for (
        var $namespace$$ = $name$$;
        ($namespace$$ = $namespace$$.substring(
          0,
          $namespace$$.lastIndexOf('.')
        )) && !goog.getObjectByName($namespace$$);

      ) {
        goog.implicitNamespaces_[$namespace$$] = !0;
      }
    }
    goog.exportPath_($name$$, $object$$, $overwriteImplicit$$);
  };
  goog.getScriptNonce = function ($opt_window$$) {
    if ($opt_window$$ && $opt_window$$ != goog.global) {
      return goog.getScriptNonce_($opt_window$$.document);
    }
    null === goog.cspNonce_ &&
      (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
    return goog.cspNonce_;
  };
  goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
  goog.cspNonce_ = null;
  goog.getScriptNonce_ = function ($doc_nonce_script$$) {
    return ($doc_nonce_script$$ =
      $doc_nonce_script$$.querySelector &&
      $doc_nonce_script$$.querySelector('script[nonce]')) &&
      ($doc_nonce_script$$ =
        $doc_nonce_script$$.nonce ||
        $doc_nonce_script$$.getAttribute('nonce')) &&
      goog.NONCE_PATTERN_.test($doc_nonce_script$$)
      ? $doc_nonce_script$$
      : '';
  };
  goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
  goog.module = function ($name$$) {
    if (
      'string' !== typeof $name$$ ||
      !$name$$ ||
      -1 == $name$$.search(goog.VALID_MODULE_RE_)
    ) {
      throw Error('Invalid module identifier');
    }
    if (!goog.isInGoogModuleLoader_()) {
      throw Error(
        'Module ' +
          $name$$ +
          " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide."
      );
    }
    if (goog.moduleLoaderState_.moduleName) {
      throw Error('goog.module may only be called once per module.');
    }
    goog.moduleLoaderState_.moduleName = $name$$;
    if (!COMPILED) {
      if (goog.isProvided_($name$$)) {
        throw Error('Namespace "' + $name$$ + '" already declared.');
      }
      delete goog.implicitNamespaces_[$name$$];
    }
  };
  goog.module.get = function ($name$$) {
    return goog.module.getInternal_($name$$);
  };
  goog.module.getInternal_ = function ($name$$) {
    if (!COMPILED) {
      if ($name$$ in goog.loadedModules_) {
        return goog.loadedModules_[$name$$].exports;
      }
      if (!goog.implicitNamespaces_[$name$$]) {
        return (
          ($name$$ = goog.getObjectByName($name$$)),
          null != $name$$ ? $name$$ : null
        );
      }
    }
    return null;
  };
  goog.ModuleType = { ES6: 'es6', GOOG: 'goog' };
  goog.moduleLoaderState_ = null;
  goog.isInModuleLoader_ = function () {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
  };
  goog.isInGoogModuleLoader_ = function () {
    return (
      !!goog.moduleLoaderState_ &&
      goog.moduleLoaderState_.type == goog.ModuleType.GOOG
    );
  };
  goog.isInEs6ModuleLoader_ = function () {
    if (
      goog.moduleLoaderState_ &&
      goog.moduleLoaderState_.type == goog.ModuleType.ES6
    ) {
      return !0;
    }
    var $jscomp$$ = goog.global.$jscomp;
    return $jscomp$$
      ? 'function' != typeof $jscomp$$.getCurrentModulePath
        ? !1
        : !!$jscomp$$.getCurrentModulePath()
      : !1;
  };
  goog.module.declareLegacyNamespace = function () {
    if (!COMPILED && !goog.isInGoogModuleLoader_()) {
      throw Error(
        'goog.module.declareLegacyNamespace must be called from within a goog.module'
      );
    }
    if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
      throw Error(
        'goog.module must be called prior to goog.module.declareLegacyNamespace.'
      );
    }
    goog.moduleLoaderState_.declareLegacyNamespace = !0;
  };
  goog.declareModuleId = function ($namespace$$) {
    if (!COMPILED) {
      if (!goog.isInEs6ModuleLoader_()) {
        throw Error(
          'goog.declareModuleId may only be called from within an ES6 module'
        );
      }
      if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) {
        throw Error('goog.declareModuleId may only be called once per module.');
      }
      if ($namespace$$ in goog.loadedModules_) {
        throw Error(
          'Module with namespace "' + $namespace$$ + '" already exists.'
        );
      }
    }
    if (goog.moduleLoaderState_) {
      goog.moduleLoaderState_.moduleName = $namespace$$;
    } else {
      var $exports_jscomp$$ = goog.global.$jscomp;
      if (
        !$exports_jscomp$$ ||
        'function' != typeof $exports_jscomp$$.getCurrentModulePath
      ) {
        throw Error(
          'Module with namespace "' +
            $namespace$$ +
            '" has been loaded incorrectly.'
        );
      }
      $exports_jscomp$$ = $exports_jscomp$$.require(
        $exports_jscomp$$.getCurrentModulePath()
      );
      goog.loadedModules_[$namespace$$] = {
        exports: $exports_jscomp$$,
        type: goog.ModuleType.ES6,
        moduleId: $namespace$$,
      };
    }
  };
  goog.setTestOnly = function ($opt_message$$) {
    if (goog.DISALLOW_TEST_ONLY_CODE) {
      throw (
        (($opt_message$$ = $opt_message$$ || ''),
        Error(
          'Importing test-only code into non-debug environment' +
            ($opt_message$$ ? ': ' + $opt_message$$ : '.')
        ))
      );
    }
  };
  goog.forwardDeclare = function ($name$$) {};
  COMPILED ||
    ((goog.isProvided_ = function ($name$$) {
      return (
        $name$$ in goog.loadedModules_ ||
        (!goog.implicitNamespaces_[$name$$] &&
          null != goog.getObjectByName($name$$))
      );
    }),
    (goog.implicitNamespaces_ = { 'goog.module': !0 }));
  goog.getObjectByName = function ($name$jscomp$83_parts$$, $cur$$) {
    $name$jscomp$83_parts$$ = $name$jscomp$83_parts$$.split('.');
    $cur$$ = $cur$$ || goog.global;
    for (var $i$$ = 0; $i$$ < $name$jscomp$83_parts$$.length; $i$$++) {
      if ((($cur$$ = $cur$$[$name$jscomp$83_parts$$[$i$$]]), null == $cur$$)) {
        return null;
      }
    }
    return $cur$$;
  };
  goog.addDependency = function (
    $relPath$$,
    $provides$$,
    $requires$$,
    $opt_loadFlags$$
  ) {
    !COMPILED &&
      goog.DEPENDENCIES_ENABLED &&
      goog.debugLoader_.addDependency(
        $relPath$$,
        $provides$$,
        $requires$$,
        $opt_loadFlags$$
      );
  };
  goog.ENABLE_DEBUG_LOADER = !0;
  goog.logToConsole_ = function ($msg$$) {
    goog.global.console && goog.global.console.error($msg$$);
  };
  goog.require = function ($namespace$$) {
    if (!COMPILED) {
      goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested($namespace$$);
      if (goog.isProvided_($namespace$$)) {
        if (goog.isInModuleLoader_()) {
          return goog.module.getInternal_($namespace$$);
        }
      } else if (goog.ENABLE_DEBUG_LOADER) {
        var $moduleLoaderState$$ = goog.moduleLoaderState_;
        goog.moduleLoaderState_ = null;
        try {
          goog.debugLoader_.load_($namespace$$);
        } finally {
          goog.moduleLoaderState_ = $moduleLoaderState$$;
        }
      }
      return null;
    }
  };
  goog.requireType = function ($namespace$$) {
    return {};
  };
  goog.basePath = '';
  goog.nullFunction = function () {};
  goog.abstractMethod = function () {
    throw Error('unimplemented abstract method');
  };
  goog.addSingletonGetter = function ($ctor$$) {
    $ctor$$.instance_ = void 0;
    $ctor$$.getInstance = function () {
      if ($ctor$$.instance_) {
        return $ctor$$.instance_;
      }
      goog.DEBUG &&
        (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] =
          $ctor$$);
      return ($ctor$$.instance_ = new $ctor$$());
    };
  };
  goog.instantiatedSingletons_ = [];
  goog.LOAD_MODULE_USING_EVAL = !0;
  goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
  goog.loadedModules_ = {};
  goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
  goog.TRANSPILE = 'detect';
  goog.ASSUME_ES_MODULES_TRANSPILED = !1;
  goog.TRANSPILE_TO_LANGUAGE = '';
  goog.TRANSPILER = 'transpile.js';
  goog.hasBadLetScoping = null;
  goog.loadModule = function ($moduleDef$$) {
    var $previousState$$ = goog.moduleLoaderState_;
    try {
      goog.moduleLoaderState_ = {
        moduleName: '',
        declareLegacyNamespace: !1,
        type: goog.ModuleType.GOOG,
      };
      var $origExports$$ = {},
        $exports$$ = $origExports$$;
      if ('function' === typeof $moduleDef$$) {
        $exports$$ = $moduleDef$$.call(void 0, $exports$$);
      } else if ('string' === typeof $moduleDef$$) {
        $exports$$ = goog.loadModuleFromSource_.call(
          void 0,
          $exports$$,
          $moduleDef$$
        );
      } else {
        throw Error('Invalid module definition');
      }
      var $moduleName$$ = goog.moduleLoaderState_.moduleName;
      if ('string' === typeof $moduleName$$ && $moduleName$$) {
        goog.moduleLoaderState_.declareLegacyNamespace
          ? goog.constructNamespace_(
              $moduleName$$,
              $exports$$,
              $origExports$$ !== $exports$$
            )
          : goog.SEAL_MODULE_EXPORTS &&
            Object.seal &&
            'object' == typeof $exports$$ &&
            null != $exports$$ &&
            Object.seal($exports$$),
          (goog.loadedModules_[$moduleName$$] = {
            exports: $exports$$,
            type: goog.ModuleType.GOOG,
            moduleId: goog.moduleLoaderState_.moduleName,
          });
      } else {
        throw Error('Invalid module name "' + $moduleName$$ + '"');
      }
    } finally {
      goog.moduleLoaderState_ = $previousState$$;
    }
  };
  goog.loadModuleFromSource_ = function (
    $exports$$,
    $JSCompiler_OptimizeArgumentsArray_p0$$
  ) {
    eval(
      goog.CLOSURE_EVAL_PREFILTER_.createScript(
        $JSCompiler_OptimizeArgumentsArray_p0$$
      )
    );
    return $exports$$;
  };
  goog.normalizePath_ = function ($components_path$$) {
    $components_path$$ = $components_path$$.split('/');
    for (var $i$$ = 0; $i$$ < $components_path$$.length; ) {
      '.' == $components_path$$[$i$$]
        ? $components_path$$.splice($i$$, 1)
        : $i$$ &&
          '..' == $components_path$$[$i$$] &&
          $components_path$$[$i$$ - 1] &&
          '..' != $components_path$$[$i$$ - 1]
        ? $components_path$$.splice(--$i$$, 2)
        : $i$$++;
    }
    return $components_path$$.join('/');
  };
  goog.loadFileSync_ = function ($src$$) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
      return goog.global.CLOSURE_LOAD_FILE_SYNC($src$$);
    }
    try {
      var $xhr$$ = new goog.global.XMLHttpRequest();
      $xhr$$.open('get', $src$$, !1);
      $xhr$$.send();
      return 0 == $xhr$$.status || 200 == $xhr$$.status
        ? $xhr$$.responseText
        : null;
    } catch ($err$$) {
      return null;
    }
  };
  goog.transpile_ = function ($code$jscomp$0$$, $path$jscomp$0$$, $target$$) {
    var $jscomp$$ = goog.global.$jscomp;
    $jscomp$$ || (goog.global.$jscomp = $jscomp$$ = {});
    var $transpile$$ = $jscomp$$.transpile;
    if (!$transpile$$) {
      var $transpilerPath$$ = goog.basePath + goog.TRANSPILER,
        $transpilerCode$$ = goog.loadFileSync_($transpilerPath$$);
      if ($transpilerCode$$) {
        (function () {
          (0, eval)($transpilerCode$$ + '\n//# sourceURL=' + $transpilerPath$$);
        }).call(goog.global);
        if (
          goog.global.$gwtExport &&
          goog.global.$gwtExport.$jscomp &&
          !goog.global.$gwtExport.$jscomp.transpile
        ) {
          throw Error(
            'The transpiler did not properly export the "transpile" method. $gwtExport: ' +
              JSON.stringify(goog.global.$gwtExport)
          );
        }
        goog.global.$jscomp.transpile =
          goog.global.$gwtExport.$jscomp.transpile;
        $jscomp$$ = goog.global.$jscomp;
        $transpile$$ = $jscomp$$.transpile;
      }
    }
    $transpile$$ ||
      ($transpile$$ = $jscomp$$.transpile =
        function ($code$$, $path$$) {
          goog.logToConsole_(
            $path$$ + ' requires transpilation but no transpiler was found.'
          );
          return $code$$;
        });
    return $transpile$$($code$jscomp$0$$, $path$jscomp$0$$, $target$$);
  };
  goog.typeOf = function ($value$$) {
    var $s$$ = typeof $value$$;
    return 'object' != $s$$
      ? $s$$
      : $value$$
      ? Array.isArray($value$$)
        ? 'array'
        : $s$$
      : 'null';
  };
  goog.isArrayLike = function ($val$$) {
    var $type$$ = goog.typeOf($val$$);
    return (
      'array' == $type$$ ||
      ('object' == $type$$ && 'number' == typeof $val$$.length)
    );
  };
  goog.isDateLike = function ($val$$) {
    return goog.isObject($val$$) && 'function' == typeof $val$$.getFullYear;
  };
  goog.isObject = function ($val$$) {
    var $type$$ = typeof $val$$;
    return ('object' == $type$$ && null != $val$$) || 'function' == $type$$;
  };
  goog.getUid = function ($obj$$) {
    return (
      (Object.prototype.hasOwnProperty.call($obj$$, goog.UID_PROPERTY_) &&
        $obj$$[goog.UID_PROPERTY_]) ||
      ($obj$$[goog.UID_PROPERTY_] = ++goog.uidCounter_)
    );
  };
  goog.hasUid = function ($obj$$) {
    return !!$obj$$[goog.UID_PROPERTY_];
  };
  goog.removeUid = function ($obj$$) {
    null !== $obj$$ &&
      'removeAttribute' in $obj$$ &&
      $obj$$.removeAttribute(goog.UID_PROPERTY_);
    try {
      delete $obj$$[goog.UID_PROPERTY_];
    } catch ($ex$$) {}
  };
  goog.UID_PROPERTY_ = 'closure_uid_' + ((1e9 * Math.random()) >>> 0);
  goog.uidCounter_ = 0;
  goog.cloneObject = function ($obj$$) {
    var $clone_type$$ = goog.typeOf($obj$$);
    if ('object' == $clone_type$$ || 'array' == $clone_type$$) {
      if ('function' === typeof $obj$$.clone) {
        return $obj$$.clone();
      }
      $clone_type$$ = 'array' == $clone_type$$ ? [] : {};
      for (var $key$$ in $obj$$) {
        $clone_type$$[$key$$] = goog.cloneObject($obj$$[$key$$]);
      }
      return $clone_type$$;
    }
    return $obj$$;
  };
  goog.bindNative_ = function ($fn$$, $selfObj$$, $var_args$$) {
    return $fn$$.call.apply($fn$$.bind, arguments);
  };
  goog.bindJs_ = function ($fn$$, $selfObj$$, $var_args$$) {
    if (!$fn$$) {
      throw Error();
    }
    if (2 < arguments.length) {
      var $boundArgs$$ = Array.prototype.slice.call(arguments, 2);
      return function () {
        var $newArgs$$ = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply($newArgs$$, $boundArgs$$);
        return $fn$$.apply($selfObj$$, $newArgs$$);
      };
    }
    return function () {
      return $fn$$.apply($selfObj$$, arguments);
    };
  };
  goog.bind = function ($fn$$, $selfObj$$, $var_args$$) {
    Function.prototype.bind &&
    -1 != Function.prototype.bind.toString().indexOf('native code')
      ? (goog.bind = goog.bindNative_)
      : (goog.bind = goog.bindJs_);
    return goog.bind.apply(null, arguments);
  };
  goog.partial = function ($fn$$, $var_args$$) {
    var $args$$ = Array.prototype.slice.call(arguments, 1);
    return function () {
      var $newArgs$$ = $args$$.slice();
      $newArgs$$.push.apply($newArgs$$, arguments);
      return $fn$$.apply(this, $newArgs$$);
    };
  };
  goog.mixin = function ($target$$, $source$$) {
    for (var $x$$ in $source$$) {
      $target$$[$x$$] = $source$$[$x$$];
    }
  };
  goog.now = function () {
    return Date.now();
  };
  goog.globalEval = function ($script$$) {
    (0, eval)($script$$);
  };
  goog.getCssName = function ($className_result$$, $opt_modifier$$) {
    if ('.' == String($className_result$$).charAt(0)) {
      throw Error(
        'className passed in goog.getCssName must not start with ".". You passed: ' +
          $className_result$$
      );
    }
    var $getMapping$$ = function ($cssName$$) {
        return goog.cssNameMapping_[$cssName$$] || $cssName$$;
      },
      $rename_renameByParts$$ = function ($cssName$jscomp$1_parts$$) {
        $cssName$jscomp$1_parts$$ = $cssName$jscomp$1_parts$$.split('-');
        for (
          var $mapped$$ = [], $i$$ = 0;
          $i$$ < $cssName$jscomp$1_parts$$.length;
          $i$$++
        ) {
          $mapped$$.push($getMapping$$($cssName$jscomp$1_parts$$[$i$$]));
        }
        return $mapped$$.join('-');
      };
    $rename_renameByParts$$ = goog.cssNameMapping_
      ? 'BY_WHOLE' == goog.cssNameMappingStyle_
        ? $getMapping$$
        : $rename_renameByParts$$
      : function ($a$$) {
          return $a$$;
        };
    $className_result$$ = $opt_modifier$$
      ? $className_result$$ + '-' + $rename_renameByParts$$($opt_modifier$$)
      : $rename_renameByParts$$($className_result$$);
    return goog.global.CLOSURE_CSS_NAME_MAP_FN
      ? goog.global.CLOSURE_CSS_NAME_MAP_FN($className_result$$)
      : $className_result$$;
  };
  goog.setCssNameMapping = function ($mapping$$, $opt_style$$) {
    goog.cssNameMapping_ = $mapping$$;
    goog.cssNameMappingStyle_ = $opt_style$$;
  };
  !COMPILED &&
    goog.global.CLOSURE_CSS_NAME_MAPPING &&
    (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
  goog.getMsg = function ($str$$, $opt_values$$, $opt_options$$) {
    $opt_options$$ &&
      $opt_options$$.html &&
      ($str$$ = $str$$.replace(/</g, '&lt;'));
    $opt_options$$ &&
      $opt_options$$.unescapeHtmlEntities &&
      ($str$$ = $str$$
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&apos;/g, "'")
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&'));
    $opt_values$$ &&
      ($str$$ = $str$$.replace(/\{\$([^}]+)}/g, function ($match$$, $key$$) {
        return null != $opt_values$$ && $key$$ in $opt_values$$
          ? $opt_values$$[$key$$]
          : $match$$;
      }));
    return $str$$;
  };
  goog.getMsgWithFallback = function ($a$$, $b$$) {
    return $a$$;
  };
  goog.exportSymbol = function ($publicPath$$, $object$$, $objectToExportTo$$) {
    goog.exportPath_($publicPath$$, $object$$, !0, $objectToExportTo$$);
  };
  goog.exportProperty = function ($object$$, $publicName$$, $symbol$$) {
    $object$$[$publicName$$] = $symbol$$;
  };
  goog.inherits = function ($childCtor$$, $parentCtor$$) {
    function $tempCtor$$() {}
    $tempCtor$$.prototype = $parentCtor$$.prototype;
    $childCtor$$.superClass_ = $parentCtor$$.prototype;
    $childCtor$$.prototype = new $tempCtor$$();
    $childCtor$$.prototype.constructor = $childCtor$$;
    $childCtor$$.base = function ($me$$, $methodName$$, $var_args$$) {
      for (
        var $args$$ = Array(arguments.length - 2), $i$$ = 2;
        $i$$ < arguments.length;
        $i$$++
      ) {
        $args$$[$i$$ - 2] = arguments[$i$$];
      }
      return $parentCtor$$.prototype[$methodName$$].apply($me$$, $args$$);
    };
  };
  goog.scope = function ($fn$$) {
    if (goog.isInModuleLoader_()) {
      throw Error('goog.scope is not supported within a module.');
    }
    $fn$$.call(goog.global);
  };
  COMPILED || (goog.global.COMPILED = COMPILED);
  goog.defineClass = function ($superClass$$, $def$$) {
    var $cls_constructor$$ = $def$$.constructor,
      $statics$$ = $def$$.statics;
    ($cls_constructor$$ &&
      $cls_constructor$$ != Object.prototype.constructor) ||
      ($cls_constructor$$ = function () {
        throw Error(
          'cannot instantiate an interface (no constructor defined).'
        );
      });
    $cls_constructor$$ = goog.defineClass.createSealingConstructor_(
      $cls_constructor$$,
      $superClass$$
    );
    $superClass$$ && goog.inherits($cls_constructor$$, $superClass$$);
    delete $def$$.constructor;
    delete $def$$.statics;
    goog.defineClass.applyProperties_($cls_constructor$$.prototype, $def$$);
    null != $statics$$ &&
      ($statics$$ instanceof Function
        ? $statics$$($cls_constructor$$)
        : goog.defineClass.applyProperties_($cls_constructor$$, $statics$$));
    return $cls_constructor$$;
  };
  goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
  goog.defineClass.createSealingConstructor_ = function (
    $ctr$$,
    $superClass$$
  ) {
    return goog.defineClass.SEAL_CLASS_INSTANCES
      ? function () {
          var $instance$$ = $ctr$$.apply(this, arguments) || this;
          $instance$$[goog.UID_PROPERTY_] = $instance$$[goog.UID_PROPERTY_];
          return $instance$$;
        }
      : $ctr$$;
  };
  goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ =
    'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(
      ' '
    );
  goog.defineClass.applyProperties_ = function ($target$$, $source$$) {
    for (var $key$$ in $source$$) {
      Object.prototype.hasOwnProperty.call($source$$, $key$$) &&
        ($target$$[$key$$] = $source$$[$key$$]);
    }
    for (
      var $i$$ = 0;
      $i$$ < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;
      $i$$++
    ) {
      ($key$$ = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[$i$$]),
        Object.prototype.hasOwnProperty.call($source$$, $key$$) &&
          ($target$$[$key$$] = $source$$[$key$$]);
    }
  };
  !COMPILED &&
    goog.DEPENDENCIES_ENABLED &&
    ((goog.inHtmlDocument_ = function () {
      var $doc$$ = goog.global.document;
      return null != $doc$$ && 'write' in $doc$$;
    }),
    (goog.isDocumentLoading_ = function () {
      var $doc$$ = goog.global.document;
      return $doc$$.attachEvent
        ? 'complete' != $doc$$.readyState
        : 'loading' == $doc$$.readyState;
    }),
    (goog.findBasePath_ = function () {
      if (
        void 0 != goog.global.CLOSURE_BASE_PATH &&
        'string' === typeof goog.global.CLOSURE_BASE_PATH
      ) {
        goog.basePath = goog.global.CLOSURE_BASE_PATH;
      } else if (goog.inHtmlDocument_()) {
        var $doc$$ = goog.global.document,
          $currentScript_i$$ = $doc$$.currentScript;
        $doc$$ = $currentScript_i$$
          ? [$currentScript_i$$]
          : $doc$$.getElementsByTagName('SCRIPT');
        for (
          $currentScript_i$$ = $doc$$.length - 1;
          0 <= $currentScript_i$$;
          --$currentScript_i$$
        ) {
          var $src$$ = $doc$$[$currentScript_i$$].src,
            $l_qmark$$ = $src$$.lastIndexOf('?');
          $l_qmark$$ = -1 == $l_qmark$$ ? $src$$.length : $l_qmark$$;
          if ('base.js' == $src$$.substr($l_qmark$$ - 7, 7)) {
            goog.basePath = $src$$.substr(0, $l_qmark$$ - 7);
            break;
          }
        }
      }
    }),
    goog.findBasePath_(),
    (goog.Transpiler = function () {
      this.requiresTranspilation_ = null;
      this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
    }),
    (goog.Transpiler.prototype.createRequiresTranspilation_ = function () {
      function $addNewerLanguageTranspilationCheck$$(
        $modeName$$,
        $isSupported$$
      ) {
        $transpilationRequiredForAllLaterModes$$
          ? ($requiresTranspilation$$[$modeName$$] = !0)
          : $isSupported$$()
          ? (($transpilationTarget$$ = $modeName$$),
            ($requiresTranspilation$$[$modeName$$] = !1))
          : ($transpilationRequiredForAllLaterModes$$ =
              $requiresTranspilation$$[$modeName$$] =
                !0);
      }
      function $evalCheck$$($code$$) {
        try {
          return !!eval($code$$);
        } catch ($ignored$$) {
          return !1;
        }
      }
      var $transpilationTarget$$ = 'es3',
        $requiresTranspilation$$ = { es3: !1 },
        $transpilationRequiredForAllLaterModes$$ = !1,
        $userAgent$$ =
          goog.global.navigator && goog.global.navigator.userAgent
            ? goog.global.navigator.userAgent
            : '';
      $addNewerLanguageTranspilationCheck$$('es5', function () {
        return $evalCheck$$('[1,].length==1');
      });
      $addNewerLanguageTranspilationCheck$$('es6', function () {
        return $userAgent$$.match(/Edge\/(\d+)(\.\d)*/i)
          ? !1
          : $evalCheck$$(
              '(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()'
            );
      });
      $addNewerLanguageTranspilationCheck$$('es7', function () {
        return $evalCheck$$('2**3==8');
      });
      $addNewerLanguageTranspilationCheck$$('es8', function () {
        return $evalCheck$$('async()=>1,1');
      });
      $addNewerLanguageTranspilationCheck$$('es9', function () {
        return $evalCheck$$('({...rest}={}),1');
      });
      $addNewerLanguageTranspilationCheck$$('es_2019', function () {
        return $evalCheck$$('let r;try{throw 0}catch{r="\u2029"};r');
      });
      $addNewerLanguageTranspilationCheck$$('es_2020', function () {
        return $evalCheck$$('null?.x??1');
      });
      $addNewerLanguageTranspilationCheck$$('es_next', function () {
        return !1;
      });
      return { target: $transpilationTarget$$, map: $requiresTranspilation$$ };
    }),
    (goog.Transpiler.prototype.needsTranspile = function ($lang$$, $module$$) {
      if ('always' == goog.TRANSPILE) {
        return !0;
      }
      if ('never' == goog.TRANSPILE) {
        return !1;
      }
      if (!this.requiresTranspilation_) {
        var $obj$$ = this.createRequiresTranspilation_();
        this.requiresTranspilation_ = $obj$$.map;
        this.transpilationTarget_ = this.transpilationTarget_ || $obj$$.target;
      }
      if ($lang$$ in this.requiresTranspilation_) {
        return this.requiresTranspilation_[$lang$$]
          ? !0
          : !goog.inHtmlDocument_() ||
            'es6' != $module$$ ||
            'noModule' in goog.global.document.createElement('script')
          ? !1
          : !0;
      }
      throw Error('Unknown language mode: ' + $lang$$);
    }),
    (goog.Transpiler.prototype.transpile = function ($code$$, $path$$) {
      return goog.transpile_($code$$, $path$$, this.transpilationTarget_);
    }),
    (goog.transpiler_ = new goog.Transpiler()),
    (goog.protectScriptTag_ = function ($str$$) {
      return $str$$.replace(/<\/(SCRIPT)/gi, '\\x3c/$1');
    }),
    (goog.DebugLoader_ = function () {
      this.dependencies_ = {};
      this.idToPath_ = {};
      this.written_ = {};
      this.loadingDeps_ = [];
      this.depsToLoad_ = [];
      this.paused_ = !1;
      this.factory_ = new goog.DependencyFactory(goog.transpiler_);
      this.deferredCallbacks_ = {};
      this.deferredQueue_ = [];
    }),
    (goog.DebugLoader_.prototype.bootstrap = function (
      $namespaces$$,
      $callback$$
    ) {
      function $resolve$$() {
        $cb$$ && (goog.global.setTimeout($cb$$, 0), ($cb$$ = null));
      }
      var $cb$$ = $callback$$;
      if ($namespaces$$.length) {
        $callback$$ = [];
        for (var $i$$ = 0; $i$$ < $namespaces$$.length; $i$$++) {
          var $path$$ = this.getPathFromDeps_($namespaces$$[$i$$]);
          if (!$path$$) {
            throw Error('Unregonized namespace: ' + $namespaces$$[$i$$]);
          }
          $callback$$.push(this.dependencies_[$path$$]);
        }
        $path$$ = goog.require;
        var $loaded$$ = 0;
        for ($i$$ = 0; $i$$ < $namespaces$$.length; $i$$++) {
          $path$$($namespaces$$[$i$$]),
            $callback$$[$i$$].onLoad(function () {
              ++$loaded$$ == $namespaces$$.length && $resolve$$();
            });
        }
      } else {
        $resolve$$();
      }
    }),
    (goog.DebugLoader_.prototype.loadClosureDeps = function () {
      this.depsToLoad_.push(
        this.factory_.createDependency(
          goog.normalizePath_(goog.basePath + 'deps.js'),
          'deps.js',
          [],
          [],
          {},
          !1
        )
      );
      this.loadDeps_();
    }),
    (goog.DebugLoader_.prototype.requested = function (
      $absPathOrId_path$$,
      $callback$jscomp$54_opt_force$$
    ) {
      ($absPathOrId_path$$ = this.getPathFromDeps_($absPathOrId_path$$)) &&
        ($callback$jscomp$54_opt_force$$ ||
          this.areDepsLoaded_(
            this.dependencies_[$absPathOrId_path$$].requires
          )) &&
        ($callback$jscomp$54_opt_force$$ =
          this.deferredCallbacks_[$absPathOrId_path$$]) &&
        (delete this.deferredCallbacks_[$absPathOrId_path$$],
        $callback$jscomp$54_opt_force$$());
    }),
    (goog.DebugLoader_.prototype.setDependencyFactory = function ($factory$$) {
      this.factory_ = $factory$$;
    }),
    (goog.DebugLoader_.prototype.load_ = function ($namespace$$) {
      if (this.getPathFromDeps_($namespace$$)) {
        var $loader$$ = this,
          $deps$$ = [],
          $visit$$ = function ($dep_namespace$$) {
            var $i$jscomp$10_path$$ =
              $loader$$.getPathFromDeps_($dep_namespace$$);
            if (!$i$jscomp$10_path$$) {
              throw Error('Bad dependency path or symbol: ' + $dep_namespace$$);
            }
            if (!$loader$$.written_[$i$jscomp$10_path$$]) {
              $loader$$.written_[$i$jscomp$10_path$$] = !0;
              $dep_namespace$$ = $loader$$.dependencies_[$i$jscomp$10_path$$];
              for (
                $i$jscomp$10_path$$ = 0;
                $i$jscomp$10_path$$ < $dep_namespace$$.requires.length;
                $i$jscomp$10_path$$++
              ) {
                goog.isProvided_(
                  $dep_namespace$$.requires[$i$jscomp$10_path$$]
                ) || $visit$$($dep_namespace$$.requires[$i$jscomp$10_path$$]);
              }
              $deps$$.push($dep_namespace$$);
            }
          };
        $visit$$($namespace$$);
        $namespace$$ = !!this.depsToLoad_.length;
        this.depsToLoad_ = this.depsToLoad_.concat($deps$$);
        this.paused_ || $namespace$$ || this.loadDeps_();
      } else {
        goog.logToConsole_('goog.require could not find: ' + $namespace$$);
      }
    }),
    (goog.DebugLoader_.prototype.loadDeps_ = function () {
      for (
        var $loader$$ = this, $paused$$ = this.paused_;
        this.depsToLoad_.length && !$paused$$;

      ) {
        (function () {
          var $loadCallDone$$ = !1,
            $dep$$ = $loader$$.depsToLoad_.shift(),
            $loaded$$ = !1;
          $loader$$.loading_($dep$$);
          var $controller$$ = {
            pause: function () {
              if ($loadCallDone$$) {
                throw Error('Cannot call pause after the call to load.');
              }
              $paused$$ = !0;
            },
            resume: function () {
              $loadCallDone$$ ? $loader$$.resume_() : ($paused$$ = !1);
            },
            loaded: function () {
              if ($loaded$$) {
                throw Error('Double call to loaded.');
              }
              $loaded$$ = !0;
              $loader$$.loaded_($dep$$);
            },
            pending: function () {
              for (
                var $pending$$ = [], $i$$ = 0;
                $i$$ < $loader$$.loadingDeps_.length;
                $i$$++
              ) {
                $pending$$.push($loader$$.loadingDeps_[$i$$]);
              }
              return $pending$$;
            },
            setModuleState: function ($type$$) {
              goog.moduleLoaderState_ = {
                type: $type$$,
                moduleName: '',
                declareLegacyNamespace: !1,
              };
            },
            registerEs6ModuleExports: function (
              $path$$,
              $exports$$,
              $opt_closureNamespace$$
            ) {
              $opt_closureNamespace$$ &&
                (goog.loadedModules_[$opt_closureNamespace$$] = {
                  exports: $exports$$,
                  type: goog.ModuleType.ES6,
                  moduleId: $opt_closureNamespace$$ || '',
                });
            },
            registerGoogModuleExports: function ($moduleId$$, $exports$$) {
              goog.loadedModules_[$moduleId$$] = {
                exports: $exports$$,
                type: goog.ModuleType.GOOG,
                moduleId: $moduleId$$,
              };
            },
            clearModuleState: function () {
              goog.moduleLoaderState_ = null;
            },
            defer: function ($callback$$) {
              if ($loadCallDone$$) {
                throw Error(
                  'Cannot register with defer after the call to load.'
                );
              }
              $loader$$.defer_($dep$$, $callback$$);
            },
            areDepsLoaded: function () {
              return $loader$$.areDepsLoaded_($dep$$.requires);
            },
          };
          try {
            $dep$$.load($controller$$);
          } finally {
            $loadCallDone$$ = !0;
          }
        })();
      }
      $paused$$ && this.pause_();
    }),
    (goog.DebugLoader_.prototype.pause_ = function () {
      this.paused_ = !0;
    }),
    (goog.DebugLoader_.prototype.resume_ = function () {
      this.paused_ && ((this.paused_ = !1), this.loadDeps_());
    }),
    (goog.DebugLoader_.prototype.loading_ = function ($dep$$) {
      this.loadingDeps_.push($dep$$);
    }),
    (goog.DebugLoader_.prototype.loaded_ = function ($dep$$) {
      for (var $i$$ = 0; $i$$ < this.loadingDeps_.length; $i$$++) {
        if (this.loadingDeps_[$i$$] == $dep$$) {
          this.loadingDeps_.splice($i$$, 1);
          break;
        }
      }
      for ($i$$ = 0; $i$$ < this.deferredQueue_.length; $i$$++) {
        if (this.deferredQueue_[$i$$] == $dep$$.path) {
          this.deferredQueue_.splice($i$$, 1);
          break;
        }
      }
      if (
        this.loadingDeps_.length == this.deferredQueue_.length &&
        !this.depsToLoad_.length
      ) {
        for (; this.deferredQueue_.length; ) {
          this.requested(this.deferredQueue_.shift(), !0);
        }
      }
      $dep$$.loaded();
    }),
    (goog.DebugLoader_.prototype.areDepsLoaded_ = function ($pathsOrIds$$) {
      for (var $i$$ = 0; $i$$ < $pathsOrIds$$.length; $i$$++) {
        var $path$$ = this.getPathFromDeps_($pathsOrIds$$[$i$$]);
        if (
          !$path$$ ||
          !(
            $path$$ in this.deferredCallbacks_ ||
            goog.isProvided_($pathsOrIds$$[$i$$])
          )
        ) {
          return !1;
        }
      }
      return !0;
    }),
    (goog.DebugLoader_.prototype.getPathFromDeps_ = function ($absPathOrId$$) {
      return $absPathOrId$$ in this.idToPath_
        ? this.idToPath_[$absPathOrId$$]
        : $absPathOrId$$ in this.dependencies_
        ? $absPathOrId$$
        : null;
    }),
    (goog.DebugLoader_.prototype.defer_ = function (
      $dependency$$,
      $callback$$
    ) {
      this.deferredCallbacks_[$dependency$$.path] = $callback$$;
      this.deferredQueue_.push($dependency$$.path);
    }),
    (goog.LoadController = function () {}),
    (goog.LoadController.prototype.pause = function () {}),
    (goog.LoadController.prototype.resume = function () {}),
    (goog.LoadController.prototype.loaded = function () {}),
    (goog.LoadController.prototype.pending = function () {}),
    (goog.LoadController.prototype.registerEs6ModuleExports = function (
      $path$$,
      $exports$$,
      $opt_closureNamespace$$
    ) {}),
    (goog.LoadController.prototype.setModuleState = function ($type$$) {}),
    (goog.LoadController.prototype.clearModuleState = function () {}),
    (goog.LoadController.prototype.defer = function ($callback$$) {}),
    (goog.LoadController.prototype.areDepsLoaded = function () {}),
    (goog.Dependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$
    ) {
      this.path = $path$$;
      this.relativePath = $relativePath$$;
      this.provides = $provides$$;
      this.requires = $requires$$;
      this.loadFlags = $loadFlags$$;
      this.loaded_ = !1;
      this.loadCallbacks_ = [];
    }),
    (goog.Dependency.prototype.getPathName = function () {
      var $pathName$$ = this.path,
        $protocolIndex_slashIndex$$ = $pathName$$.indexOf('://');
      0 <= $protocolIndex_slashIndex$$ &&
        (($pathName$$ = $pathName$$.substring($protocolIndex_slashIndex$$ + 3)),
        ($protocolIndex_slashIndex$$ = $pathName$$.indexOf('/')),
        0 <= $protocolIndex_slashIndex$$ &&
          ($pathName$$ = $pathName$$.substring(
            $protocolIndex_slashIndex$$ + 1
          )));
      return $pathName$$;
    }),
    (goog.Dependency.prototype.onLoad = function ($callback$$) {
      this.loaded_ ? $callback$$() : this.loadCallbacks_.push($callback$$);
    }),
    (goog.Dependency.prototype.loaded = function () {
      this.loaded_ = !0;
      var $callbacks$$ = this.loadCallbacks_;
      this.loadCallbacks_ = [];
      for (var $i$$ = 0; $i$$ < $callbacks$$.length; $i$$++) {
        $callbacks$$[$i$$]();
      }
    }),
    (goog.Dependency.defer_ = !1),
    (goog.Dependency.callbackMap_ = {}),
    (goog.Dependency.registerCallback_ = function ($callback$$) {
      var $key$$ = Math.random().toString(32);
      goog.Dependency.callbackMap_[$key$$] = $callback$$;
      return $key$$;
    }),
    (goog.Dependency.unregisterCallback_ = function ($key$$) {
      delete goog.Dependency.callbackMap_[$key$$];
    }),
    (goog.Dependency.callback_ = function ($key$$, $var_args$$) {
      if ($key$$ in goog.Dependency.callbackMap_) {
        for (
          var $callback$$ = goog.Dependency.callbackMap_[$key$$],
            $args$$ = [],
            $i$$ = 1;
          $i$$ < arguments.length;
          $i$$++
        ) {
          $args$$.push(arguments[$i$$]);
        }
        $callback$$.apply(void 0, $args$$);
      } else {
        throw Error(
          'Callback key ' +
            $key$$ +
            ' does not exist (was base.js loaded more than once?).'
        );
      }
    }),
    (goog.Dependency.prototype.load = function ($controller$$) {
      if (goog.global.CLOSURE_IMPORT_SCRIPT) {
        goog.global.CLOSURE_IMPORT_SCRIPT(this.path)
          ? $controller$$.loaded()
          : $controller$$.pause();
      } else {
        if (goog.inHtmlDocument_()) {
          var $doc$$ = goog.global.document;
          if (
            'complete' == $doc$$.readyState &&
            !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING
          ) {
            if (/\bdeps.js$/.test(this.path)) {
              $controller$$.loaded();
              return;
            }
            throw Error('Cannot write "' + this.path + '" after document load');
          }
          var $nonce$$ = goog.getScriptNonce();
          if (
            !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING &&
            goog.isDocumentLoading_()
          ) {
            var $callback$$ = function ($script$$) {
              $script$$.readyState && 'complete' != $script$$.readyState
                ? ($script$$.onload = $callback$$)
                : (goog.Dependency.unregisterCallback_($key$$),
                  $controller$$.loaded());
            };
            var $key$$ = goog.Dependency.registerCallback_($callback$$);
            $nonce$$ = $nonce$$ ? ' nonce="' + $nonce$$ + '"' : '';
            var $script$jscomp$0$$ =
              '<script src="' +
              this.path +
              '"' +
              $nonce$$ +
              (goog.Dependency.defer_ ? ' defer' : '') +
              ' id="script-' +
              $key$$ +
              '">\x3c/script>';
            $script$jscomp$0$$ += '<script' + $nonce$$ + '>';
            $script$jscomp$0$$ = goog.Dependency.defer_
              ? $script$jscomp$0$$ +
                ("document.getElementById('script-" +
                  $key$$ +
                  "').onload = function() {\n  goog.Dependency.callback_('" +
                  $key$$ +
                  "', this);\n};\n")
              : $script$jscomp$0$$ +
                ("goog.Dependency.callback_('" +
                  $key$$ +
                  "', document.getElementById('script-" +
                  $key$$ +
                  "'));");
            $script$jscomp$0$$ += '\x3c/script>';
            $doc$$.write(
              goog.TRUSTED_TYPES_POLICY_
                ? goog.TRUSTED_TYPES_POLICY_.createHTML($script$jscomp$0$$)
                : $script$jscomp$0$$
            );
          } else {
            var $scriptEl$$ = $doc$$.createElement('script');
            $scriptEl$$.defer = goog.Dependency.defer_;
            $scriptEl$$.async = !1;
            $nonce$$ && ($scriptEl$$.nonce = $nonce$$);
            goog.DebugLoader_.IS_OLD_IE_
              ? ($controller$$.pause(),
                ($scriptEl$$.onreadystatechange = function () {
                  if (
                    'loaded' == $scriptEl$$.readyState ||
                    'complete' == $scriptEl$$.readyState
                  ) {
                    $controller$$.loaded(), $controller$$.resume();
                  }
                }))
              : ($scriptEl$$.onload = function () {
                  $scriptEl$$.onload = null;
                  $controller$$.loaded();
                });
            $scriptEl$$.src = goog.TRUSTED_TYPES_POLICY_
              ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path)
              : this.path;
            $doc$$.head.appendChild($scriptEl$$);
          }
        } else {
          goog.logToConsole_(
            'Cannot use default debug loader outside of HTML documents.'
          ),
            'deps.js' == this.relativePath
              ? (goog.logToConsole_(
                  'Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true.'
                ),
                $controller$$.loaded())
              : $controller$$.pause();
        }
      }
    }),
    (goog.Es6ModuleDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$
    ) {
      goog.Dependency.call(
        this,
        $path$$,
        $relativePath$$,
        $provides$$,
        $requires$$,
        $loadFlags$$
      );
    }),
    goog.inherits(goog.Es6ModuleDependency, goog.Dependency),
    (goog.Es6ModuleDependency.prototype.load = function ($controller$$) {
      function $write$$($script$jscomp$5_src$$, $contents$$) {
        var $nonceAttr$$ = '',
          $nonce$$ = goog.getScriptNonce();
        $nonce$$ && ($nonceAttr$$ = ' nonce="' + $nonce$$ + '"');
        $script$jscomp$5_src$$ = $contents$$
          ? '<script type="module" crossorigin' +
            $nonceAttr$$ +
            '>' +
            $contents$$ +
            '\x3c/script>'
          : '<script type="module" crossorigin src="' +
            $script$jscomp$5_src$$ +
            '"' +
            $nonceAttr$$ +
            '>\x3c/script>';
        $doc$$.write(
          goog.TRUSTED_TYPES_POLICY_
            ? goog.TRUSTED_TYPES_POLICY_.createHTML($script$jscomp$5_src$$)
            : $script$jscomp$5_src$$
        );
      }
      function $append$$($src$$, $contents$$) {
        var $scriptEl$$ = $doc$$.createElement('script');
        $scriptEl$$.defer = !0;
        $scriptEl$$.async = !1;
        $scriptEl$$.type = 'module';
        $scriptEl$$.setAttribute('crossorigin', !0);
        var $nonce$$ = goog.getScriptNonce();
        $nonce$$ && ($scriptEl$$.nonce = $nonce$$);
        $contents$$
          ? ($scriptEl$$.text = goog.TRUSTED_TYPES_POLICY_
              ? goog.TRUSTED_TYPES_POLICY_.createScript($contents$$)
              : $contents$$)
          : ($scriptEl$$.src = goog.TRUSTED_TYPES_POLICY_
              ? goog.TRUSTED_TYPES_POLICY_.createScriptURL($src$$)
              : $src$$);
        $doc$$.head.appendChild($scriptEl$$);
      }
      if (goog.global.CLOSURE_IMPORT_SCRIPT) {
        goog.global.CLOSURE_IMPORT_SCRIPT(this.path)
          ? $controller$$.loaded()
          : $controller$$.pause();
      } else {
        if (goog.inHtmlDocument_()) {
          var $doc$$ = goog.global.document,
            $dep$$ = this;
          if (goog.isDocumentLoading_()) {
            var $create$$ = $write$$;
            goog.Dependency.defer_ = !0;
          } else {
            $create$$ = $append$$;
          }
          var $beforeKey$$ = goog.Dependency.registerCallback_(function () {
            goog.Dependency.unregisterCallback_($beforeKey$$);
            $controller$$.setModuleState(goog.ModuleType.ES6);
          });
          $create$$(
            void 0,
            'goog.Dependency.callback_("' + $beforeKey$$ + '")'
          );
          $create$$(this.path, void 0);
          var $registerKey$$ = goog.Dependency.registerCallback_(function (
            $exports$$
          ) {
            goog.Dependency.unregisterCallback_($registerKey$$);
            $controller$$.registerEs6ModuleExports(
              $dep$$.path,
              $exports$$,
              goog.moduleLoaderState_.moduleName
            );
          });
          $create$$(
            void 0,
            'import * as m from "' +
              this.path +
              '"; goog.Dependency.callback_("' +
              $registerKey$$ +
              '", m)'
          );
          var $afterKey$$ = goog.Dependency.registerCallback_(function () {
            goog.Dependency.unregisterCallback_($afterKey$$);
            $controller$$.clearModuleState();
            $controller$$.loaded();
          });
          $create$$(void 0, 'goog.Dependency.callback_("' + $afterKey$$ + '")');
        } else {
          goog.logToConsole_(
            'Cannot use default debug loader outside of HTML documents.'
          ),
            $controller$$.pause();
        }
      }
    }),
    (goog.TransformedDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$
    ) {
      goog.Dependency.call(
        this,
        $path$$,
        $relativePath$$,
        $provides$$,
        $requires$$,
        $loadFlags$$
      );
      this.contents_ = null;
      this.lazyFetch_ =
        !goog.inHtmlDocument_() ||
        !('noModule' in goog.global.document.createElement('script'));
    }),
    goog.inherits(goog.TransformedDependency, goog.Dependency),
    (goog.TransformedDependency.prototype.load = function ($controller$$) {
      function $fetch$$() {
        $dep$$.contents_ = goog.loadFileSync_($dep$$.path);
        $dep$$.contents_ &&
          (($dep$$.contents_ = $dep$$.transform($dep$$.contents_)),
          $dep$$.contents_ &&
            ($dep$$.contents_ += '\n//# sourceURL=' + $dep$$.path));
      }
      function $load$$() {
        $dep$$.lazyFetch_ && $fetch$$();
        if ($dep$$.contents_) {
          $isEs6$$ && $controller$$.setModuleState(goog.ModuleType.ES6);
          try {
            var $contents$$ = $dep$$.contents_;
            $dep$$.contents_ = null;
            goog.globalEval($contents$$);
            if ($isEs6$$) {
              var $namespace$$ = goog.moduleLoaderState_.moduleName;
            }
          } finally {
            $isEs6$$ && $controller$$.clearModuleState();
          }
          $isEs6$$ &&
            goog.global.$jscomp.require.ensure(
              [$dep$$.getPathName()],
              function () {
                $controller$$.registerEs6ModuleExports(
                  $dep$$.path,
                  goog.global.$jscomp.require($dep$$.getPathName()),
                  $namespace$$
                );
              }
            );
          $controller$$.loaded();
        }
      }
      function $fetchInOwnScriptThenLoad$$() {
        var $doc$$ = goog.global.document,
          $key$$ = goog.Dependency.registerCallback_(function () {
            goog.Dependency.unregisterCallback_($key$$);
            $load$$();
          }),
          $nonce$jscomp$4_script$$ = goog.getScriptNonce();
        $nonce$jscomp$4_script$$ =
          '<script' +
          ($nonce$jscomp$4_script$$
            ? ' nonce="' + $nonce$jscomp$4_script$$ + '"'
            : '') +
          '>' +
          goog.protectScriptTag_(
            'goog.Dependency.callback_("' + $key$$ + '");'
          ) +
          '\x3c/script>';
        $doc$$.write(
          goog.TRUSTED_TYPES_POLICY_
            ? goog.TRUSTED_TYPES_POLICY_.createHTML($nonce$jscomp$4_script$$)
            : $nonce$jscomp$4_script$$
        );
      }
      var $dep$$ = this;
      if (goog.global.CLOSURE_IMPORT_SCRIPT) {
        $fetch$$(),
          this.contents_ &&
          goog.global.CLOSURE_IMPORT_SCRIPT('', this.contents_)
            ? ((this.contents_ = null), $controller$$.loaded())
            : $controller$$.pause();
      } else {
        var $isEs6$$ = this.loadFlags.module == goog.ModuleType.ES6;
        this.lazyFetch_ || $fetch$$();
        var $anythingElsePending_needsAsyncLoading$$ =
            1 < $controller$$.pending().length,
          $isInternetExplorer_useOldIeWorkAround$$ =
            $anythingElsePending_needsAsyncLoading$$ &&
            goog.DebugLoader_.IS_OLD_IE_;
        $anythingElsePending_needsAsyncLoading$$ =
          goog.Dependency.defer_ &&
          ($anythingElsePending_needsAsyncLoading$$ ||
            goog.isDocumentLoading_());
        if (
          $isInternetExplorer_useOldIeWorkAround$$ ||
          $anythingElsePending_needsAsyncLoading$$
        ) {
          $controller$$.defer(function () {
            $load$$();
          });
        } else {
          var $doc$jscomp$0$$ = goog.global.document;
          $isInternetExplorer_useOldIeWorkAround$$ =
            goog.inHtmlDocument_() && 'ActiveXObject' in goog.global;
          if (
            $isEs6$$ &&
            goog.inHtmlDocument_() &&
            goog.isDocumentLoading_() &&
            !$isInternetExplorer_useOldIeWorkAround$$
          ) {
            goog.Dependency.defer_ = !0;
            $controller$$.pause();
            var $oldCallback$$ = $doc$jscomp$0$$.onreadystatechange;
            $doc$jscomp$0$$.onreadystatechange = function () {
              'interactive' == $doc$jscomp$0$$.readyState &&
                (($doc$jscomp$0$$.onreadystatechange = $oldCallback$$),
                $load$$(),
                $controller$$.resume());
              'function' === typeof $oldCallback$$ &&
                $oldCallback$$.apply(void 0, arguments);
            };
          } else {
            !goog.DebugLoader_.IS_OLD_IE_ &&
            goog.inHtmlDocument_() &&
            goog.isDocumentLoading_()
              ? $fetchInOwnScriptThenLoad$$()
              : $load$$();
          }
        }
      }
    }),
    (goog.TransformedDependency.prototype.transform = function (
      $contents$$
    ) {}),
    (goog.TranspiledDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$,
      $transpiler$$
    ) {
      goog.TransformedDependency.call(
        this,
        $path$$,
        $relativePath$$,
        $provides$$,
        $requires$$,
        $loadFlags$$
      );
      this.transpiler = $transpiler$$;
    }),
    goog.inherits(goog.TranspiledDependency, goog.TransformedDependency),
    (goog.TranspiledDependency.prototype.transform = function ($contents$$) {
      return this.transpiler.transpile($contents$$, this.getPathName());
    }),
    (goog.PreTranspiledEs6ModuleDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$
    ) {
      goog.TransformedDependency.call(
        this,
        $path$$,
        $relativePath$$,
        $provides$$,
        $requires$$,
        $loadFlags$$
      );
    }),
    goog.inherits(
      goog.PreTranspiledEs6ModuleDependency,
      goog.TransformedDependency
    ),
    (goog.PreTranspiledEs6ModuleDependency.prototype.transform = function (
      $contents$$
    ) {
      return $contents$$;
    }),
    (goog.GoogModuleDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$,
      $needsTranspile$$,
      $transpiler$$
    ) {
      goog.TransformedDependency.call(
        this,
        $path$$,
        $relativePath$$,
        $provides$$,
        $requires$$,
        $loadFlags$$
      );
      this.needsTranspile_ = $needsTranspile$$;
      this.transpiler_ = $transpiler$$;
    }),
    goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency),
    (goog.GoogModuleDependency.prototype.transform = function ($contents$$) {
      this.needsTranspile_ &&
        ($contents$$ = this.transpiler_.transpile(
          $contents$$,
          this.getPathName()
        ));
      return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON
        ? 'goog.loadModule(' +
            goog.global.JSON.stringify(
              $contents$$ + '\n//# sourceURL=' + this.path + '\n'
            ) +
            ');'
        : 'goog.loadModule(function(exports) {"use strict";' +
            $contents$$ +
            '\n;return exports});\n//# sourceURL=' +
            this.path +
            '\n';
    }),
    (goog.DebugLoader_.IS_OLD_IE_ = !(
      goog.global.atob ||
      !goog.global.document ||
      !goog.global.document.all
    )),
    (goog.DebugLoader_.prototype.addDependency = function (
      $relPath$$,
      $provides$$,
      $dep$jscomp$6_i$jscomp$16_requires$$,
      $opt_loadFlags$$
    ) {
      $provides$$ = $provides$$ || [];
      $relPath$$ = $relPath$$.replace(/\\/g, '/');
      var $path$$ = goog.normalizePath_(goog.basePath + $relPath$$);
      ($opt_loadFlags$$ && 'boolean' !== typeof $opt_loadFlags$$) ||
        ($opt_loadFlags$$ = $opt_loadFlags$$
          ? { module: goog.ModuleType.GOOG }
          : {});
      $dep$jscomp$6_i$jscomp$16_requires$$ = this.factory_.createDependency(
        $path$$,
        $relPath$$,
        $provides$$,
        $dep$jscomp$6_i$jscomp$16_requires$$,
        $opt_loadFlags$$,
        goog.transpiler_.needsTranspile(
          $opt_loadFlags$$.lang || 'es3',
          $opt_loadFlags$$.module
        )
      );
      this.dependencies_[$path$$] = $dep$jscomp$6_i$jscomp$16_requires$$;
      for (
        $dep$jscomp$6_i$jscomp$16_requires$$ = 0;
        $dep$jscomp$6_i$jscomp$16_requires$$ < $provides$$.length;
        $dep$jscomp$6_i$jscomp$16_requires$$++
      ) {
        this.idToPath_[$provides$$[$dep$jscomp$6_i$jscomp$16_requires$$]] =
          $path$$;
      }
      this.idToPath_[$relPath$$] = $path$$;
    }),
    (goog.DependencyFactory = function ($transpiler$$) {
      this.transpiler = $transpiler$$;
    }),
    (goog.DependencyFactory.prototype.createDependency = function (
      $path$$,
      $relativePath$$,
      $provides$$,
      $requires$$,
      $loadFlags$$,
      $needsTranspile$$
    ) {
      return $loadFlags$$.module == goog.ModuleType.GOOG
        ? new goog.GoogModuleDependency(
            $path$$,
            $relativePath$$,
            $provides$$,
            $requires$$,
            $loadFlags$$,
            $needsTranspile$$,
            this.transpiler
          )
        : $needsTranspile$$
        ? new goog.TranspiledDependency(
            $path$$,
            $relativePath$$,
            $provides$$,
            $requires$$,
            $loadFlags$$,
            this.transpiler
          )
        : $loadFlags$$.module == goog.ModuleType.ES6
        ? 'never' == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED
          ? new goog.PreTranspiledEs6ModuleDependency(
              $path$$,
              $relativePath$$,
              $provides$$,
              $requires$$,
              $loadFlags$$
            )
          : new goog.Es6ModuleDependency(
              $path$$,
              $relativePath$$,
              $provides$$,
              $requires$$,
              $loadFlags$$
            )
        : new goog.Dependency(
            $path$$,
            $relativePath$$,
            $provides$$,
            $requires$$,
            $loadFlags$$
          );
    }),
    (goog.debugLoader_ = new goog.DebugLoader_()),
    (goog.loadClosureDeps = function () {
      goog.debugLoader_.loadClosureDeps();
    }),
    (goog.setDependencyFactory = function ($factory$$) {
      goog.debugLoader_.setDependencyFactory($factory$$);
    }),
    (goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME
      ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + '#base')
      : null),
    goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(),
    (goog.bootstrap = function ($namespaces$$, $callback$$) {
      goog.debugLoader_.bootstrap($namespaces$$, $callback$$);
    }));
  goog.TRUSTED_TYPES_POLICY_NAME = 'goog';
  goog.identity_ = function ($s$$) {
    return $s$$;
  };
  goog.createTrustedTypesPolicy = function ($name$$) {
    var $policy$$ = null,
      $policyFactory$$ = goog.global.trustedTypes;
    if (!$policyFactory$$ || !$policyFactory$$.createPolicy) {
      return $policy$$;
    }
    try {
      $policy$$ = $policyFactory$$.createPolicy($name$$, {
        createHTML: goog.identity_,
        createScript: goog.identity_,
        createScriptURL: goog.identity_,
      });
    } catch ($e$$) {
      goog.logToConsole_($e$$.message);
    }
    return $policy$$;
  };
  if (!COMPILED) {
    var isNotChrome87 = !1;
    try {
      isNotChrome87 =
        eval(goog.global.trustedTypes.emptyScript) !==
        goog.global.trustedTypes.emptyScript;
    } catch ($err$$) {}
    goog.CLOSURE_EVAL_PREFILTER_ = (goog.global.trustedTypes &&
      isNotChrome87 &&
      goog.createTrustedTypesPolicy('goog#base#devonly#eval')) || {
      createScript: goog.identity_,
    };
  } /*
 Copyright 2022 Glance Networks, Inc.
*/
  var MINIMIZED = !1,
    CONFIG = 'debug',
    GLANCE_VERSION = '6.3.0.2',
    GCommon = { Defs: {} };
  GCommon.Defs.Version = GLANCE_VERSION.split('.').slice(0, 3).join('.');
  GCommon.Defs.Config = CONFIG;
  GCommon.Type = {};
  GCommon.Domain = {};
  GCommon.Domain.set = function () {
    document.domain = window.location.host.split('.').splice(-2).join('.');
  };
  GCommon.Domain.match = function ($origin$$, $domain$$) {
    return null !== $origin$$.match(new RegExp('\\.' + $domain$$ + '$', 'i'));
  };
  GCommon.Domain.getGlanceDomain = function () {
    return document.domain.split('.').splice(-2).join('.');
  };
  GCommon.Geometry = {};
  GCommon.Geometry.Rect = function ($rect$$) {
    this.top = $rect$$.top;
    this.left = $rect$$.left;
    this.right = $rect$$.right;
    this.bottom = $rect$$.bottom;
  };
  GCommon.Geometry.Rect.prototype.Union = function ($rect$$) {
    this.left = Math.min(this.left, $rect$$.left);
    this.top = Math.min(this.top, $rect$$.top);
    this.right = Math.max(this.right, $rect$$.right);
    this.bottom = Math.max(this.bottom, $rect$$.bottom);
  };
  GCommon.Geometry.Rect.prototype.width = function () {
    return this.right - this.left;
  };
  GCommon.Geometry.Rect.prototype.height = function () {
    return this.bottom - this.top;
  };
  GCommon.Time = {};
  GCommon.Time.UTCNow = function () {
    var $now$$ = new Date();
    return (
      $now$$.getUTCFullYear() +
      '/' +
      ($now$$.getUTCMonth() + 1) +
      '/' +
      $now$$.getUTCDate() +
      ' ' +
      GCommon.String.zeropad($now$$.getUTCHours(), 2) +
      ':' +
      GCommon.String.zeropad($now$$.getUTCMinutes(), 2) +
      ':' +
      GCommon.String.zeropad($now$$.getUTCSeconds(), 2)
    );
  };
  GCommon.Time.Timer = function () {
    this.set();
  };
  GCommon.Time.Timer.prototype.elapsed = function ($reset$$) {
    var $now$$ = new Date().getTime(),
      $elapsed$$ = $now$$ - this.t;
    $reset$$ && (this.t = $now$$);
    return $elapsed$$;
  };
  GCommon.Time.Timer.prototype.set = function () {
    this.t = new Date().getTime();
  };
  GCommon.String = {};
  GCommon.String.zeropad = function ($num$jscomp$6_s$$, $len$$) {
    for (
      $num$jscomp$6_s$$ = $num$jscomp$6_s$$.toString();
      $num$jscomp$6_s$$.length < $len$$;

    ) {
      $num$jscomp$6_s$$ = '0' + $num$jscomp$6_s$$;
    }
    return $num$jscomp$6_s$$;
  };
  GCommon.String.queryStringParam = function ($results_url$$, $param$$) {
    $results_url$$ = new RegExp('[\\?&]' + $param$$ + '=([^&#]*)').exec(
      $results_url$$
    );
    return null === $results_url$$ ? '' : $results_url$$[1];
  };
  GCommon.String.queryString = function ($params$$) {
    var $querystring$$ = [];
    Object.keys($params$$).forEach(function ($key$$) {
      $querystring$$.push($key$$ + '=' + $params$$[$key$$]);
    });
    return $querystring$$.join('&');
  };
  GCommon.Url = window.URL || window.webkitURL;
  Uint8Array.prototype.slice ||
    (Uint8Array.prototype.slice = function ($begin$$, $end$$) {
      return new Uint8Array(this.subarray($begin$$, $end$$));
    });
  ArrayBuffer.prototype.slice ||
    (ArrayBuffer.prototype.slice = function ($begin$$, $end$$) {
      void 0 === $begin$$ && ($begin$$ = 0);
      void 0 === $end$$ && ($end$$ = this.byteLength);
      $begin$$ = Math.floor($begin$$);
      $end$$ = Math.floor($end$$);
      0 > $begin$$ && ($begin$$ += this.byteLength);
      0 > $end$$ && ($end$$ += this.byteLength);
      $begin$$ = Math.min(Math.max(0, $begin$$), this.byteLength);
      $end$$ = Math.min(Math.max(0, $end$$), this.byteLength);
      if (0 >= $end$$ - $begin$$) {
        return new ArrayBuffer(0);
      }
      var $result$$ = new ArrayBuffer($end$$ - $begin$$),
        $resultBytes$$ = new Uint8Array($result$$);
      $begin$$ = new Uint8Array(this, $begin$$, $end$$ - $begin$$);
      $resultBytes$$.set($begin$$);
      return $result$$;
    });
  GCommon.Browser = (function () {
    var $ua$$ = navigator.userAgent.toLowerCase(),
      $platform$$ = navigator.platform.toLowerCase(),
      $UA$$ = $ua$$.match(/(edge)[\s\/:]([\w\d\.]+)?/) ||
        $ua$$.match(
          /(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/
        ) ||
        $ua$$.match(/(rv):([\w\d\.]+)/) || [null, 'unknown', 0];
    'rv' === $UA$$[1] && ($UA$$[1] = 'ie');
    return {
      name: 'version' === $UA$$[1] ? $UA$$[3] : $UA$$[1],
      version:
        ('ie' === $UA$$[1] && document.documentMode) ||
        parseFloat('opera' === $UA$$[1] && $UA$$[4] ? $UA$$[4] : $UA$$[2]),
      platform: $ua$$.match(/ip(?:ad|od|hone)/)
        ? 'ios'
        : ($ua$$.match(/(?:webos|android)/) ||
            $platform$$.match(/mac|win|linux/) || ['other'])[0],
    };
  })();
  GCommon.Elem = {};
  GCommon.Elem.makeUnselectable = function ($elem$$) {
    $elem$$.on('selectstart dragstart', function ($evt$$) {
      $evt$$.preventDefault();
      return !1;
    });
  };
  var EVENTSLOG = 'Debug' === GCommon.Defs.Config && !1,
    MSGLOG = 'Debug' === GCommon.Defs.Config && !1,
    COMMLOG = 'Debug' === GCommon.Defs.Config && !1,
    PAINTLOG = 'Debug' === GCommon.Defs.Config && !1,
    INFOLOG = 'Debug' === GCommon.Defs.Config && !0,
    FRAMELOG = 'Debug' === GCommon.Defs.Config && !1,
    DRAWLOG = 'Debug' === GCommon.Defs.Config && !1,
    RCLOG = 'Debug' === GCommon.Defs.Config && !1,
    STATSLOG = !1;
  GCommon.Log = {};
  GCommon.Log.logstring = function ($loginfo$$) {
    for (var $s$$ = '', $i$$ = 0; $i$$ < $loginfo$$.length; $i$$++) {
      $s$$ +=
        ('object' === typeof $loginfo$$[$i$$]
          ? JSON.stringify($loginfo$$[$i$$])
          : $loginfo$$[$i$$]) + ' ';
    }
    return $s$$
      .replace(/[\r\n]/g, ' ')
      .replace('<', '&lt;')
      .replace('>', '&gt;');
  };
  GCommon.Log.log = function ($var_args$$) {
    window.console &&
      window.console.log &&
      (window.GLANCE_COBROWSE ? !window.GLANCE_COBROWSE.disableLogging : 1) &&
      window.console.log(GCommon.Log.logstring(arguments));
  };
  GCommon.Log.error = function ($var_args$$) {
    window.console &&
      window.console.error &&
      window.console.error(GCommon.Log.logstring(arguments));
  };
  'Debug' === GCommon.Defs.Config &&
    (GCommon.Log.debuglog = function ($cat$$, $arr$$) {
      $arr$$ = Array.prototype.slice.call($arr$$);
      $arr$$.unshift($cat$$);
      window.console &&
        window.console.log &&
        window.console.log(GCommon.Log.logstring($arr$$));
    });
  GCommon.Log.msglog = MSGLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('MSG:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.commlog = COMMLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('COMM:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.paintlog = PAINTLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('PAINT:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.eventslog = EVENTSLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('EVENTS:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.infolog = INFOLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('INFO:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.framelog = FRAMELOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('FRAME:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.drawlog = DRAWLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('DRAW:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.rclog = RCLOG
    ? function ($var_args$$) {
        GCommon.Log.debuglog('RCLOG:', arguments);
      }
    : function ($var_args$$) {};
  GCommon.Log.statslog = STATSLOG
    ? function ($var_args$$) {
        GCommon.Log.log(arguments);
      }
    : function ($var_args$$) {};
  GCommon.Diags = {};
  GCommon.Diags.blobToString = function ($blob$$) {
    return new Promise(function ($resolve$$, $fileReader_reject$$) {
      $fileReader_reject$$ = new FileReader();
      $fileReader_reject$$.onload = function () {
        var $array$$ = new Uint8Array(this.result);
        $resolve$$($array$$.toString());
      };
      $fileReader_reject$$.readAsArrayBuffer($blob$$);
    });
  };
  GCommon.assert =
    'Debug' === GCommon.Defs.Config
      ? function ($b$$) {
          if (!$b$$) {
            throw Error('assert failed');
          }
        }
      : function ($b$$) {};
  GCommon.Stats = {};
  GCommon.Stats.tracker = function (
    $intervalsecs$$,
    $logfunc$$,
    $notifyfunc$$
  ) {
    this.stats = {};
    this.statcounts = {};
    this.stattypes = {};
    this.interval = $intervalsecs$$;
    this.logfunc = $logfunc$$;
    this.notifyfunc = $notifyfunc$$;
    var $self$$ = this;
    0 < $intervalsecs$$ &&
      window.setInterval(function () {
        $self$$.report();
      }, 1000 * $intervalsecs$$);
  };
  GCommon.Stats.tracker.statType = {
    STAT_AVERAGE: 0,
    STAT_PERSEC: 1,
    STAT_TOTAL: 2,
  };
  GCommon.Stats.tracker.prototype.track = function (
    $stat$$,
    $count$$,
    $type$$
  ) {
    this.stattypes[$stat$$] = $type$$;
    this.stats[$stat$$] = this.stats[$stat$$] || 0;
    this.stats[$stat$$] += $count$$;
    this.statcounts[$stat$$] = (this.statcounts[$stat$$] || 0) + 1;
  };
  GCommon.Stats.tracker.prototype.report = function () {
    this.notifyfunc && this.notifyfunc();
    if (this.logfunc) {
      for (var $stat$$ in this.stats) {
        switch (this.stattypes[$stat$$]) {
          case GCommon.Stats.tracker.statType.STAT_AVERAGE:
            this.logfunc(
              Math.round(
                (this.stats[$stat$$] / this.statcounts[$stat$$]) * 100
              ) / 100,
              'average',
              $stat$$
            );
            break;
          case GCommon.Stats.tracker.statType.STAT_PERSEC:
            this.logfunc(
              Math.round((this.stats[$stat$$] / this.interval) * 100) / 100,
              $stat$$ + '/sec'
            );
            break;
          case GCommon.Stats.tracker.statType.STAT_TOTAL:
            this.logfunc(Math.round(100 * this.stats[$stat$$]) / 100, $stat$$);
        }
      }
    }
    this.stats = {};
    this.statcounts = {};
  };
  GCommon.EventListeners = function () {
    this._listeners = {};
  };
  GCommon.EventListeners.prototype.add = function ($evtname$$, $listener$$) {
    this._listeners[$evtname$$] ||
      ((this._listeners[$evtname$$] = this._listeners[$evtname$$] || []),
      this._listeners[$evtname$$].push($listener$$));
  };
  GCommon.EventListeners.prototype.remove = function (
    $evtname$jscomp$1_l$$,
    $listener$jscomp$67_n$$
  ) {
    $evtname$jscomp$1_l$$ = this._listeners[$evtname$jscomp$1_l$$];
    void 0 !== $evtname$jscomp$1_l$$ &&
      (($listener$jscomp$67_n$$ = $evtname$jscomp$1_l$$.indexOf(
        $listener$jscomp$67_n$$
      )),
      0 <= $listener$jscomp$67_n$$ &&
        $evtname$jscomp$1_l$$.splice($listener$jscomp$67_n$$, 1));
  };
  GCommon.EventListeners.prototype.fire = function (
    $evtname$jscomp$2_n$$,
    $obj$$
  ) {
    GCommon.Log.eventslog(
      'fire ',
      $evtname$jscomp$2_n$$,
      ' ',
      $obj$$ ? JSON.stringify($obj$$) : ''
    );
    var $l$$ = this._listeners[$evtname$jscomp$2_n$$],
      $ret$$ = !0;
    if (void 0 === $l$$) {
      return !0;
    }
    for (
      $evtname$jscomp$2_n$$ = 0;
      $evtname$jscomp$2_n$$ < $l$$.length;
      $evtname$jscomp$2_n$$++
    ) {
      $l$$[$evtname$jscomp$2_n$$]($obj$$) || ($ret$$ = !1);
    }
    return $ret$$;
  };
  var GLANCE_LOGGER = !0,
    GlanceLogger = {
      sanitize: function ($s$$) {
        return $s$$.replace(/[\r\n]/g, ' ').replace('<', '&lt;');
      },
      _log: function ($fn$$, ...$args$$) {
        !window.console ||
          !window.console[$fn$$] ||
          (window.GLANCE_COBROWSE && window.GLANCE_COBROWSE.disableLogging) ||
          (($args$$ = $args$$.map(($value$$) => {
            if ('object' === typeof $value$$) {
              try {
                $value$$ = JSON.stringify($value$$);
              } catch ($e$$) {
                console.error($e$$),
                  ($value$$ = 'unable to convert object to string');
              }
            }
            return 'string' === typeof $value$$
              ? GlanceLogger.sanitize($value$$)
              : $value$$;
          })),
          window.console[$fn$$](...$args$$));
      },
      log: function (...$args$$) {
        GlanceLogger._log('log', ...$args$$);
      },
      error: function (...$args$$) {
        GlanceLogger._log('error', ...$args$$);
      },
    },
    LOG_DIFFS = !1,
    LOG_DIFFDET = !1,
    LOG_DRAW = !1,
    LOG_PRES = !0,
    LOG_CBSTATE = !1,
    LOG_IFRAME = !1,
    LOG_SCROLL = !1,
    LOG_EVENTS = !1,
    LOG_LOADER = !1,
    LOG_UI = !1,
    LOG_FOCUS = !1,
    LOG_XDOM = !0,
    LOG_C3P = !1,
    LOG_PDF = !1,
    LOG_STYLES = !1,
    LOG_GEST = !1,
    LOG_MSG = !1,
    LOG_RES = !0,
    LOG_RC = !1,
    LOG_SD = !1,
    LOG_VID = !0,
    LOG_MASK = !1,
    LOG_DOC = !1,
    LOG_XLS = !1,
    LOG_SS = !1,
    debuglog = GLANCE_LOGGER
      ? function (...$args$$) {
          GlanceLogger.log('DEBUG:', ...$args$$);
        }
      : function () {},
    diffslog =
      GLANCE_LOGGER && LOG_DIFFS
        ? function (...$args$$) {
            GlanceLogger.log('DIFFS:', ...$args$$);
          }
        : function () {},
    diffdetlog =
      GLANCE_LOGGER && LOG_DIFFDET
        ? function (...$args$$) {
            GlanceLogger.log('DIFFDET:', ...$args$$);
          }
        : function () {},
    drawlog =
      GLANCE_LOGGER && LOG_DRAW
        ? function (...$args$$) {
            GlanceLogger.log('DRAW:', ...$args$$);
          }
        : function () {},
    preslog = LOG_PRES
      ? function (...$args$$) {
          GlanceLogger.log('PRES:', ...$args$$);
        }
      : function () {},
    cbstatelog =
      GLANCE_LOGGER && LOG_CBSTATE
        ? function (...$args$$) {
            GlanceLogger.log('CBSTATE:', ...$args$$);
          }
        : function () {},
    iframelog =
      GLANCE_LOGGER && LOG_IFRAME
        ? function (...$args$$) {
            GlanceLogger.log('IFRAME:', ...$args$$);
          }
        : function () {},
    scrolllog =
      GLANCE_LOGGER && LOG_SCROLL
        ? function (...$args$$) {
            GlanceLogger.log('SCROLL:', ...$args$$);
          }
        : function () {},
    eventslog =
      GLANCE_LOGGER && LOG_EVENTS
        ? function (...$args$$) {
            GlanceLogger.log('EVENTS:', ...$args$$);
          }
        : function () {},
    loaderlog =
      GLANCE_LOGGER && LOG_LOADER
        ? function (...$args$$) {
            GlanceLogger.log('LOADER:', ...$args$$);
          }
        : function () {},
    uilog =
      GLANCE_LOGGER && LOG_UI
        ? function (...$args$$) {
            GlanceLogger.log('UI:', ...$args$$);
          }
        : function () {},
    focuslog =
      GLANCE_LOGGER && LOG_FOCUS
        ? function (...$args$$) {
            GlanceLogger.log('FOCUS:', ...$args$$);
          }
        : function () {},
    xdomlog = LOG_XDOM
      ? function (...$args$$) {
          GlanceLogger.log('XDOM:', ...$args$$);
        }
      : function () {},
    c3plog =
      GLANCE_LOGGER && LOG_C3P
        ? function (...$args$$) {
            GlanceLogger.log('C3P:', ...$args$$);
          }
        : function () {},
    pdflog =
      GLANCE_LOGGER && LOG_PDF
        ? function (...$args$$) {
            GlanceLogger.log('PDF:', ...$args$$);
          }
        : function () {},
    stylelog =
      GLANCE_LOGGER && LOG_STYLES
        ? function (...$args$$) {
            GlanceLogger.log('STYLES:', ...$args$$);
          }
        : function () {},
    gestlog =
      GLANCE_LOGGER && LOG_GEST
        ? function (...$args$$) {
            GlanceLogger.log('GEST:', ...$args$$);
          }
        : function () {},
    msglog =
      GLANCE_LOGGER && LOG_MSG
        ? function (...$args$$) {
            GlanceLogger.log('MSG:', ...$args$$);
          }
        : function () {},
    reslog =
      GLANCE_LOGGER && LOG_RES
        ? function (...$args$$) {
            GlanceLogger.log('RES:', ...$args$$);
          }
        : function () {},
    rclog =
      GLANCE_LOGGER && LOG_RC
        ? function (...$args$$) {
            GlanceLogger.log('RC:', ...$args$$);
          }
        : function () {},
    sdlog =
      GLANCE_LOGGER && LOG_SD
        ? function (...$args$$) {
            GlanceLogger.log('SD:', ...$args$$);
          }
        : function () {},
    vidlog = LOG_VID
      ? function (...$args$$) {
          GlanceLogger.log('VID:', ...$args$$);
        }
      : function () {},
    masklog =
      GLANCE_LOGGER && LOG_MASK
        ? function (...$args$$) {
            GlanceLogger.log('MASK:', ...$args$$);
          }
        : function () {},
    doclog =
      GLANCE_LOGGER && LOG_DOC
        ? function (...$args$$) {
            GlanceLogger.log('DOC:', ...$args$$);
          }
        : function () {},
    sslog =
      GLANCE_LOGGER && LOG_SS
        ? function (...$args$$) {
            GlanceLogger.log('SS:', ...$args$$);
          }
        : function () {},
    assert = GLANCE_LOGGER
      ? function ($b$$) {
          if (!$b$$) {
            if (window.console && window.console.error) {
              GlanceLogger.error('ASSERT');
            } else {
              throw Error('ASSERT');
            }
          }
        }
      : function () {};
  function consolelog(...$args$$) {
    GlanceLogger.log('GLANCE:', ...$args$$);
  }
  function errorlog(...$args$$) {
    GlanceLogger.error('GLANCE:', ...$args$$);
  } /*
 Copyright (c) 2022 Glance Networks, Inc.
*/
  var GLANCE = GLANCE || {};
  GLANCE.Lib = GLANCE.Lib || {};
  GLANCE.VERSION = '6.3.0.2';
  GLANCE.PATCH = '';
  window.GLANCE = window.GLANCE || {};
  window.GLANCE.VERSION = GLANCE.VERSION;
  window.GLANCE.PATCH = GLANCE.PATCH;
  window.GLANCE.Lib = window.GLANCE.Lib || {};
  GLANCE.Lib.KEYTYPE = { RANDOM: 'GLANCE_KEYTYPE_RANDOM' };
  GLANCE.Lib.KEYTYPE = { RANDOM: 'GLANCE_KEYTYPE_RANDOM' };
  GLANCE.Lib.MESSAGES = {
    GLANCE_INVOKE_MSG: 'glance_invoke',
    GLANCE_SCREENSHARE: 'glance_screenshare',
    GLANCE_SCREENSHAREPREVIEW: 'glance_screensharepreview',
    GLANCE_VISITOR_SCREENSHAREPREVIEW: 'glance_visitor_screensharepreview',
    GLANCE_AGENTVIDEO: 'glance_agentvideo',
    GLANCE_VIDEOPREVIEW: 'glance_videopreview',
  };
  GLANCE.Lib.Const = { GID: 'data-gid', GCID: 'data-gcid', SDID: 'data-sdid' };
  GLANCE.Lib.scriptId = function ($namespace$$) {
    return ('glance_' + $namespace$$).toLowerCase();
  };
  GLANCE.Lib.CallFlags = {
    None: 0,
    Reconnect: 1,
    Reverse: 2,
    Declined: 4,
    Rcrequested: 8,
    Closing: 16,
    Beta: 32,
    MultipleGuestsOk: 64,
    Anonymous: 128,
    Showback: 256,
    GuestNameRequired: 512,
    GuestEmailRequired: 1024,
    GuestPhoneRequired: 2048,
    GuestNameHidden: 4096,
    GuestEmailHidden: 8192,
    GuestPhoneHidden: 16384,
    GuestInfo: 32256,
    Encrypt: 32768,
    ForceAjax: 65536,
    Persist: 131072,
    PresenceStart: 262144,
    StagingSession: 524288,
    HDAgentVideoEnabled: 2097152,
  };
  GLANCE.Lib.IntVersion = (function () {
    var $vernums$$ = GLANCE.VERSION.split('.');
    return (
      1000000 * parseInt($vernums$$[0]) +
      1000 * parseInt($vernums$$[1]) +
      parseInt($vernums$$[2])
    );
  })();
  GLANCE.Lib.VideoJoinURL = function ($offerurl$$, $scaling$$) {
    $scaling$$ = $scaling$$ || 'clip';
    return `https://${
      URL.toString().includes('[native code]')
        ? new URL($offerurl$$).hostname
        : GLANCE.Lib.GElement.nativeInstance('URL', $offerurl$$).hostname
    }/viv/VideoPlayer.html?offer=${$offerurl$$}&scaling=${$scaling$$}&noendpage=1&guestid={guestid}&conntype={role}`;
  };
  GLANCE.Lib.Browser = (function () {
    var $Browser_ua$$ = navigator.userAgent.toLowerCase(),
      $platform$$ = navigator.platform.toLowerCase(),
      $UA$$ = $Browser_ua$$.match(/(edge)[\s\/:]([\w\d\.]+)?/) ||
        $Browser_ua$$.match(
          /(opera|ie|firefox|chrome|crios|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/
        ) ||
        $Browser_ua$$.match(/(rv):([\w\d\.]+)/) || [null, 'unknown', 0];
    'crios' === $UA$$[1]
      ? ($UA$$[1] = 'chrome')
      : 'rv' === $UA$$[1] && ($UA$$[1] = 'ie');
    $Browser_ua$$ = {
      extend: Function.prototype.extend,
      name: 'version' == $UA$$[1] ? $UA$$[3] : $UA$$[1],
      version:
        ('ie' == $UA$$[1] && document.documentMode) ||
        parseFloat('opera' == $UA$$[1] && $UA$$[4] ? $UA$$[4] : $UA$$[2]),
      Platform: {
        name:
          $Browser_ua$$.match(/ip(?:ad|od|hone)/) ||
          ($platform$$.match(/mac/) &&
            'undefined' !== typeof navigator.standalone)
            ? 'ios'
            : ($Browser_ua$$.match(/(?:webos|android)/) ||
                $platform$$.match(/mac|win|linux/) || ['other'])[0],
      },
      Features: {
        xpath: !!document.evaluate,
        air: !!window.runtime,
        query: !!document.querySelector,
        json: !!window.JSON,
      },
      Plugins: {},
      isMobileDevice: function () {
        return 'ios' == this.Platform.name || 'android' == this.Platform.name;
      },
    };
    document.documentMode && window.XDomainRequest
      ? (($Browser_ua$$.name = 'ie'),
        ($Browser_ua$$.version = document.documentMode))
      : window.navigator &&
        navigator.appVersion &&
        -1 != navigator.appVersion.indexOf('MSIE 7.') &&
        (($Browser_ua$$.name = 'ie'), ($Browser_ua$$.version = '7'));
    $Browser_ua$$[$Browser_ua$$.name] = !0;
    $Browser_ua$$[$Browser_ua$$.name + parseInt($Browser_ua$$.version, 10)] =
      !0;
    $Browser_ua$$.Platform[$Browser_ua$$.Platform.name] = !0;
    return $Browser_ua$$;
  })();
  GLANCE.Lib.getIframe = function ($frameid$$, $element$$) {
    $element$$ = $element$$ || document;
    return GLANCE.Lib.GElement.nativeMethod(
      $element$$,
      'querySelector',
      "iframe[frameid='" + $frameid$$ + "']"
    );
  };
  GLANCE.Lib.equal = function ($obj1$$, $obj2$$) {
    return (
      GLANCE.Lib.JSONStringify($obj1$$) === GLANCE.Lib.JSONStringify($obj2$$)
    );
  };
  GLANCE.Lib.random = function ($nlen_r$$) {
    for (
      $nlen_r$$ = String(Math.round(Math.random() * Math.pow(10, $nlen_r$$)));
      4 > $nlen_r$$.length;

    ) {
      $nlen_r$$ = '0' + $nlen_r$$;
    }
    return $nlen_r$$;
  };
  GLANCE.Lib.getCryptoToken = function ($a$$) {
    $a$$ = new Uint32Array(Math.ceil($a$$ / 32));
    window.crypto.getRandomValues($a$$);
    let $s$$ = '';
    $a$$.forEach(($n$$) => {
      $s$$ += $n$$.toString(36);
    });
    return $s$$;
  };
  GLANCE.Lib.getProperties = function ($obj$$, $prefix$$) {
    var $ret$$ = {},
      $re$$ = new RegExp($prefix$$),
      $prop$$;
    for ($prop$$ in $obj$$) {
      $prop$$.match($re$$) &&
        ($ret$$[$prop$$.substr($prefix$$.length)] = $obj$$[$prop$$]);
    }
    return $ret$$;
  };
  GLANCE.Lib.pointDistance = function ($pt1$$, $pt2$$) {
    return Math.max(
      Math.abs($pt1$$.x - $pt2$$.x),
      Math.abs($pt1$$.y - $pt2$$.y)
    );
  };
  GLANCE.Lib.Url = {};
  GLANCE.Lib.Url.isAbsolute = function ($url$$) {
    return 0 <= $url$$.indexOf('//') || 0 === $url$$.indexOf('/');
  };
  GLANCE.Lib.ExtendableTimer = function () {};
  GLANCE.Lib.ExtendableTimer.prototype.set = function (
    $timeout$$,
    $callbackfn$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(window, 'clearTimeout', this.timer);
    var $self$$ = this;
    this.timer = GLANCE.Lib.GElement.nativeMethod(
      window,
      'setTimeout',
      function () {
        delete $self$$.timer;
        $callbackfn$$ && $callbackfn$$();
      },
      $timeout$$
    );
  };
  GLANCE.Lib.ExtendableTimer.prototype.isSet = function () {
    return void 0 !== this.timer;
  };
  GLANCE.Lib.ExtendableTimer.prototype.clear = function () {
    GLANCE.Lib.GElement.nativeMethod(window, 'clearTimeout', this.timer);
    delete this.timer;
  };
  void 0 === GLANCE.Lib.JSONStringify &&
    (GLANCE.Lib.JSONStringify = function ($obj$$) {
      return JSON.stringify($obj$$);
    });
  GLANCE.Lib._enhanceSocket = function ($ws$$) {
    $ws$$.onmessage = function ($msg$jscomp$1_obj$$) {
      $msg$jscomp$1_obj$$ = JSON.parse($msg$jscomp$1_obj$$.data);
      if ($ws$$.onreceiveobj) {
        $ws$$.onreceiveobj($msg$jscomp$1_obj$$);
      }
    };
    $ws$$.sendobj = function ($obj$jscomp$38_s$$) {
      $obj$jscomp$38_s$$ = GLANCE.Lib.JSONStringify($obj$jscomp$38_s$$);
      $ws$$.send($obj$jscomp$38_s$$);
    };
    $ws$$.getcode = function ($e$$) {
      return ($e$$ && $e$$.code) || 0;
    };
    $ws$$.getreason = function ($e$$) {
      return ($e$$ && $e$$.reason) || '';
    };
    return $ws$$;
  };
  GLANCE.Lib.GWebSocket = function ($url$jscomp$26_ws$$) {
    $url$jscomp$26_ws$$ = new WebSocket($url$jscomp$26_ws$$);
    GLANCE.Lib._enhanceSocket($url$jscomp$26_ws$$);
    return $url$jscomp$26_ws$$;
  };
  GLANCE.Lib.GSockJS = function ($url$$, $hbcheckinterval$$) {
    var $options$$ = {};
    if (GLANCE.Lib.useIFrameProxy) {
      var $sockjs$$ = new GLANCE.Lib.GSockJSProxy($url$$);
    } else {
      GLANCE.Lib.Browser.ie9 &&
        'http:' === window.location.protocol &&
        ($options$$.protocols_whitelist = [
          'iframe-eventsource',
          'iframe-htmlfile',
        ]),
        ($sockjs$$ = new SockJS($url$$, '', $options$$));
    }
    $sockjs$$.hbskipped = 0;
    $sockjs$$.checkheartbeat = function () {
      $sockjs$$.cancelheartbeatcheck();
      $hbcheckinterval$$ &&
        $sockjs$$.transport &&
        !$sockjs$$.transport.match(/^iframe-/) &&
        ($sockjs$$.hbinterval = GLANCE.Lib.GElement.nativeMethod(
          window,
          'setInterval',
          function () {
            $sockjs$$.hbskipped++;
            if ($sockjs$$.onheartbeatskipped) {
              $sockjs$$.onheartbeatskipped({ hbskipped: $sockjs$$.hbskipped });
            }
          },
          $hbcheckinterval$$
        ));
    };
    $sockjs$$.cancelheartbeatcheck = function () {
      $sockjs$$.hbinterval &&
        GLANCE.Lib.GElement.nativeMethod(
          window,
          'clearInterval',
          $sockjs$$.hbinterval
        );
    };
    GLANCE.Lib._enhanceSocket($sockjs$$);
    $sockjs$$.onclose = function ($e$$) {
      $sockjs$$.cancelheartbeatcheck();
      if ($sockjs$$.on_close) {
        $sockjs$$.on_close($e$$);
      }
    };
    $sockjs$$.onheartbeat = function () {
      $sockjs$$.hbskipped = 0;
      $sockjs$$.checkheartbeat();
      if ($sockjs$$.on_heartbeat) {
        $sockjs$$.on_heartbeat();
      }
    };
    return $sockjs$$;
  };
  GLANCE.Lib.RequestProxy = { loaded: !1 };
  GLANCE.Lib.RequestProxy.init = function ($webserver$$) {
    GLANCE.Lib.RequestProxy.server = $webserver$$;
    if (!document.getElementById('glance_request_proxy')) {
      var $rqproxyiframe$$ = document.createElement('iframe');
      $rqproxyiframe$$.id = 'glance_request_proxy';
      $rqproxyiframe$$.width = '0px';
      $rqproxyiframe$$.height = '0px';
      $rqproxyiframe$$.style.border = 'none';
      $rqproxyiframe$$.src = 'https://' + $webserver$$ + '/RequestProxy.htm?1';
      $rqproxyiframe$$.onload = function () {
        GLANCE.Lib.RequestProxy.loaded = !0;
      };
      document.body.appendChild($rqproxyiframe$$);
    }
    GLANCE.Lib.RequestProxy.proxyframe = document.getElementById(
      'glance_request_proxy'
    ).contentWindow;
  };
  GLANCE.Lib.RequestProxy.postMessage = function ($message$$, $targetOrigin$$) {
    var $self$$ = GLANCE.Lib.RequestProxy;
    $self$$.loaded
      ? $self$$.proxyframe.postMessage(
          $message$$,
          $targetOrigin$$ || 'https://' + GLANCE.Lib.RequestProxy.server
        )
      : GLANCE.Lib.GElement.nativeMethod(
          window,
          'setTimeout',
          function () {
            $self$$.postMessage($message$$, $targetOrigin$$);
          },
          100
        );
  };
  GLANCE.Lib.GSockJSProxy = function ($url$$) {
    this.readyState = SockJS.CONNECTING;
    this.sockid = Math.round(1000000 * Math.random());
    GLANCE.Lib.GSockJSProxy.sockets = GLANCE.Lib.GSockJSProxy.sockets || {};
    GLANCE.Lib.GSockJSProxy.sockets[this.sockid] = this;
    GLANCE.Lib.RequestProxy.postMessage({
      from: 'GSockJSProxy',
      sockid: this.sockid,
      cmd: 'open',
      url: $url$$,
    });
  };
  GLANCE.Lib.GSockJSProxy.init = function ($webserver$$) {
    GLANCE.Lib.RequestProxy.init($webserver$$);
    GLANCE.Lib.Window.addEventListener(
      'message',
      GLANCE.Lib.GSockJSProxy.handleMessage,
      !1
    );
  };
  var _protect_gsjsproxyresp = { to: 0, event: 0 };
  GLANCE.Lib.GSockJSProxy.handleMessage = function ($e$$) {
    if (
      GLANCE.Lib.getDomain($e$$.origin) ===
        GLANCE.Lib.getDomain(GLANCE.Lib.RequestProxy.server) &&
      'undefined' != typeof $e$$.data.to &&
      'GSockJSProxy' == $e$$.data.to
    ) {
      var $sock$$ = GLANCE.Lib.GSockJSProxy.sockets[$e$$.data.sockid];
      if ($sock$$) {
        switch ($e$$.data.event.type) {
          case 'open':
            $sock$$.readyState = SockJS.OPEN;
            if ($sock$$.onopen) {
              $sock$$.onopen($e$$.data.event);
            }
            break;
          case 'heartbeat':
            $sock$$.onheartbeat();
            break;
          case 'message':
            $sock$$.onmessage($e$$.data.event);
            break;
          case 'close':
            $sock$$.readyState = SockJS.CLOSED;
            $sock$$.onclose($e$$.data.event);
            break;
          default:
            GLANCE.Lib.log(
              'UNKNOWN GLANCE SOCKJS PROXY MESSAGE: ' +
                JSON.stringify($e$$.data)
            );
        }
      }
    }
  };
  GLANCE.Lib.GSockJSProxy.prototype.send = function ($data$$) {
    GLANCE.Lib.RequestProxy.postMessage({
      from: 'GSockJSProxy',
      sockid: this.sockid,
      cmd: 'send',
      data: $data$$,
    });
  };
  GLANCE.Lib.GSockJSProxy.prototype.close = function ($code$$, $reason$$) {
    this.readyState = SockJS.CLOSING;
    GLANCE.Lib.RequestProxy.postMessage({
      from: 'GSockJSProxy',
      sockid: this.sockid,
      cmd: 'close',
    });
  };
  GLANCE.Lib.nextGID = 1;
  GLANCE.Lib.compressObj = function ($o_s$$) {
    if (void 0 === $o_s$$ || null === $o_s$$) {
      return $o_s$$;
    }
    $o_s$$ = GLANCE.Lib.JSONStringify($o_s$$);
    return { _c: GLANCE.Lib.compressToBase64($o_s$$) };
  };
  GLANCE.Lib.compressToBase64 = function ($binary$jscomp$inline_8_s$$) {
    $binary$jscomp$inline_8_s$$ = new TextEncoder().encode(
      $binary$jscomp$inline_8_s$$
    );
    var $bytes$$ = new window.GLANCE.Lib.Zlib.RawDeflate(
      $binary$jscomp$inline_8_s$$
    ).compress();
    $binary$jscomp$inline_8_s$$ = '';
    $bytes$$ = new Uint8Array($bytes$$);
    for (var $len$$ = $bytes$$.byteLength, $i$$ = 0; $i$$ < $len$$; $i$$++) {
      $binary$jscomp$inline_8_s$$ += String.fromCharCode($bytes$$[$i$$]);
    }
    return window.btoa($binary$jscomp$inline_8_s$$);
  };
  GLANCE.Lib.decompressObj = function ($o$jscomp$1_s$$) {
    if (
      null === $o$jscomp$1_s$$ ||
      ($o$jscomp$1_s$$ instanceof String && 0 === $o$jscomp$1_s$$.length)
    ) {
      return null;
    }
    if (void 0 === $o$jscomp$1_s$$._c) {
      return $o$jscomp$1_s$$;
    }
    $o$jscomp$1_s$$ = GLANCE.Lib.decompressFromBase64($o$jscomp$1_s$$._c);
    return JSON.parse($o$jscomp$1_s$$);
  };
  GLANCE.Lib.decompressFromBase64 = function (
    $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$
  ) {
    $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$ =
      window.atob(
        $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$
      );
    for (
      var $len$$ =
          $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$.length,
        $bytes$$ = new Uint8Array($len$$),
        $i$$ = 0;
      $i$$ < $len$$;
      $i$$++
    ) {
      $bytes$$[$i$$] =
        $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$.charCodeAt(
          $i$$
        );
    }
    $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$ =
      new window.GLANCE.Lib.Zlib.RawInflate($bytes$$.buffer).decompress();
    return new TextDecoder().decode(
      $binary_string$jscomp$inline_14_deflatedb64$jscomp$2_utf8buf$$
    );
  };
  GLANCE.Lib.pad = function ($str$$, $c$$, $len$$) {
    return (
      ($str$$.length >= $len$$
        ? ''
        : Array((1 + $len$$ - $str$$.length) >>> 0).join($c$$)) + $str$$
    );
  };
  GLANCE.Lib.hash = function ($str$$) {
    var $hash$$ = 0,
      $i$$;
    if (0 == $str$$.length) {
      return $hash$$;
    }
    for ($i$$ = 0; $i$$ < $str$$.length; $i$$++) {
      var $ch$$ = $str$$.charCodeAt($i$$);
      $hash$$ = ($hash$$ << 5) - $hash$$ + $ch$$;
      $hash$$ &= $hash$$;
    }
    return Math.abs($hash$$);
  };
  GLANCE.Lib.Params = {};
  GLANCE.Lib.Params.copy = function ($from$$, $to$$, $whichparams$$) {
    if (void 0 !== $from$$) {
      return (
        ($whichparams$$ = $whichparams$$ || Object.keys($from$$)),
        $whichparams$$.forEach(function ($p$$) {
          void 0 !== $from$$[$p$$] && ($to$$[$p$$] = $from$$[$p$$]);
        }),
        $to$$
      );
    }
  };
  GLANCE.Lib.invokeFunction = function ($params$$) {
    var $a$$ = $params$$.func.split('.');
    if (2 > $a$$.length) {
      GLANCE.Lib.errlog('ERR_BADINVOKE:', $params$$.func);
    } else {
      if (
        'GLANCE' === $a$$[0] ||
        ('GLANCE_COBROWSE' === $a$$[0] && 'Custom' === $a$$[1])
      ) {
        for (var $f$$ = window[$a$$[0]], $i$$ = 1; $i$$ < $a$$.length; $i$$++) {
          if ((($f$$ = $f$$[$a$$[$i$$]]), !$f$$)) {
            GLANCE.Lib.errlog('ERR_UNDEFINVOKE:' + $a$$[$i$$]);
            return;
          }
        }
        $params$$.args = $params$$.args || {};
        $params$$.args.remote = !0;
        $f$$($params$$.args);
      } else {
        GLANCE.Lib.errlog('ERR_BADINVOKE:' + $a$$[0]);
      }
    }
  };
  GLANCE.Lib.UTCNow = function () {
    function $zeropad$$($num$jscomp$8_s$$, $len$$) {
      for (
        $num$jscomp$8_s$$ = $num$jscomp$8_s$$.toString();
        $num$jscomp$8_s$$.length < $len$$;

      ) {
        $num$jscomp$8_s$$ = '0' + $num$jscomp$8_s$$;
      }
      return $num$jscomp$8_s$$;
    }
    var $now$$ = new Date();
    return (
      $now$$.getUTCFullYear() +
      '/' +
      ($now$$.getUTCMonth() + 1) +
      '/' +
      $now$$.getUTCDate() +
      ' ' +
      $zeropad$$($now$$.getUTCHours(), 2) +
      ':' +
      $zeropad$$($now$$.getUTCMinutes(), 2) +
      ':' +
      $zeropad$$($now$$.getUTCSeconds(), 2)
    );
  };
  GLANCE.Lib.Timer = function () {
    this.t = 0;
  };
  GLANCE.Lib.Timer.prototype.elapsed = function () {
    return new Date().getTime() - this.t;
  };
  GLANCE.Lib.Timer.prototype.set = function () {
    this.t = new Date().getTime();
  };
  GLANCE.Lib.Window = {};
  GLANCE.Lib.Window.addEventListener = function (
    $evt$$,
    $listener$$,
    $capture$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(
      window,
      'addEventListener',
      $evt$$,
      $listener$$,
      $capture$$
    );
  };
  GLANCE.Lib.Window.removeEventListener = function ($evt$$, $listener$$) {
    GLANCE.Lib.GElement.nativeMethod(
      window,
      'removeEventListener',
      $evt$$,
      $listener$$
    );
  };
  GLANCE.Lib.Window.postWindowMessage = function (
    $w$$,
    $msgname$$,
    $message$$,
    $origin$$
  ) {
    var $msgobj$$ = {};
    $msgobj$$[$msgname$$] = $message$$;
    $w$$.postMessage($msgobj$$, void 0 !== $origin$$ ? $origin$$ : '*');
  };
  GLANCE.Lib.Window.onWindowMessage = function (
    $msgname$$,
    $handler$$,
    $alloweddomains$$
  ) {
    var $handlerFunction$$ = function ($event$$) {
      if ('string' === typeof $event$$.data) {
        try {
          var $data$$ = JSON.parse($event$$.data);
        } catch ($e$$) {
          return !1;
        }
      } else {
        $data$$ = $event$$.data;
      }
      void 0 !== $data$$[$msgname$$] &&
        ($alloweddomains$$ &&
        !GLANCE.Lib.isAllowedOrigin($event$$.origin, $alloweddomains$$)
          ? GLANCE.Lib.errlog(
              'UNTRUSTED_ORIGIN:' +
                $event$$.origin +
                ' ' +
                JSON.stringify($data$$)
            )
          : $handler$$($event$$.source, $data$$[$msgname$$]));
    };
    GLANCE.Lib.GElement.nativeMethod(
      window,
      'addEventListener',
      'message',
      $handlerFunction$$
    );
    return $handlerFunction$$;
  };
  GLANCE.Lib.Window.POPUP_WINDOW =
    'location=no,menubar=0,titlebar=0,status=0,toolbar=0';
  GLANCE.Lib.Window.onPageHide = function ($fn$$) {
    GLANCE.Lib.Window.addEventListener(
      void 0 !== window.onpagehide ? 'pagehide' : 'unload',
      $fn$$
    );
  };
  GLANCE.Lib.Window.onPageShow = function ($fn$$) {
    void 0 !== window.onpageshow &&
      GLANCE.Lib.Window.addEventListener('pageshow', $fn$$);
  };
  GLANCE.Lib.Window.DOMEvents =
    'DOMAttrModified DOMAttributeNameChanged DOMCharacterDataModified DOMElementNameChanged DOMNodeInserted DOMNodeInsertedIntoDocument DOMNodeRemoved DOMNodeRemovedFromDocument DOMSubtreeModified'.split(
      ' '
    );
  GLANCE.Lib.Window.listenForDOMChanges = function ($onChange$$) {
    var $windowcontext$$ =
      !MutationObserver.toString().includes('native code') &&
      GLANCE.Lib.GElement.USE_CLEANCONTEXT
        ? GLANCE.Lib.GElement.CleanContext
        : window;
    GLANCE.Lib.Window.mutationObserver = new $windowcontext$$.MutationObserver(
      $onChange$$
    );
    GLANCE.Lib.Window.mutationObserver.observe(document, {
      childList: !0,
      characterData: !0,
      attributes: !0,
      subtree: !0,
    });
  };
  GLANCE.Lib.Window.stopListenForDOMChanges = function () {
    GLANCE.Lib.Window.mutationObserver &&
      GLANCE.Lib.Window.mutationObserver.disconnect();
    delete GLANCE.Lib.Window.mutationObserver;
  };
  GLANCE.Lib.cleanObj = function ($obj$jscomp$1$$) {
    function $deleteEmpty$$($obj$jscomp$0$$) {
      for (var $attr$$ in $obj$jscomp$0$$) {
        if ('object' === typeof $obj$jscomp$0$$[$attr$$]) {
          $deleteEmpty$$($obj$jscomp$0$$[$attr$$]);
          a: {
            var $JSCompiler_inline_result$jscomp$3_attr$$ = void 0;
            var $obj$$ = $obj$jscomp$0$$[$attr$$];
            if ($obj$$ instanceof Array || $obj$$ instanceof String) {
              $JSCompiler_inline_result$jscomp$3_attr$$ = !1;
            } else {
              for ($JSCompiler_inline_result$jscomp$3_attr$$ in $obj$$) {
                if (
                  $obj$$.hasOwnProperty(
                    $JSCompiler_inline_result$jscomp$3_attr$$
                  )
                ) {
                  $JSCompiler_inline_result$jscomp$3_attr$$ = !1;
                  break a;
                }
              }
              $JSCompiler_inline_result$jscomp$3_attr$$ = !0;
            }
          }
          $JSCompiler_inline_result$jscomp$3_attr$$ &&
            delete $obj$jscomp$0$$[$attr$$];
        }
      }
    }
    function $deleteUndefined$$($obj$$) {
      if (!($obj$$ instanceof Array || $obj$$ instanceof String)) {
        for (var $attr$$ in $obj$$) {
          void 0 === $obj$$[$attr$$]
            ? delete $obj$$[$attr$$]
            : 'object' === typeof $obj$$[$attr$$] &&
              $deleteUndefined$$($obj$$[$attr$$]);
        }
      }
    }
    $deleteUndefined$$($obj$jscomp$1$$);
    $deleteEmpty$$($obj$jscomp$1$$);
  };
  GLANCE.Lib.compareObjects = function ($obj1$$, $obj2$$) {
    return JSON.stringify($obj1$$) === JSON.stringify($obj2$$);
  };
  GLANCE.Lib.compareVersions = function ($v1$$, $i$jscomp$22_v2$$) {
    $v1$$ = String($v1$$).split('.');
    var $v2s$$ = String($i$jscomp$22_v2$$).split('.');
    $v1$$.push([0, 0, 0, 0]);
    $v2s$$.push([0, 0, 0, 0]);
    for ($i$jscomp$22_v2$$ = 0; 4 > $i$jscomp$22_v2$$; $i$jscomp$22_v2$$++) {
      isNaN($v1$$[$i$jscomp$22_v2$$]) && ($v1$$[$i$jscomp$22_v2$$] = 0);
      isNaN($v2s$$[$i$jscomp$22_v2$$]) && ($v2s$$[$i$jscomp$22_v2$$] = 0);
      if (
        Number($v1$$[$i$jscomp$22_v2$$]) < Number($v2s$$[$i$jscomp$22_v2$$])
      ) {
        return -1;
      }
      if (
        Number($v1$$[$i$jscomp$22_v2$$]) > Number($v2s$$[$i$jscomp$22_v2$$])
      ) {
        return 1;
      }
    }
    return 0;
  };
  GLANCE.Lib.AppendUrlParams = function ($url$$, $params$$) {
    var $hashlocation$$ = $url$$.indexOf('#');
    return 0 > $hashlocation$$
      ? $url$$ + (-1 === $url$$.indexOf('?') ? '?' : '&') + $params$$
      : GLANCE.Lib.AppendUrlParams(
          $url$$.substring(0, $hashlocation$$),
          $params$$
        ) + $url$$.substring($hashlocation$$);
  };
  GLANCE.Lib.XMLDoc = function ($docelem$$) {
    this.ownerDoc = $docelem$$.ownerDocument;
  };
  GLANCE.Lib.XMLDoc.prototype.getElementText = function ($elem$$) {
    return ($elem$$ = this.ownerDoc.querySelector($elem$$))
      ? $elem$$.textContent
      : null;
  };
  GLANCE.Lib.JSONFetch = async function ($url$$, $fetchParams$$) {
    return new Promise(async ($msg$jscomp$2_resolve$$, $reject$$) => {
      $fetchParams$$.headers = { 'Content-Type': 'application/json' };
      'object' === typeof $fetchParams$$.body &&
        ($fetchParams$$.body = JSON.stringify($fetchParams$$.body));
      let $response$$;
      try {
        $response$$ = await fetch($url$$, $fetchParams$$);
      } catch ($e$$) {
        GLANCE.Lib.errlog(`JSON request to ${$url$$} failed: ${$e$$.message}`);
        $reject$$('connection');
        return;
      }
      if ($response$$.ok) {
        try {
          var $data$$ = await $response$$.json();
        } catch ($err$$) {
          GLANCE.Lib.errlog(
            `JSON request to ${$url$$} reponse parse failed`,
            $err$$
          ),
            $reject$$('error');
        }
        $msg$jscomp$2_resolve$$($data$$);
      } else {
        GLANCE.Lib.errlog(
          `JSON request to ${$url$$} failed status: ${$response$$.status}`
        ),
          ($msg$jscomp$2_resolve$$ = await $response$$.text()),
          GLANCE.Lib.errlog($msg$jscomp$2_resolve$$),
          $reject$$(
            401 === $response$$.status || 403 === $response$$.status
              ? 'authorization'
              : 'error'
          );
      }
    });
  };
  GLANCE.Lib.Request = function ($type$$) {
    GLANCE.Lib.useIFrameProxy
      ? (this.ifproxy = new GLANCE.Lib.Request.IFrameProxyRequest($type$$))
      : (this.xmlhttp = this.getXmlHttp());
    this.response = null;
    this.type = $type$$;
  };
  GLANCE.Lib.Request.prototype.setAuthorizer = function ($a$$) {
    this.authorizer = $a$$;
  };
  GLANCE.Lib.Request.prototype.setAuthorizationToken = function ($tok$$) {
    this.authorizationToken = $tok$$;
  };
  GLANCE.Lib.Request.prototype.getXmlHttp = function () {
    return new window.XMLHttpRequest();
  };
  GLANCE.Lib.Request.prototype.abort = function () {
    this.ifproxy ? this.ifproxy.abort() : this.xmlhttp.abort();
  };
  GLANCE.Lib.Request.prototype.onreadystatechange = function () {
    if (4 == this.xmlhttp.readyState) {
      GLANCE.Lib.GElement.nativeMethod(
        window,
        'clearTimeout',
        this.requesttimeout
      );
      delete this.requesttimeout;
      var $failreason$$ = 'error';
      if (0 == this.xmlhttp.status) {
        GLANCE.Lib.log(this.method + ' to ' + this.url + ' failed: network'),
          this.onfailure(!0, 'connection', this.xmlhttp.status);
      } else {
        if (200 !== this.xmlhttp.status) {
          GLANCE.Lib.errlog(
            this.method +
              ' to ' +
              this.url +
              ' failed with status: ' +
              this.xmlhttp.status
          );
          'text' === this.xmlhttp.responseType &&
            null !== this.xmlhttp.responseText &&
            GLANCE.Lib.log(this.xmlhttp.responseText);
          if (401 === this.xmlhttp.status || 403 === this.xmlhttp.status) {
            ($failreason$$ = 'authorization'),
              this.authorizer && this.authorizer.clearToken();
          }
          this.onfailure(!1, $failreason$$, this.xmlhttp.status);
        } else {
          if ('' !== this.xmlhttp.response) {
            if ('XML' === this.accept) {
              (this.response =
                this.xmlhttp.responseXML &&
                this.xmlhttp.responseXML.documentElement),
                null === this.response &&
                  GLANCE.Lib.errlog(
                    'Invalid XML response: ' + this.xmlhttp.responseText
                  );
            } else if (this.IE11BinaryWorkaround) {
              for (
                var $binaryResponseData$$ = new Uint8Array(
                    this.xmlhttp.responseText.length
                  ),
                  $i$$ = 0;
                $i$$ < this.xmlhttp.responseText.length;
                $i$$++
              ) {
                $binaryResponseData$$[$i$$] =
                  this.xmlhttp.responseText.charCodeAt($i$$) & 255;
              }
              this.response = new Blob([$binaryResponseData$$], {
                type: this.xmlhttp.getResponseHeader('Content-Type'),
              });
            } else if ('blob' === this.xmlhttp.responseType) {
              this.response = this.xmlhttp.response;
            } else if (this.xmlhttp.responseXML) {
              this.response = this.parsejson(
                this.xmlhttp.responseXML.childNodes[0].childNodes[0].nodeValue
              );
            } else if ('HTML' === this.accept || 'TEXT' === this.accept) {
              this.response = this.xmlhttp.responseText;
            } else {
              if (
                ((this.response = this.parsejson(this.xmlhttp.responseText)),
                null === this.response)
              ) {
                GLANCE.Lib.log(
                  this.method +
                    ' to ' +
                    this.url +
                    " failed - can't parse response " +
                    this.xmlhttp.responseText
                );
                this.onfailure(!1, $failreason$$);
                return;
              }
            }
            if (void 0 !== this.response.err && void 0 !== this.response.msg) {
              GLANCE.Lib.log(
                this.method +
                  ' to ' +
                  this.url +
                  ' failed with error:' +
                  this.response.err +
                  ' ' +
                  this.response.msg
              );
              this.onfailure(!1, $failreason$$);
              return;
            }
          }
          this.onsuccess(this.response);
        }
      }
    }
  };
  GLANCE.Lib.Request.prototype.parsejson = function ($data$$) {
    var $result$$ = null;
    try {
      $result$$ = JSON.parse($data$$);
    } catch ($err$$) {
      return (
        GLANCE.Lib.log(
          'JSON parse failed with error: ' +
            $err$$.toString() +
            ' parsing: ' +
            $data$$
        ),
        null
      );
    }
    return $result$$;
  };
  GLANCE.Lib.Request.prototype.getResponseHeader = function ($headerName$$) {
    return this.xmlhttp.getResponseHeader($headerName$$);
  };
  GLANCE.Lib.Request.prototype.setAccept = function ($a$$) {
    this.accept = $a$$;
    'XML' === $a$$
      ? (this.acceptheader =
          'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8')
      : 'JSON' === $a$$
      ? (this.acceptheader = 'application/json, text/javascript, */*; q=0.01')
      : 'HTML' === $a$$
      ? (this.acceptheader = 'text/html')
      : 'TEXT' === $a$$
      ? (this.acceptheader = 'text/*')
      : 'IMAGE' === $a$$
      ? (this.acceptheader = 'image/*')
      : 'BINARY' === $a$$ && (this.acceptheader = '*/*');
    if ('IMAGE' === $a$$ || 'BINARY' === $a$$) {
      this.xmlhttp.responseType = 'blob';
    }
  };
  GLANCE.Lib.Request.appendQueryStringParams = function ($url$$, $params$$) {
    return (
      $url$$ +
      '?' +
      Object.keys($params$$)
        .map(function ($key$$) {
          return $key$$ + '=' + $params$$[$key$$];
        })
        .join('&')
    );
  };
  GLANCE.Lib.Request.prototype.get = function (
    $url$$,
    $async$$,
    $withcred$$,
    $onsuccess$$,
    $onfailure$$
  ) {
    this.method = 'GET';
    this.post($url$$, null, $async$$, $withcred$$, $onsuccess$$, $onfailure$$);
  };
  GLANCE.Lib.Request.formUrlEncode = function ($obj$$) {
    var $str$$ = [],
      $p$$;
    for ($p$$ in $obj$$) {
      $obj$$.hasOwnProperty($p$$) &&
        $str$$.push(
          encodeURIComponent($p$$) + '=' + encodeURIComponent($obj$$[$p$$])
        );
    }
    return $str$$.join('&');
  };
  GLANCE.Lib.Request.prototype.post = function (
    $url$$,
    $obj$$,
    $async$$,
    $withcred$$,
    $contenttype_onsuccess$$,
    $onfailure$$
  ) {
    this.url = $url$$;
    this.onsuccess =
      void 0 !== $contenttype_onsuccess$$
        ? $contenttype_onsuccess$$
        : function () {};
    this.onfailure = void 0 !== $onfailure$$ ? $onfailure$$ : function () {};
    this.method = this.method || 'POST';
    if (this.ifproxy) {
      this.ifproxy.post(
        $url$$,
        $obj$$,
        $async$$,
        $withcred$$,
        $contenttype_onsuccess$$,
        $onfailure$$
      );
    } else {
      $contenttype_onsuccess$$ =
        this.contenttype ||
        ('JSON' === this.type
          ? 'application/json; charset=utf-8'
          : 'application/x-www-form-urlencoded; charset=utf-8');
      if ('string' === typeof $obj$$) {
        var $data$$ = $obj$$;
      } else {
        $obj$$ instanceof Blob
          ? (($contenttype_onsuccess$$ = $obj$$.type), ($data$$ = $obj$$))
          : $obj$$ &&
            ($data$$ =
              'JSON' === this.type
                ? GLANCE.Lib.JSONStringify($obj$$)
                : 'data=' + GLANCE.Lib.JSONStringify($obj$$));
      }
      var $self$$ = this;
      GLANCE.Lib.Browser.safari &&
        this.safaritimeout &&
        (this.requesttimeout = GLANCE.Lib.GElement.nativeMethod(
          window,
          'setTimeout',
          function () {
            GLANCE.Lib.log(
              this.method + ' to ' + this.url + ' failed - timedout (Safari)'
            );
            this.onfailure(!1, 'timedout');
          }.bind(this),
          this.safaritimeout
        ));
      this.xmlhttp.onreadystatechange = function () {
        $self$$.onreadystatechange();
      };
      try {
        this.xmlhttp.open(this.method, $url$$, $async$$),
          void 0 !== this.acceptheader &&
            this.xmlhttp.setRequestHeader('Accept', this.acceptheader),
          void 0 !== this.xmlhttp.setRequestHeader &&
            'GET' !== this.method &&
            this.xmlhttp.setRequestHeader(
              'Content-type',
              $contenttype_onsuccess$$
            ),
          this.authorizer && this.authorizer.gettoken()
            ? this.xmlhttp.setRequestHeader(
                'Authorization',
                'Bearer ' + this.authorizer.gettoken()
              )
            : this.authorizationToken &&
              this.xmlhttp.setRequestHeader(
                'Authorization',
                'Bearer ' + this.authorizationToken
              ),
          (this.xmlhttp.withCredentials = $withcred$$),
          this.xmlhttp.send($data$$);
      } catch ($err$$) {
        GLANCE.Lib.log(
          this.method + ' to ' + $url$$ + ' failed with: ' + $err$$.toString()
        ),
          this.onfailure(!1, $err$$.toString());
      }
    }
  };
  GLANCE.Lib.Request.IFrameProxyRequest = function ($type$$) {
    this.type = $type$$;
    GLANCE.Lib.Request.IFrameProxyRequest.currentRequest = this;
  };
  GLANCE.Lib.Request.IFrameProxyRequest.init = function ($webserver$$) {
    GLANCE.Lib.RequestProxy.init($webserver$$);
    GLANCE.Lib.Window.addEventListener(
      'message',
      GLANCE.Lib.Request.IFrameProxyRequest.handleMessage,
      !1
    );
  };
  GLANCE.Lib.Request.IFrameProxyRequest.prototype.post = function (
    $url$$,
    $obj$$,
    $async$$,
    $withcred$$,
    $onsuccess$$,
    $onfailure$$
  ) {
    this.onsuccess = $onsuccess$$;
    this.onfailure = $onfailure$$;
    GLANCE.Lib.RequestProxy.postMessage({
      from: 'IFrameProxyRequest',
      type: this.type,
      url: $url$$,
      obj: $obj$$,
      async: $async$$,
      withcred: $withcred$$,
    });
  };
  GLANCE.Lib.Request.IFrameProxyRequest.prototype.abort = function () {
    GLANCE.Lib.Request.IFrameProxyRequest.postMessage({
      from: 'IFrameProxyRequest',
      abort: !0,
    });
  };
  var _protect_ifproxyresp = { to: 0, success: 0, response: 0 };
  GLANCE.Lib.Request.IFrameProxyRequest.handleMessage = function ($e$$) {
    if (
      GLANCE.Lib.getDomain($e$$.origin) ===
        GLANCE.Lib.getDomain(GLANCE.Lib.RequestProxy.server) &&
      'undefined' != typeof $e$$.data.to &&
      'IFrameProxyRequest' == $e$$.data.to
    ) {
      if ($e$$.data.success) {
        GLANCE.Lib.Request.IFrameProxyRequest.currentRequest.onsuccess(
          $e$$.data.response
        );
      } else {
        GLANCE.Lib.Request.IFrameProxyRequest.currentRequest.onfailure();
      }
    }
  };
  GLANCE.Lib.Cookie = function ($cookiename$$, $cookiedomain$$) {
    this.name = $cookiename$$;
    this.domain = $cookiedomain$$ || new GLANCE.Lib.Page(window).getDomain();
  };
  GLANCE.Lib.Cookie.prototype.setObj = function ($obj$$, $secure$$) {
    var $date$$ = new Date();
    $date$$.setUTCHours($date$$.getUTCHours() + 8);
    document.cookie =
      this.name +
      '=' +
      escape(GLANCE.Lib.JSONStringify($obj$$)) +
      '; expires=' +
      $date$$.toGMTString() +
      '; domain=' +
      this.domain +
      '; path=/' +
      ($secure$$ || $obj$$.secure ? ';secure' : '');
  };
  GLANCE.Lib.Cookie.prototype.getObj = function () {
    var $cookieval$$ = this.get();
    return $cookieval$$ ? JSON.parse($cookieval$$) : null;
  };
  GLANCE.Lib.Cookie.prototype.get = function () {
    return this.exists()
      ? unescape(
          document.cookie.replace(
            new RegExp(
              '(?:^|.*;\\s*)' +
                escape(this.name).replace(/[\-\.\+\*]/g, '\\$&') +
                '\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*'
            ),
            '$1'
          )
        )
      : null;
  };
  GLANCE.Lib.Cookie.prototype.del = function () {
    var $date$$ = new Date();
    $date$$.setDate($date$$.getDate() - 1);
    document.cookie =
      escape(this.name) +
      '=; expires=' +
      $date$$.toGMTString() +
      '; domain=' +
      this.domain +
      '; path=/';
  };
  GLANCE.Lib.Cookie.prototype.exists = function () {
    return new RegExp(
      '(?:^|;\\s*)' +
        escape(this.name).replace(/[\-\.\+\*]/g, '\\$&') +
        '\\s*\\='
    ).test(document.cookie);
  };
  GLANCE.Lib.lsCookie = function ($name$$) {
    this.name = $name$$;
  };
  GLANCE.Lib.lsCookie.prototype.setObj = function ($obj$$) {
    var $date$$ = new Date();
    $date$$.setUTCHours($date$$.getUTCHours() + 8);
    localStorage.setItem(this.name, GLANCE.Lib.JSONStringify($obj$$));
    localStorage.setItem(this.name + '_exp', $date$$.toGMTString());
  };
  GLANCE.Lib.lsCookie.prototype.getObj = function () {
    if (!this.exists()) {
      return null;
    }
    var $val$$ = localStorage.getItem(this.name);
    return JSON.parse($val$$);
  };
  GLANCE.Lib.lsCookie.prototype.setExp = function ($expmins$$) {
    'string' === typeof $expmins$$ && ($expmins$$ = parseInt($expmins$$));
    var $date$$ = new Date();
    $date$$.setUTCMinutes($date$$.getUTCMinutes() + $expmins$$);
    localStorage.setItem(this.name + '_exp', $date$$.toGMTString());
  };
  GLANCE.Lib.lsCookie.prototype.get = function () {
    return this.exists() ? localStorage.getItem(this.name) : null;
  };
  GLANCE.Lib.lsCookie.prototype.del = function () {
    localStorage.removeItem(this.name);
    localStorage.removeItem(this.name + '_exp');
  };
  GLANCE.Lib.lsCookie.prototype.exists = function () {
    var $exp$$ = localStorage.getItem(this.name + '_exp');
    if (!$exp$$) {
      return !1;
    }
    $exp$$ = new Date($exp$$);
    return $exp$$ < new Date() ? (this.del(), !1) : !0;
  };
  GLANCE.Lib.DualCookie = function ($cookiename$$, $cookiedomain$$) {
    this.cookies = [
      new GLANCE.Lib.Cookie($cookiename$$, $cookiedomain$$),
      new GLANCE.Lib.lsCookie($cookiename$$),
    ];
  };
  GLANCE.Lib.DualCookie.prototype.setObj = function ($obj$$, $secure$$) {
    this.cookies[0].setObj($obj$$, $secure$$);
    this.cookies[1].setObj($obj$$, $secure$$);
  };
  GLANCE.Lib.DualCookie.prototype.getObj = function () {
    return this.cookies[0].getObj() || this.cookies[1].getObj();
  };
  GLANCE.Lib.DualCookie.prototype.get = function () {
    return this.cookies[0].get() || this.cookies[1].get();
  };
  GLANCE.Lib.DualCookie.prototype.del = function () {
    this.cookies[0].del();
    this.cookies[1].del();
  };
  GLANCE.Lib.DualCookie.prototype.exists = function () {
    return this.cookies[0].exists() || this.cookies[1].exists();
  };
  GLANCE.Lib.formatDocEvent = function ($params$$) {
    var $evt$$ = {};
    ['url', 'name', 'visitorselected', 'agentselected'].forEach(($key$$) => {
      $params$$.hasOwnProperty($key$$) && ($evt$$[$key$$] = $params$$[$key$$]);
    });
    return $evt$$;
  };
  GLANCE.Lib.parseSize = function (
    $size$$,
    $defaultw_parsed$$,
    $defaulth_result$$
  ) {
    $defaultw_parsed$$ = { w: $defaultw_parsed$$, h: $defaulth_result$$ };
    $size$$ &&
      ((($defaulth_result$$ = $size$$.match(/(\d+)x(\d+)/)) &&
        3 === $defaulth_result$$.length) ||
        GLANCE.Lib.log('ERR_INVALIDDIMS:' + $size$$),
      ($defaultw_parsed$$.w = $defaulth_result$$[1]),
      ($defaultw_parsed$$.h = $defaulth_result$$[2]));
    return $defaultw_parsed$$;
  };
  GLANCE.Lib.Event = function ($e$$) {
    this.event = $e$$ || window.event;
    this.client = { x: this.event.clientX, y: this.event.clientY };
  };
  GLANCE.Lib.toEvent = function ($e$$) {
    return new GLANCE.Lib.Event($e$$);
  };
  GLANCE.Lib.Event.fireHTMLEvent = function ($elem$$, $eventname$$) {
    if ('undefined' !== typeof CustomEvent) {
      try {
        var $evt$$ = new CustomEvent($eventname$$);
      } catch ($e$$) {}
    }
    $evt$$ ||
      (($evt$$ = document.createEvent('HTMLEvents')),
      $evt$$.initEvent($eventname$$, !0, !0));
    $elem$$.dispatchEvent($evt$$);
  };
  GLANCE.Lib.Event.fireKeyboardEvent = function (
    $elem$$,
    $e$jscomp$19_event$$
  ) {
    $e$jscomp$19_event$$ = new KeyboardEvent('keydown', {
      bubbles: !0,
      cancelable: !0,
      key: String.fromCharCode($e$jscomp$19_event$$.code),
      char: String.fromCharCode($e$jscomp$19_event$$.code),
      shiftKey: !1,
    });
    $elem$$.dispatchEvent($e$jscomp$19_event$$);
  };
  GLANCE.Lib.cssEscape = function ($elemid_sel$$) {
    function $escapeDigitChar$$($charCode_match$$, $offset$$, $string$$) {
      $charCode_match$$ = 48 + parseInt($charCode_match$$);
      return '\\' + GLANCE.Lib.pad($charCode_match$$.toString(16), '0', 6);
    }
    function $escapeChar$$($match$$, $offset$$, $string$$) {
      return '\\' + $match$$;
    }
    if ($elemid_sel$$) {
      return (
        ($elemid_sel$$ = $elemid_sel$$
          .trim()
          .replace(/[^\w\d-_]/g, $escapeChar$$)),
        /^\d/.test($elemid_sel$$) &&
          ($elemid_sel$$ = $elemid_sel$$.replace(/^\d/, $escapeDigitChar$$)),
        /^-/.test($elemid_sel$$) &&
          ($elemid_sel$$ = $elemid_sel$$.replace(/^-/, $escapeChar$$)),
        $elemid_sel$$
      );
    }
  };
  GLANCE.Lib.Page = function ($n$$) {
    this.doc = $n$$.document;
    this.wnd = $n$$;
    this.mouse = { x: -1, y: -1 };
    this.browser = GLANCE.Lib.Browser;
    var $vis$$ = [
      ['hidden', 'visibilitychange'],
      ['mozHidden', 'mozvisibilitychange'],
      ['webkitHidden', 'webkitvisibilitychange'],
      ['msHidden', 'msvisibilitychange'],
      ['oHidden', 'ovisibilitychange'],
    ];
    for ($n$$ = 0; $n$$ < $vis$$.length; $n$$++) {
      if ($vis$$[$n$$][0] in document) {
        this.HIDDENATTR = $vis$$[$n$$][0];
        this.VISCHANGEEVT = $vis$$[$n$$][1];
        break;
      }
    }
  };
  GLANCE.Lib.hostFromUrl = function ($spliturl_url$$) {
    var $parsed$$ = $spliturl_url$$;
    $spliturl_url$$ = $spliturl_url$$.split('?');
    1 < $spliturl_url$$.length && ($parsed$$ = $spliturl_url$$[0]);
    $parsed$$ = new RegExp(/(?:.*?:\/\/){0,1}([^\/:]+)/).exec($parsed$$);
    return null === $parsed$$ ||
      2 > $parsed$$.length ||
      0 > $parsed$$[1].indexOf('.')
      ? null
      : $parsed$$[1];
  };
  GLANCE.Lib.getDomain = function ($hostname$$) {
    var $regex$jscomp$2_results$$ = new RegExp(
        /^(?:[a-z]{1,5}:\/\/|)([^:\?\/]*)/
      ),
      $hostnameparts_isip$$ = $hostname$$.match(/^\d+\.\d+.\d+.\d+$/);
    $regex$jscomp$2_results$$ = $regex$jscomp$2_results$$.exec($hostname$$);
    if ($hostnameparts_isip$$) {
      return $hostname$$;
    }
    if (
      null === $regex$jscomp$2_results$$ ||
      2 !== $regex$jscomp$2_results$$.length
    ) {
      return (
        'about:' !== $hostname$$ &&
          GLANCE.Lib.log('ERR_DOMAINPARSE: ' + $hostname$$),
        null
      );
    }
    $hostnameparts_isip$$ = $regex$jscomp$2_results$$[1].split('.');
    return 1 === $hostnameparts_isip$$.length
      ? (GLANCE.Lib.log('ERR_DOMAINPARSE: ' + $hostname$$), null)
      : 2 === $hostnameparts_isip$$.length
      ? $hostnameparts_isip$$.join('.')
      : 3 === $hostnameparts_isip$$.length
      ? $hostnameparts_isip$$.slice(1).join('.')
      : 4 >= $hostnameparts_isip$$[$hostnameparts_isip$$.length - 2].length
      ? $hostnameparts_isip$$.slice($hostnameparts_isip$$.length - 3).join('.')
      : $hostnameparts_isip$$.slice($hostnameparts_isip$$.length - 2).join('.');
  };
  GLANCE.Lib.isAllowedOrigin = function ($origin$$, $alloweddomains$$) {
    var $match$$ = !1;
    $origin$$ = GLANCE.Lib.hostFromUrl($origin$$);
    if (null === $origin$$ || !$alloweddomains$$) {
      return !1;
    }
    $alloweddomains$$.forEach(function ($el$$, $index$$) {
      'object' === typeof $el$$ && ($el$$ = $el$$.domain);
      if (
        $origin$$.match(new RegExp('\\.' + $el$$ + '$', 'i')) ||
        $origin$$ === $el$$
      ) {
        $match$$ = { index: $index$$, domain: $el$$ };
      }
    });
    return $match$$;
  };
  GLANCE.Lib.Page.prototype.getStylesheet = function ($elem$$) {
    for (
      var $sheets$$ = this.doc.styleSheets, $i$$ = 0;
      $i$$ < $sheets$$.length;
      $i$$++
    ) {
      if (
        $sheets$$[$i$$].ownerNode &&
        $sheets$$[$i$$].ownerNode.getAttribute(GLANCE.Lib.Const.GID) ===
          $elem$$.getAttribute(GLANCE.Lib.Const.GID)
      ) {
        return $sheets$$[$i$$];
      }
    }
    return null;
  };
  GLANCE.Lib.Page.prototype.getURL = function () {
    return window.location.href.replace(/\?.*/g, '');
  };
  GLANCE.Lib.Page.prototype.getProto = function () {
    for (
      var $proto$$ = this.wnd.location.protocol, $wnd$$ = this.wnd;
      ('about:' === $proto$$ || 'javascript:' === $proto$$) &&
      $wnd$$.parent !== $wnd$$;

    ) {
      ($proto$$ = $wnd$$.parent.location.protocol), ($wnd$$ = $wnd$$.parent);
    }
    return $proto$$.replace(/:/g, '');
  };
  GLANCE.Lib.Page.prototype.isSrclessIframe = function () {
    return this.wnd.parent !== this.wnd && '' === this.wnd.location.hostname;
  };
  GLANCE.Lib.Page.prototype.getDomain = function () {
    for (
      var $hostname$$ = this.wnd.location.hostname, $wnd$$ = this.wnd;
      '' === $hostname$$ && $wnd$$.parent !== $wnd$$;

    ) {
      ($hostname$$ = $wnd$$.parent.location.hostname), ($wnd$$ = $wnd$$.parent);
    }
    return GLANCE.Lib.getDomain($hostname$$);
  };
  GLANCE.Lib.Page.prototype.inList = function ($list$$) {
    for (
      var $pageurl$$ = window.location.href.toLowerCase(), $n$$ = 0;
      $n$$ < $list$$.length;
      $n$$++
    ) {
      if (0 <= $pageurl$$.indexOf($list$$[$n$$].toLowerCase())) {
        return !0;
      }
    }
    return !1;
  };
  GLANCE.Lib.stringToBlob = function ($str$$, $type$$) {
    for (
      var $buf$$ = new ArrayBuffer($str$$.length),
        $bufView$$ = new Uint8Array($buf$$),
        $i$$ = 0,
        $strLen$$ = $str$$.length;
      $i$$ < $strLen$$;
      $i$$++
    ) {
      $bufView$$[$i$$] = $str$$.charCodeAt($i$$);
    }
    return new Blob([$buf$$], { type: $type$$ });
  };
  GLANCE.Lib.trapFocusInIframe = function () {
    ['first', 'last'].forEach(function ($whichitem$$) {
      let $item$$ = document.querySelector('.' + $whichitem$$ + 'control');
      $item$$ &&
        ($item$$.addEventListener('keydown', function ($e$$) {
          (('Tab' === $e$$.key && 'last' === $whichitem$$ && !$e$$.shiftKey) ||
            ('first' === $whichitem$$ && $e$$.shiftKey)) &&
            $e$$.preventDefault();
        }),
        'first' === $whichitem$$ && $item$$.focus());
    });
  };
  GLANCE.Lib.getScrollables = function ($elem$$) {
    function $getScrollableChildren$$($children$jscomp$2_elem$$) {
      if (
        ($children$jscomp$2_elem$$ = GLANCE.Lib.GElement.nativeGetProperty(
          'children',
          $children$jscomp$2_elem$$
        ))
      ) {
        for (var $n$$ = 0; $n$$ < $children$jscomp$2_elem$$.length; $n$$++) {
          GLANCE.Lib.toElem($children$jscomp$2_elem$$[$n$$]).isScrollable() &&
            $scrollables$$.push($children$jscomp$2_elem$$[$n$$]),
            $getScrollableChildren$$($children$jscomp$2_elem$$[$n$$]);
        }
      }
    }
    var $scrollables$$ = [];
    $getScrollableChildren$$($elem$$);
    return $scrollables$$;
  };
  GLANCE.Lib.Page.prototype.getElementsByTagName = function ($t$$) {
    return GLANCE.Lib.GElement.nativeMethod(
      this.doc,
      'getElementsByTagName',
      $t$$
    );
  };
  GLANCE.Lib.Page.prototype.isLinkToOtherDomain = function ($elem$$) {
    for (
      var $linkurl$$, $pagedomain$$ = this.getDomain();
      $elem$$ && !GLANCE.Lib.toElem($elem$$).isBody();

    ) {
      if ($elem$$ instanceof DocumentFragment) {
        $elem$$ = null;
        break;
      }
      if ('a' === $elem$$.tagName.toLowerCase()) {
        break;
      }
      $elem$$ = $elem$$.parentNode;
    }
    if (!$elem$$ || 'a' !== $elem$$.tagName.toLowerCase()) {
      return !1;
    }
    $linkurl$$ = $elem$$.href;
    $linkurl$$ = $linkurl$$.baseVal || $linkurl$$;
    var $nslashslash$$ = $linkurl$$.indexOf('//');
    if (0 > $nslashslash$$) {
      return !1;
    }
    0 === $nslashslash$$ && ($linkurl$$ = 'http:' + $linkurl$$);
    return $elem$$.hasAttribute('download') || $linkurl$$.startsWith('blob:')
      ? !1
      : GLANCE.Lib.getDomain($linkurl$$) !== $pagedomain$$;
  };
  GLANCE.Lib.Page.prototype.getUrlParam = function ($param$jscomp$7_results$$) {
    $param$jscomp$7_results$$ = new RegExp(
      '[\\?&]' + $param$jscomp$7_results$$ + '=([^&#]*)'
    ).exec(this.wnd.location.href);
    return null == $param$jscomp$7_results$$
      ? ''
      : $param$jscomp$7_results$$[1];
  };
  GLANCE.Lib.Page.prototype.addScriptAsync = async function ($params$$) {
    return new Promise(($resolve$$, $reject$$) => {
      var $script$$ = this.doc.createElement('script');
      $script$$.onload = $resolve$$;
      $script$$.onerror = $reject$$;
      for (const $attr$$ in $params$$) {
        $script$$.setAttribute($attr$$, $params$$[$attr$$]);
      }
      $script$$.setAttribute('charset', 'UTF-8');
      this.doc.head.appendChild($script$$);
    });
  };
  GLANCE.Lib.Page.prototype.addScript = function (
    $scriptattrs$$,
    $i$$,
    $onerror$$
  ) {
    var $script$$ = this.doc.createElement('script');
    $i$$ && $script$$.addEventListener('load', $i$$);
    $onerror$$ && $script$$.addEventListener('error', $onerror$$);
    $script$$.setAttribute('type', 'text/javascript');
    $script$$.setAttribute('charset', 'UTF-8');
    for ($i$$ = 0; $i$$ < $scriptattrs$$.length; $i$$++) {
      $script$$.setAttribute($scriptattrs$$[$i$$][0], $scriptattrs$$[$i$$][1]);
    }
    this.doc.head.appendChild($script$$);
    return $script$$;
  };
  GLANCE.Lib.Page.prototype.VSCROLL = 1;
  GLANCE.Lib.Page.prototype.HSCROLL = 2;
  GLANCE.Lib.Page.prototype.getScrollVisible = function ($which$$) {
    var $dims$$ = this.getDimensions(),
      $docdims$$ = this.getDocDimensions(),
      $cstyle$$ = GLANCE.Lib.Page.getComputedStyle(this.doc.body);
    if (null === $cstyle$$) {
      return !1;
    }
    var $overflowXY$$ =
      $which$$ === this.VSCROLL ? $cstyle$$.overflowY : $cstyle$$.overflowX;
    return (
      ($which$$ === this.VSCROLL ? $docdims$$.y : $docdims$$.x) >
        ($which$$ === this.VSCROLL ? $dims$$.y : $dims$$.x) &&
      ('visible' === $cstyle$$.overflow ||
        'visible' === $overflowXY$$ ||
        'auto' === $cstyle$$.overflow ||
        'auto' === $overflowXY$$ ||
        'scroll' === $overflowXY$$)
    );
  };
  GLANCE.Lib.Page.prototype.getElement = function ($id$$) {
    return GLANCE.Lib.GElement.nativeMethod(this.doc, 'getElementById', $id$$);
  };
  GLANCE.Lib.Page.prototype.trackMouse = function () {
    var $self$$ = this;
    this.onMouseMove = function ($e$jscomp$21_evt$$) {
      $e$jscomp$21_evt$$ = new GLANCE.Lib.Event($e$jscomp$21_evt$$);
      $self$$.mouse.x = $e$jscomp$21_evt$$.client.x || -1;
      $self$$.mouse.y = $e$jscomp$21_evt$$.client.y || -1;
      return !0;
    };
    this.onMouseOut = function ($e$$) {
      new GLANCE.Lib.Event($e$$);
      $self$$.mouse.x = -1;
      $self$$.mouse.y = -1;
      return !0;
    };
    this.addEventListener('mousemove', this.onMouseMove);
    this.addEventListener('mouseout', this.onMouseOut);
  };
  GLANCE.Lib.Page.prototype.stopTrackMouse = function () {
    this.doc.removeEventListener('mousemove', this.onMouseMove);
    this.doc.removeEventListener('mouseout', this.onMouseOut);
  };
  GLANCE.Lib.Page.prototype.trackMouseClick = function () {
    var $self$$ = this;
    this.clearMouseClick();
    this.onMouseClick = function ($e$jscomp$23_evt$$) {
      $e$jscomp$23_evt$$ = new GLANCE.Lib.Event($e$jscomp$23_evt$$);
      $self$$.click.x = $e$jscomp$23_evt$$.client.x || 0;
      $self$$.click.y = $e$jscomp$23_evt$$.client.y || 0;
      $self$$.click.ts = Date.now();
      return !0;
    };
    this.addEventListener('click', this.onMouseClick);
  };
  GLANCE.Lib.Page.prototype.stopTrackMouseClick = function () {
    this.doc.removeEventListener('click', this.onMouseClick);
  };
  GLANCE.Lib.Page.prototype.getMouse = function () {
    return this.getElemRelativeCoords(this.mouse);
  };
  GLANCE.Lib.Page.prototype.clearMouse = function () {
    this.mouse = { x: -1, y: -1 };
  };
  GLANCE.Lib.Page.prototype.getMouseClick = function () {
    var $click$$ = this.click;
    this.click = { x: -1, y: -1 };
    return this.getElemRelativeCoords($click$$);
  };
  GLANCE.Lib.Page.prototype.clearMouseClick = function () {
    this.click = { x: -1, y: -1 };
  };
  GLANCE.Lib.Page.prototype.isHidden = function () {
    return void 0 === this.HIDDENATTR ? !1 : this.doc[this.HIDDENATTR];
  };
  GLANCE.Lib.Page.prototype.onVisibilityChange = function ($onvischange$$) {
    this.doc.addEventListener(this.VISCHANGEEVT, $onvischange$$);
  };
  GLANCE.Lib.Page.prototype.getNonFixedElemNear = function (
    $coords$$,
    $axisname$$
  ) {
    function $isfixed$$($elem$$) {
      if (!$elem$$ || 'body' === $elem$$.tagName.toLowerCase()) {
        return !1;
      }
      let $posn$$ = GLANCE.Lib.Page.getComputedStyle($elem$$).position;
      return 'fixed' === $posn$$ || 'sticky' === $posn$$
        ? !0
        : $isfixed$$(
            GLANCE.Lib.GElement.nativeGetProperty('parentElement', $elem$$)
          );
    }
    var $elem$jscomp$0$$,
      $passes$$ = 0,
      $coordscopy$$ = {};
    for (
      GLANCE.Lib.Params.copy($coords$$, $coordscopy$$);
      ($elem$jscomp$0$$ = this.getElemAt($coordscopy$$)) &&
      $isfixed$$($elem$jscomp$0$$);

    ) {
      if (
        (scrolllog(
          'skipping fixed elem ' +
            $elem$jscomp$0$$.tagName +
            '  class=' +
            $elem$jscomp$0$$.getAttribute('class') +
            ' data-gid=' +
            $elem$jscomp$0$$.getAttribute(GLANCE.Lib.Const.GID) +
            ' at ' +
            JSON.stringify($coordscopy$$)
        ),
        ($coordscopy$$[$axisname$$] += 50),
        10 < $passes$$++)
      ) {
        return (
          scrolllog(
            'getNonFixedElemNear not finding a non fixed element, returning body'
          ),
          document.body
        );
      }
    }
    scrolllog(
      'getNonFixedElemNear found non-fixed elem ' +
        $elem$jscomp$0$$.tagName +
        '  class=' +
        $elem$jscomp$0$$.getAttribute('class') +
        ' data-gid=' +
        $elem$jscomp$0$$.getAttribute(GLANCE.Lib.Const.GID) +
        ' at ' +
        JSON.stringify($coordscopy$$)
    );
    return $elem$jscomp$0$$ || document.body;
  };
  GLANCE.Lib.Page.prototype.getElemAt = function ($coords$$) {
    $coords$$ = document.elementFromPoint($coords$$.x, $coords$$.y);
    null === $coords$$ && ($coords$$ = document.body);
    3 == $coords$$.nodeType && ($coords$$ = $coords$$.parentNode);
    return $coords$$;
  };
  GLANCE.Lib.Page.coordsOutside = function ($pos$$) {
    $pos$$ = $pos$$.client || $pos$$;
    return 0 > $pos$$.x || 0 > $pos$$.y;
  };
  GLANCE.Lib.Page.prototype.getElemRelativeCoords = function (
    $client$$,
    $page$$,
    $elem$$
  ) {
    if ($client$$ && (0 > $client$$.x || 0 > $client$$.y)) {
      return {
        client: { x: Math.round($client$$.x), y: Math.round($client$$.y) },
      };
    }
    $client$$ = $client$$ || this.pageToClientCoords($page$$);
    $page$$ = $page$$ || this.clientToPageCoords($client$$);
    $elem$$ = GLANCE.Lib.toElem(
      $elem$$
        ? this.getNonFixedElemNear($client$$, $elem$$)
        : this.getElemAt($client$$)
    );
    if (
      $elem$$.matches('#glance_session_widget *') ||
      $elem$$.matches('#glance_screensharepreview')
    ) {
      $elem$$ = GLANCE.Lib.toElem(
        document.getElementById('glance_session_widget')
      );
    }
    var $coords$$ = $elem$$.getCoords();
    return {
      client: { x: Math.round($client$$.x), y: Math.round($client$$.y) },
      relative: {
        x: Math.round($page$$.x - $coords$$.x),
        y: Math.round($page$$.y - $coords$$.y),
        element: $elem$$.getPath(),
      },
    };
  };
  GLANCE.Lib.Page.prototype.getElemRelativeOffset = function (
    $axisname$$,
    $offset$$
  ) {
    if (0 === $offset$$) {
      return { offset: 0 };
    }
    var $relative_scrollcoords$$ = this.getScrollCoords($axisname$$, $offset$$);
    $relative_scrollcoords$$ = this.getElemRelativeCoords(
      void 0,
      $relative_scrollcoords$$,
      $axisname$$
    ).relative;
    return {
      offset: $offset$$,
      relative: {
        element: $relative_scrollcoords$$.element,
        offset: $relative_scrollcoords$$[$axisname$$],
      },
    };
  };
  GLANCE.Lib.Page.prototype.relativeOffsetToPage = function (
    $axisname$$,
    $coords$jscomp$3_relative$$,
    $fallback$$
  ) {
    if (!$coords$jscomp$3_relative$$) {
      return $fallback$$;
    }
    var $relativecoords$$ = { element: $coords$jscomp$3_relative$$.element };
    $relativecoords$$[$axisname$$] = $coords$jscomp$3_relative$$.offset;
    $relativecoords$$['x' === $axisname$$ ? 'y' : 'x'] = 0;
    return ($coords$jscomp$3_relative$$ =
      this.relativeCoordsToPage($relativecoords$$))
      ? $coords$jscomp$3_relative$$[$axisname$$]
      : $fallback$$;
  };
  GLANCE.Lib.Page.prototype.relativeCoordsToClient = function (
    $coords$jscomp$4_relative$$,
    $fallbackClient$$
  ) {
    return ($coords$jscomp$4_relative$$ = this.relativeCoordsToPage(
      $coords$jscomp$4_relative$$
    ))
      ? this.pageToClientCoords($coords$jscomp$4_relative$$)
      : $fallbackClient$$;
  };
  GLANCE.Lib.Page.prototype.relativeCoordsToPage = function (
    $relative$$,
    $coords$$
  ) {
    var $el$$ = $relative$$
      ? GLANCE.Lib.toElem(this.doc.documentElement).getUniqueElement(
          $relative$$.element,
          !1
        )
      : null;
    if (null === $el$$) {
      return GLANCE.Lib.log('Element not found for relative coords'), $coords$$;
    }
    $coords$$ = GLANCE.Lib.toElem($el$$).getCoords();
    return { x: $coords$$.x + $relative$$.x, y: $coords$$.y + $relative$$.y };
  };
  GLANCE.Lib.Page.prototype.toAbsoluteUrls = function ($html$$, $proto$$) {
    var $p$$,
      $page$$ = this;
    return $html$$.replace(
      RegExp('url\\s*\\([\'"]?(\\s*(?!.*//.*).+?)[\'"]?\\)', 'g'),
      function ($match$$, $url$$) {
        '/' !== $url$$.charAt(0) &&
          ($p$$ = $page$$.getPath()) &&
          ($url$$ = $p$$ + $url$$);
        return 'url(' + $proto$$ + $page$$.wnd.location.host + $url$$ + ')';
      }
    );
  };
  GLANCE.Lib.Page.prototype.head = function () {
    return void 0 !== this.doc.head
      ? this.doc.head
      : this.getElementsByTagName('head')[0];
  };
  GLANCE.Lib.Page.prototype.cloneBody = function () {
    return GLANCE.Lib.toElem(this.doc.body).deepClone();
  };
  GLANCE.Lib.Page.prototype.cloneHead = function () {
    return this.doc.head.cloneNode(!0);
  };
  GLANCE.Lib.Page.prototype.addLoadListener = function ($listener$$) {
    this.wnd.addEventListener &&
      (document.readyState.match(/complete/)
        ? $listener$$()
        : (this.wnd.addEventListener('load', $listener$$),
          this.doc.addEventListener('DOMContentLoaded', $listener$$, !1)));
  };
  GLANCE.Lib.Page.prototype.getDocContainer = function () {
    return this.doc.compatMode && 'CSS1Compat' !== this.doc.compatMode
      ? this.doc.body
      : this.doc.documentElement;
  };
  GLANCE.Lib.Page.prototype.getDimensions = function () {
    if (void 0 !== window.orientation) {
      return { x: window.innerWidth, y: window.innerHeight };
    }
    var $container$$ = this.getDocContainer();
    return { x: $container$$.clientWidth, y: $container$$.clientHeight };
  };
  GLANCE.Lib.Page.prototype.getDocDimensions = function () {
    if (this.doc.width) {
      return { x: this.doc.width, y: this.doc.height };
    }
    var $container$$ = this.getDocContainer();
    return { x: $container$$.scrollWidth, y: $container$$.scrollHeight };
  };
  GLANCE.Lib.Page.prototype.getScrollInfo = function () {
    for (
      var $windims$$ = this.getDimensions(),
        $docdims$$ = this.getDocDimensions(),
        $dimensions$$ = ['x', 'y'],
        $dim$$,
        $scrolltabsz$$,
        $scrollbarsz$$,
        $scrollratio$$,
        $scrollinfo$$ = {},
        $i$$ = 0;
      $i$$ < $dimensions$$.length;
      $i$$++
    ) {
      ($dim$$ = $dimensions$$[$i$$]),
        ($scrolltabsz$$ = Math.round(
          Math.pow($windims$$[$dim$$], 2) / $docdims$$[$dim$$]
        )),
        ($scrollbarsz$$ = $windims$$[$dim$$] - 4),
        ($scrollratio$$ = 0),
        $docdims$$[$dim$$] > $windims$$[$dim$$] &&
          ($scrollratio$$ =
            ($scrollbarsz$$ - $scrolltabsz$$) /
            ($docdims$$[$dim$$] - $windims$$[$dim$$])),
        ($scrollratio$$ = Math.round(10000 * $scrollratio$$) / 10000),
        ($scrollinfo$$[$dim$$] = {
          tabsz: $scrolltabsz$$,
          ratio: $scrollratio$$,
        });
    }
    return $scrollinfo$$;
  };
  GLANCE.Lib.Page.prototype.getScroll = function () {
    if (void 0 !== window.pageXOffset) {
      return {
        x: Math.round(this.wnd.pageXOffset),
        y: Math.round(this.wnd.pageYOffset),
      };
    }
    if (void 0 !== document.documentElement.scrollTop) {
      return {
        x: this.doc.documentElement.scrollLeft,
        y: this.doc.documentElement.scrollTop,
      };
    }
    if (void 0 !== document.body.scrollLeft) {
      return { x: this.doc.body.scrollLeft, y: this.doc.body.scrollTop };
    }
    throw Error("Can't get page scroll");
  };
  GLANCE.Lib.Page.prototype.getScrollCoords = function (
    $axisname$$,
    $scrolloffset$$
  ) {
    var $windims$$ = this.getDimensions(),
      $pagescroll$$ = this.getScroll();
    return {
      x:
        'x' === $axisname$$
          ? $scrolloffset$$
          : $windims$$.x / 2 + $pagescroll$$.x,
      y:
        'y' === $axisname$$
          ? $scrolloffset$$
          : $windims$$.y / 2 + $pagescroll$$.y,
    };
  };
  GLANCE.Lib.Page.prototype.pageToClientCoords = function ($coords$$) {
    var $pagescroll$$ = this.getScroll();
    return {
      x: $coords$$.x - $pagescroll$$.x,
      y: $coords$$.y - $pagescroll$$.y,
    };
  };
  GLANCE.Lib.Page.prototype.clientToPageCoords = function ($coords$$) {
    var $pagescroll$$ = this.getScroll();
    return {
      x: $coords$$.x + $pagescroll$$.x,
      y: $coords$$.y + $pagescroll$$.y,
    };
  };
  GLANCE.Lib.Page.prototype.scrollTo = function (
    $direction$$,
    $offset$$,
    $smooth$$
  ) {
    var $scrollpos$$ = this.getScroll();
    $scrollpos$$[$direction$$] = $offset$$;
    $direction$$ = {
      left: $scrollpos$$.x,
      top: $scrollpos$$.y,
      behavior: $smooth$$ ? 'smooth' : 'auto',
    };
    GLANCE.Lib.Browser.ie11 || GLANCE.Lib.Browser.edge
      ? window.scrollTo($scrollpos$$.x, $scrollpos$$.y)
      : window.scrollTo($direction$$);
    scrolllog(
      'scrolled the page to:',
      $scrollpos$$,
      'new scroll position:',
      this.getScroll()
    );
  };
  GLANCE.Lib.Page.prototype.getPath = function () {
    var $pathname$$ = this.origPath(),
      $m$$ = $pathname$$.match(/(((.*?)\/)*)([^\/]+)/);
    return 0 > $pathname$$.indexOf('.') ? $pathname$$ : $m$$ ? $m$$[1] : null;
  };
  GLANCE.Lib.Page.prototype.getBasePath = function () {
    let $baseuri$$ = new URL(document.baseURI),
      $splitpath$$ = $baseuri$$.pathname.split('/');
    0 < $splitpath$$.slice(-1).indexOf('.') &&
      ($splitpath$$ = $splitpath$$.slice(0, -1));
    return $baseuri$$.origin + $splitpath$$.join('/');
  };
  GLANCE.Lib.Page.prototype.origPath = function () {
    return window.GLANCE.Cobrowse.Loader._origpath;
  };
  GLANCE.Lib.Page.prototype.pathChanged = function () {
    return (
      window === window.parent && window.location.pathname !== this.origPath()
    );
  };
  GLANCE.Lib.Page.getComputedStyle = function ($el$$, $pseudo$$) {
    return window.getComputedStyle($el$$, $pseudo$$);
  };
  GLANCE.Lib.Page.prototype.addEventListener = function (
    $type$$,
    $listener$$,
    $useCapture$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(
      this.doc,
      'addEventListener',
      $type$$,
      $listener$$,
      $useCapture$$
    );
  };
  GLANCE.Lib.Page.prototype.removeEventListener = function (
    $type$$,
    $listener$$,
    $useCapture$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(
      this.doc,
      'removeEventListener',
      $type$$,
      $listener$$,
      $useCapture$$
    );
  };
  GLANCE.Lib.errlog = function ($msg$$) {
    GlanceLogger.error($msg$$);
  };
  GLANCE.Lib.log = function ($msg$$) {
    GlanceLogger.log($msg$$);
  };
  GLANCE.Lib.moo = {
    extendElement: function ($mooelem$$) {
      $mooelem$$.playAnimation = function ($animclass$$, $clearafter$$) {
        window.clearTimeout($mooelem$$.timeout);
        $mooelem$$.removeClass($animclass$$);
        window.requestAnimationFrame(function ($time$$) {
          window.requestAnimationFrame(function ($time$$) {
            $mooelem$$.addClass($animclass$$);
            $mooelem$$.timeout = window.setTimeout(() => {
              $mooelem$$.removeClass('remoteclick');
            }, $clearafter$$);
          });
        });
      };
    },
  };
  GLANCE.Lib.GElement = function ($el$$) {
    this.element = $el$$;
  };
  GLANCE.Lib.toElem = function ($el$$) {
    return new GLANCE.Lib.GElement($el$$);
  };
  GLANCE.Lib.GElement.prototype.show = function ($show$$) {
    void 0 === $show$$ && ($show$$ = !0);
    this.element.className.match(
      new RegExp($show$$ ? 'glance_show' : 'glance_hide', 'g')
    ) ||
      (this.replaceClass(
        $show$$ ? 'glance_hide' : 'glance_show',
        $show$$ ? 'glance_show' : 'glance_hide'
      ),
      this.addClass($show$$ ? 'glance_show' : 'glance_hide'));
  };
  GLANCE.Lib.GElement.prototype.dummyOuterHTML = function () {
    var $idattr$$ = this.element.id ? ' id="' + this.element.id + '"' : '';
    return (
      '<meta ' +
      GLANCE.Lib.Const.GID +
      '="' +
      this.element.getAttribute(GLANCE.Lib.Const.GID) +
      '"' +
      $idattr$$ +
      '></meta>'
    );
  };
  GLANCE.Lib.GElement.prototype.addClass = function ($cls$$) {
    ('string' === typeof this.element.className &&
      this.element.className.match(new RegExp('\\b' + $cls$$ + '\\b', 'g'))) ||
      (this.element.className += ' ' + $cls$$);
  };
  GLANCE.Lib.GElement.prototype.removeClass = function ($cls$$) {
    this.element.className = this.element.className.replace(
      new RegExp('\\s+' + $cls$$, 'g'),
      ''
    );
  };
  GLANCE.Lib.GElement.prototype.replaceClass = function ($cold$$, $cnew$$) {
    this.element.className = this.element.className.replace(
      new RegExp($cold$$, 'g'),
      $cnew$$
    );
  };
  GLANCE.Lib.GElement.prototype.addEventListener = function (
    $type$$,
    $listener$$,
    $useCapture$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(
      this.element,
      'addEventListener',
      $listener$$,
      $useCapture$$
    );
  };
  GLANCE.Lib.GElement.prototype.removeEventListener = function (
    $type$$,
    $listener$$,
    $useCapture$$
  ) {
    GLANCE.Lib.GElement.nativeMethod(
      this.element,
      'removeEventListener',
      $listener$$,
      $useCapture$$
    );
  };
  GLANCE.Lib.GElement.prototype.isTextInput = function () {
    return (
      this.element.tagName.match(/^textarea$/i) ||
      this.element.type.match(
        /^(text|datetime|email|password|tel|url|number)$/i
      )
    );
  };
  GLANCE.Lib.GElement.prototype.isButtonInput = function () {
    return (
      this.element.tagName.match(/^input$/i) &&
      this.element.type.match(/^(radio|checkbox|button)$/i)
    );
  };
  GLANCE.Lib.GElement.prototype.hasNativeShadowRoot = function () {
    return (
      this.element.attachShadow == Element.prototype.attachShadow &&
      GLANCE.Lib.GElement.nativeGetProperty('shadowRoot', this.element)
    );
  };
  GLANCE.Lib.GElement.prototype.hasGIDlessDescendants = function () {
    for (
      var $descendants$$ = GLANCE.Lib.GElement.nativeMethod(
          this.element,
          'querySelectorAll',
          '*'
        ),
        $n$$ = 0;
      $n$$ < $descendants$$.length;
      $n$$++
    ) {
      if (!$descendants$$[$n$$].getAttribute(GLANCE.Lib.Const.GID)) {
        return !0;
      }
    }
    return !1;
  };
  GLANCE.Lib.GElement.prototype.simulateMouseEvent = function (
    $type$$,
    $properties$$
  ) {
    'click' === $type$$ &&
      this.element.tagName.match(/input|textarea/i) &&
      (this.element.focus(),
      this.isTextInput() &&
        'number' !== this.element.type &&
        (this.element.selectionStart = this.element.selectionEnd));
    if ('click' === $type$$ && void 0 !== this.element.click) {
      this.element.click();
    } else {
      void 0 === $properties$$ &&
        ($properties$$ = { view: window, bubbles: !0, cancelable: !0 });
      try {
        var $evt$$ = new MouseEvent($type$$, $properties$$);
      } catch ($e$$) {
        ($evt$$ = this.element.ownerDocument.createEvent('MouseEvents')),
          $evt$$.initMouseEvent(
            $type$$,
            !0,
            !0,
            this.element.ownerDocument.defaultView,
            1,
            0,
            0,
            0,
            0,
            !1,
            !1,
            !1,
            !1,
            1,
            null
          );
      }
      this.element.dispatchEvent($evt$$);
    }
  };
  GLANCE.Lib.GElement.nativeGetProperty = function ($propName$$, $element$$) {
    if (!GLANCE.Lib.GElement.USE_CLEANCONTEXT || 1 !== $element$$.nodeType) {
      return $element$$[$propName$$];
    }
    var $windowcontext$$ = GLANCE.Lib.GElement.USE_CLEANCONTEXT
      ? GLANCE.Lib.GElement.CleanContext
      : window;
    if (GLANCE.Lib.GElement.USE_CLEANCONTEXT) {
      try {
        var $elemproto_protoelem$$ = $windowcontext$$.document.createElement(
          $element$$.nodeName
        );
      } catch ($e$$) {
        $elemproto_protoelem$$ = $windowcontext$$.document.createElement('div');
      }
    } else {
      $elemproto_protoelem$$ = $element$$;
    }
    $elemproto_protoelem$$ = $windowcontext$$.Object.getPrototypeOf(
      $elemproto_protoelem$$
    );
    if (!$elemproto_protoelem$$) {
      return $element$$[$propName$$];
    }
    if ('contentWindow' === $propName$$) {
      return $windowcontext$$.Object.getOwnPropertyDescriptor(
        $elemproto_protoelem$$,
        $propName$$
      ).get.call($element$$);
    }
    for (
      var $pd$$;
      !($pd$$ = $windowcontext$$.Object.getOwnPropertyDescriptor(
        $elemproto_protoelem$$,
        $propName$$
      )) || 0 > $pd$$.get.toString().indexOf('[native code]');

    ) {
      if (
        (($elemproto_protoelem$$ = $windowcontext$$.Object.getPrototypeOf(
          $elemproto_protoelem$$
        )),
        !$elemproto_protoelem$$)
      ) {
        return $element$$[$propName$$];
      }
    }
    return $pd$$.get.call($element$$);
  };
  GLANCE.Lib.GElement.nativeMethod = function (
    $element$$,
    $methodName$$,
    ...$methodArgs$$
  ) {
    return GLANCE.Lib.GElement.USE_CLEANCONTEXT &&
      GLANCE.Lib.GElement.CleanContext &&
      $element$$.nodeType
      ? '#document' === $element$$.nodeName
        ? GLANCE.Lib.GElement.CleanContext.document[$methodName$$].apply(
            $element$$,
            $methodArgs$$
          )
        : '#document-fragment' === $element$$.nodeName
        ? GLANCE.Lib.GElement.CleanContext.DocumentFragment.prototype[
            $methodName$$
          ].apply($element$$, $methodArgs$$)
        : GLANCE.Lib.GElement.CleanContext.document.body[$methodName$$].apply(
            $element$$,
            $methodArgs$$
          )
      : GLANCE.Lib.GElement.USE_CLEANCONTEXT &&
        GLANCE.Lib.GElement.CleanContext &&
        '[object Window]' === $element$$.toString()
      ? GLANCE.Lib.GElement.CleanContext.window[$methodName$$].apply(
          $element$$,
          $methodArgs$$
        )
      : $element$$[$methodName$$].apply($element$$, $methodArgs$$);
  };
  GLANCE.Lib.GElement.getNativeMethod = function ($methodName$$, $element$$) {
    return GLANCE.Lib.GElement.USE_CLEANCONTEXT &&
      GLANCE.Lib.GElement.CleanContext &&
      GLANCE.Lib.GElement.CleanContext.document[$methodName$$]
      ? '#document' === $element$$.nodeName
        ? GLANCE.Lib.GElement.CleanContext.document[$methodName$$]
        : '#document-fragment' === $element$$.nodeName
        ? GLANCE.Lib.GElement.CleanContext.DocumentFragment.prototype[
            $methodName$$
          ]
        : GLANCE.Lib.GElement.CleanContext.document.body[$methodName$$]
      : GLANCE.Lib.GElement.USE_CLEANCONTEXT &&
        GLANCE.Lib.GElement.CleanContext &&
        '[object Window]' === $element$$.toString()
      ? GLANCE.Lib.GElement.CleanContext.window[$methodName$$]
      : $element$$[$methodName$$];
  };
  GLANCE.Lib.GElement.nativeInstance = function (
    $className$$,
    ...$classArguments$$
  ) {
    $className$$ = GLANCE.Lib.GElement.CleanContext.window[$className$$];
    return new (Function.bind.apply($className$$, [
      $className$$,
      ...$classArguments$$,
    ]))();
  };
  GLANCE.Lib.GElement.prototype.deepClone = function () {
    try {
      if (GLANCE.Lib.GElement.USE_CLEANCONTEXT) {
        if (GLANCE.Lib.GElement.CleanContext.clone) {
          var $clone$$ = GLANCE.Lib.GElement.CleanContext.clone(this.element);
        } else {
          diffslog(
            'clean context clone not loaded  cloning ' +
              this.element.gid +
              ' iframe:' +
              window.parent !==
              window
          ),
            ($clone$$ = GLANCE.Lib.GElement.nativeMethod(
              this.element,
              'cloneNode',
              !0
            ));
        }
      } else {
        $clone$$ = this.element.cloneNode(!0);
      }
      return $clone$$;
    } catch ($e$$) {
      GLANCE.Lib.log(
        'deepClone failed for ' +
          this.element.tagName +
          ' error:' +
          $e$$.message
      );
    }
    return this.element.cloneNode(!0);
  };
  GLANCE.Lib.GElement.prototype.isDescendantOf = function ($e$$) {
    return $e$$.contains
      ? GLANCE.Lib.Browser.ie11 && this.element.nodeType === Node.TEXT_NODE
        ? this.element.parentNode === $e$$ ||
          GLANCE.Lib.GElement.nativeMethod(
            $e$$,
            'contains',
            this.element.parentNode
          )
        : GLANCE.Lib.GElement.nativeMethod($e$$, 'contains', this.element)
      : !1;
  };
  GLANCE.Lib.GElement.prototype.remove = function () {
    this.element.parentNode &&
      this.element.parentNode.removeChild(this.element);
  };
  GLANCE.Lib.GElement.prototype.isScrollable = function () {
    if (!this.element) {
      return !1;
    }
    var $cs$$ = window.getComputedStyle(this.element);
    return null === $cs$$
      ? !1
      : ($cs$$.overflowX + $cs$$.overflowY).match(/scroll|auto/);
  };
  GLANCE.Lib.GElement.prototype.replaces = function ($oldelem$$) {
    this.element.parent.replaceChild(this.element, $oldelem$$);
  };
  GLANCE.Lib.GElement.prototype.empty = function () {
    for (; this.element.hasChildNodes(); ) {
      this.element.removeChild(this.element.childNodes[0]);
    }
  };
  GLANCE.Lib.GElement.prototype.getDimensions = function () {
    if (this.element.getBoundingClientRect) {
      var $bound$$ = this.element.getBoundingClientRect();
      return {
        width: Math.round($bound$$.right - $bound$$.left),
        height: Math.round($bound$$.bottom - $bound$$.top),
      };
    }
    return {
      width: this.element.offsetWidth,
      height: this.element.offsetHeight,
    };
  };
  GLANCE.Lib.GElement.prototype.setDimensions = function ($width$$, $height$$) {
    this.element.style.width = $width$$ + 'px';
    this.element.style.height = $height$$ + 'px';
  };
  GLANCE.Lib.GElement.prototype.isBody = function () {
    return /^(?:body|html)$/i.test(this.element.tagName);
  };
  GLANCE.Lib.GElement.prototype.isHead = function () {
    return /^(?:head)$/i.test(this.element.tagName);
  };
  GLANCE.Lib.GElement.prototype.isHeadOrHeadChild = function () {
    return this.isHead() || this.isDescendantOf(document.head);
  };
  GLANCE.Lib.GElement.prototype.getScrolls = function () {
    for (
      var $element$$ = this.element.parentNode, $position$$ = { x: 0, y: 0 };
      $element$$ && !GLANCE.Lib.toElem($element$$).isBody();

    ) {
      ($position$$.x += $element$$.scrollLeft),
        ($position$$.y += $element$$.scrollTop),
        ($element$$ = $element$$.parentNode);
    }
    return $position$$;
  };
  GLANCE.Lib.GElement.prototype.getCoords = function (
    $JSCompiler_temp$jscomp$4_cs$$
  ) {
    if (this.element.tagName.match(/html/i)) {
      return { x: 0, y: 0 };
    }
    var $bound$$ = this.element.getBoundingClientRect(),
      $html$$ = document.documentElement,
      $htmlScroll$$ = new GLANCE.Lib.Page(window).getScroll();
    if (($JSCompiler_temp$jscomp$4_cs$$ = !$JSCompiler_temp$jscomp$4_cs$$)) {
      ($JSCompiler_temp$jscomp$4_cs$$ = GLANCE.Lib.Page.getComputedStyle(
        this.element
      )),
        ($JSCompiler_temp$jscomp$4_cs$$ =
          'fixed' ===
          ($JSCompiler_temp$jscomp$4_cs$$
            ? $JSCompiler_temp$jscomp$4_cs$$.getPropertyValue('position')
            : ''));
    }
    return {
      x:
        parseInt($bound$$.left) +
        ($JSCompiler_temp$jscomp$4_cs$$ ? 0 : $htmlScroll$$.x) -
        $html$$.clientLeft,
      y:
        parseInt($bound$$.top) +
        ($JSCompiler_temp$jscomp$4_cs$$ ? 0 : $htmlScroll$$.y) -
        $html$$.clientTop,
    };
  };
  GLANCE.Lib.GElement.prototype.setCoords = function ($x$$, $y$$) {
    this.element.style.left = $x$$ + 'px';
    this.element.style.top = $y$$ + 'px';
  };
  GLANCE.Lib.GElement.prototype.positionAtZero = function () {
    if ('static' !== GLANCE.Lib.Page.getComputedStyle(document.body).position) {
      let $bodyoffset$$ = GLANCE.Lib.toElem(document.body).getCoords(!0);
      this.setCoords(-$bodyoffset$$.x, -$bodyoffset$$.y);
    } else {
      this.setCoords(0, 0);
    }
  };
  GLANCE.Lib.GElement.prototype.containsElemCoords = function ($elem$$) {
    var $thatcoords$$ = $elem$$.getCoords();
    $elem$$ = $elem$$.getDimensions();
    var $thiscoords$$ = this.getCoords(),
      $thisdims$$ = this.getDimensions();
    return !(
      $thatcoords$$.x + $elem$$.width > $thiscoords$$.x + $thisdims$$.width ||
      $thatcoords$$.x < $thiscoords$$.x ||
      $thatcoords$$.y + $elem$$.height > $thiscoords$$.y + $thisdims$$.height ||
      $thatcoords$$.y < $thiscoords$$.y
    );
  };
  GLANCE.Lib.GElement.prototype.pointInScrollbar = function ($pt$$) {
    if (!this.isScrollable()) {
      return !1;
    }
    var $bound$$ = this.element.getBoundingClientRect();
    return (
      ($pt$$.y > $bound$$.top &&
        $pt$$.y < $bound$$.bottom &&
        $pt$$.x > $bound$$.left + this.element.clientWidth &&
        $pt$$.x < $bound$$.right) ||
      ($pt$$.x > $bound$$.left &&
        $pt$$.x < $bound$$.right &&
        $pt$$.y > $bound$$.top + this.element.clientHeight &&
        $pt$$.y < $bound$$.bottom)
    );
  };
  GLANCE.Lib.GElement.prototype.moveTo = function ($x$$, $y$$) {
    function $move$$() {
      10 > $n$$++
        ? (($x1$$ += $dx$$),
          ($y1$$ += $dy$$),
          $self$$.setCoords(Math.floor($x1$$), Math.floor($y1$$)),
          ($self$$.movetimer = GLANCE.Lib.GElement.nativeMethod(
            window,
            'setTimeout',
            $move$$,
            20
          )))
        : $self$$.setCoords($x$$, $y$$);
    }
    void 0 !== this.movetimer &&
      GLANCE.Lib.GElement.nativeMethod(window, 'clearTimeout', this.movetimer);
    var $self$$ = this,
      $x1$$ = parseInt(this.element.style.left),
      $y1$$ = parseInt(this.element.style.top);
    isNaN($x1$$) && ($x1$$ = -999);
    isNaN($y1$$) && ($y1$$ = -999);
    var $n$$ = 0,
      $dx$$ = ($x$$ - $x1$$) / 10,
      $dy$$ = ($y$$ - $y1$$) / 10;
    (0 === $dx$$ && 0 === $dy$$) || $move$$();
  };
  GLANCE.Lib.GElement.prototype.cancelFade = function () {
    null != this.fadeStartTimer &&
      GLANCE.Lib.GElement.nativeMethod(
        window,
        'clearTimeout',
        this.fadeStartTimer
      );
    this.fadeStartTimer = null;
    this.fadeInterval &&
      GLANCE.Lib.GElement.nativeMethod(
        window,
        'clearInterval',
        this.fadeInterval
      );
    this.fadeInterval = null;
  };
  GLANCE.Lib.GElement.prototype.setOpacity = function ($n$$) {
    this.opacity = $n$$;
    this.element.style.opacity = this.opacity / 100;
    this.element.style.filter = 'alpha(opacity = ' + this.opacity + ')';
  };
  GLANCE.Lib.GElement.prototype.fade = function (
    $duration$$,
    $fadefunc$$,
    $fadecomplete$$
  ) {
    var $self$$ = this,
      $t$$ = new Date();
    null !== this.fadeInterval && this.cancelFade();
    this.fadeInterval = GLANCE.Lib.GElement.nativeMethod(
      window,
      'setInterval',
      function () {
        var $elapsed$$ = new Date() - $t$$;
        $elapsed$$ >= $duration$$
          ? ($self$$.setOpacity(0),
            $self$$.cancelFade(),
            $fadecomplete$$ && $fadecomplete$$())
          : $self$$.setOpacity(
              Math.max(0, $fadefunc$$($elapsed$$ / $duration$$))
            );
      },
      50
    );
  };
  GLANCE.Lib.GElement.prototype.getSelectorRelativeToParent = function () {
    var $sibling$$,
      $i$$ = 1,
      $tag$$ = this.tagNameLCase();
    for (
      $sibling$$ = this.element.previousElementSibling;
      null != $sibling$$;
      $sibling$$ = $sibling$$.previousElementSibling
    ) {
      $sibling$$.tagName.toLowerCase() === $tag$$ && $i$$++;
    }
    return GLANCE.Lib.cssEscape($tag$$) + ':nth-of-type(' + $i$$ + ')';
  };
  GLANCE.Lib.GElement.prototype.tagNameLCase = function () {
    return this.element == document
      ? 'document'
      : this.element.tagName.toLowerCase();
  };
  GLANCE.Lib.GElement.prototype.cssid = function () {
    var $elementid$$ = this.element.getAttribute('id');
    return $elementid$$ ? '#' + GLANCE.Lib.cssEscape($elementid$$) : void 0;
  };
  GLANCE.Lib.GElement.prototype.isSelectiveEditable = function () {
    return (
      !this.element.matches('.glance_masked') &&
      (this.element.matches('.glance_controllable') ||
        this.element.matches('.glance_controllable *'))
    );
  };
  GLANCE.Lib.GElement.prototype.getPath = function () {
    for (
      var $path$$ = [], $e$$ = this, $elemid$$;
      $e$$.element && $e$$.element.tagName;

    ) {
      if ($e$$.isBody() || $e$$.isHead()) {
        $path$$.unshift($e$$.tagNameLCase());
        break;
      }
      var $parentnode$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'parentNode',
        $e$$.element
      );
      if (null === $parentnode$$) {
        return null;
      }
      $elemid$$ = $e$$.cssid();
      if ($e$$.element.getAttribute(GLANCE.Lib.Const.GID)) {
        $path$$.unshift(
          '[' +
            GLANCE.Lib.Const.GID +
            '="' +
            $e$$.element.getAttribute(GLANCE.Lib.Const.GID) +
            '"]'
        );
        break;
      } else if (
        $elemid$$ &&
        1 === GLANCE.Lib.toElem($parentnode$$).getElements($elemid$$).length
      ) {
        if (
          ($path$$.unshift($elemid$$),
          1 ===
            GLANCE.Lib.toElem(document.documentElement).getElements($elemid$$)
              .length)
        ) {
          break;
        }
      } else {
        $path$$.unshift($e$$.getSelectorRelativeToParent());
      }
      $e$$ = GLANCE.Lib.toElem($parentnode$$);
    }
    return $path$$.join('>');
  };
  GLANCE.Lib.GElement.matchesShim =
    Element.prototype.matches ||
    Element.prototype.matchesSelector ||
    Element.prototype.msMatchesSelector;
  GLANCE.Lib.GElement.prototype.matches = function ($selector$$) {
    return GLANCE.Lib.GElement.matchesShim.call(this.element, $selector$$);
  };
  GLANCE.Lib.GElement.prototype.matchesAny = function ($selectorarray$$) {
    return (
      0 < $selectorarray$$.length && this.matches($selectorarray$$.join(','))
    );
  };
  GLANCE.Lib.GElement.prototype.getElements = function ($selector$$) {
    return GLANCE.Lib.GElement.nativeMethod(
      this.element,
      'querySelectorAll',
      $selector$$
    );
  };
  GLANCE.Lib.GElement.prototype.getShadowDOMElementPath = function (
    $sdidpath_selector$$
  ) {
    if (!$sdidpath_selector$$) {
      return null;
    }
    $sdidpath_selector$$ = $sdidpath_selector$$.replace(/'/g, '"');
    return ($sdidpath_selector$$ = $sdidpath_selector$$.match(
      new RegExp('\\[' + GLANCE.Lib.Const.GID + '="(.*-.*)"\\]')
    )) && 2 === $sdidpath_selector$$.length
      ? $sdidpath_selector$$[1]
      : null;
  };
  GLANCE.Lib.GElement.prototype.findElementInShadowDOM = function (
    $selector$$
  ) {
    function $followpath$$($doc$jscomp$8_elem$$, $sdidpath$$, $level$$) {
      if (null === $doc$jscomp$8_elem$$) {
        return (
          sdlog(
            'No shadow root at level ' +
              $level$$ +
              'for selector ' +
              $selector$$
          ),
          null
        );
      }
      var $shadowDOMElementSelector$$ =
        '[' +
        GLANCE.Lib.Const.GID +
        "='" +
        $sdidpath$$.slice(0, $level$$ + 1).join('-') +
        "']";
      $doc$jscomp$8_elem$$ = GLANCE.Lib.GElement.nativeMethod(
        $doc$jscomp$8_elem$$,
        'querySelector',
        $shadowDOMElementSelector$$
      );
      return $doc$jscomp$8_elem$$
        ? $level$$ === $sdidpath$$.length - 1
          ? $doc$jscomp$8_elem$$
          : $followpath$$(
              $doc$jscomp$8_elem$$.shadowRoot,
              $sdidpath$$,
              $level$$ + 1
            )
        : (sdlog('sdid ' + $shadowDOMElementSelector$$ + ' not found'), null);
    }
    var $sdidpath$jscomp$0$$ = this.getShadowDOMElementPath($selector$$);
    if (!$sdidpath$jscomp$0$$) {
      return null;
    }
    $sdidpath$jscomp$0$$ = $sdidpath$jscomp$0$$.split('-');
    return $followpath$$(this.element.ownerDocument, $sdidpath$jscomp$0$$, 0);
  };
  GLANCE.Lib.GElement.prototype.getUniqueElement = function (
    $selector$$,
    $throwonerror$$
  ) {
    function $reportError$$($msg$$) {
      if ($throwonerror$$) {
        throw Error($msg$$);
      }
      GLANCE.Lib.log($msg$$);
      return null;
    }
    if (this.element === document.documentElement && 'html' === $selector$$) {
      return this.element;
    }
    void 0 === $throwonerror$$ && ($throwonerror$$ = !0);
    var $ae_sdelem$$ = GLANCE.Lib.GElement.nativeMethod(
      this.element,
      'querySelectorAll',
      $selector$$
    );
    return 1 === $ae_sdelem$$.length
      ? $ae_sdelem$$[0]
      : 1 < $ae_sdelem$$.length
      ? $reportError$$('Nonunique selector: ' + $selector$$)
      : ($ae_sdelem$$ = this.findElementInShadowDOM($selector$$))
      ? $ae_sdelem$$
      : $reportError$$('Element not found: ' + $selector$$);
  };
  GLANCE.Lib.GElement.prototype.getInputValue = function (
    $inputval_maskstring$$
  ) {
    var $inputtype$$ =
      GLANCE.Lib.GElement.nativeGetProperty('type', this.element) || '';
    $inputval_maskstring$$ = {
      tag: GLANCE.Lib.GElement.nativeGetProperty('tagName', this.element),
      type: $inputtype$$,
      path: this.getPath(),
      id: GLANCE.Lib.GElement.nativeGetProperty('id', this.element),
      name: GLANCE.Lib.GElement.nativeGetProperty('name', this.element),
      sel: GLANCE.Lib.GElement.nativeGetProperty('selectedIndex', this.element),
      value:
        $inputval_maskstring$$ ||
        GLANCE.Lib.GElement.nativeGetProperty('value', this.element),
    };
    'string' === typeof $inputval_maskstring$$.value &&
      ($inputval_maskstring$$.value = $inputval_maskstring$$.value.replace(
        /<\/script>/gi,
        '<\\/script>'
      ));
    $inputtype$$.match(/^(radio|checkbox)$/i) &&
      ($inputval_maskstring$$.checked = this.element.checked);
    return $inputval_maskstring$$;
  };
  GLANCE.Lib.GElement.prototype.setInputValue = function ($inputvalue$$) {
    switch ($inputvalue$$.type.toLowerCase()) {
      case 'checkbox':
      case 'radio':
        this.element.checked = $inputvalue$$.checked;
        break;
      case 'select-one':
        this.element.selectedIndex = $inputvalue$$.sel;
        break;
      case 'file':
        break;
      default:
        'string' === typeof $inputvalue$$.value &&
          (this.element.value = $inputvalue$$.value.replace(
            '<\\/script>',
            '\x3c/script>'
          ));
    }
  };
  GLANCE.Lib.MessageHandlers = function () {
    this.handlers = {};
  };
  GLANCE.Lib.MessageHandlers.prototype.addHandler = function (
    $messageMatch$$,
    $callback$$
  ) {
    this.handlers['^' + $messageMatch$$ + '$'] = $callback$$;
  };
  GLANCE.Lib.MessageHandlers.prototype.dispatch = function ($msg$$) {
    var $self$$ = this,
      $name$$ = $msg$$.messageName;
    delete $msg$$.messageName;
    Object.keys(this.handlers).forEach(function ($messageMatch$$) {
      if (new RegExp($messageMatch$$).test($name$$)) {
        $self$$.handlers[$messageMatch$$]($name$$, $msg$$);
      }
    });
  };
  GLANCE.Lib.EventListeners = function () {
    this.listeners = this._listeners = {};
  };
  GLANCE.Lib.EventListeners.prototype.merge = function ($other$$) {
    $other$$ = $other$$.listeners;
    for (var $evt$$ in $other$$) {
      this._listeners[$evt$$] = (this._listeners[$evt$$] || []).concat(
        $other$$[$evt$$]
      );
    }
  };
  GLANCE.Lib.EventListeners.prototype.add = function ($evtname$$, $listener$$) {
    this._listeners[$evtname$$] = this._listeners[$evtname$$] || [];
    this._listeners[$evtname$$].push($listener$$);
  };
  GLANCE.Lib.EventListeners.prototype.remove = function (
    $evtname$jscomp$5_l$$,
    $listener$jscomp$76_n$$
  ) {
    $evtname$jscomp$5_l$$ = this._listeners[$evtname$jscomp$5_l$$];
    void 0 !== $evtname$jscomp$5_l$$ &&
      (($listener$jscomp$76_n$$ = $evtname$jscomp$5_l$$.indexOf(
        $listener$jscomp$76_n$$
      )),
      0 <= $listener$jscomp$76_n$$ &&
        $evtname$jscomp$5_l$$.splice($listener$jscomp$76_n$$, 1));
  };
  GLANCE.Lib.EventListeners.prototype.removeAll = function ($evtname$$) {
    this._listeners[$evtname$$] = [];
  };
  GLANCE.Lib.EventListeners.prototype.fire = function (
    $evtname$jscomp$7_n$$,
    $obj$$
  ) {
    eventslog(
      'fire ' +
        $evtname$jscomp$7_n$$ +
        ' ' +
        ($obj$$ ? JSON.stringify($obj$$) : '')
    );
    var $l$$ = this._listeners[$evtname$jscomp$7_n$$],
      $ret$$ = !0;
    if (void 0 === $l$$) {
      return !0;
    }
    for (
      $evtname$jscomp$7_n$$ = 0;
      $evtname$jscomp$7_n$$ < $l$$.length;
      $evtname$jscomp$7_n$$++
    ) {
      $l$$[$evtname$jscomp$7_n$$]($obj$$) || ($ret$$ = !1);
    }
    return $ret$$;
  };
  GLANCE.Lib.CssRuleString = function ($i$$) {
    function $escapeCSSSelector$$($match$$) {
      return $match$$.replace(/[\\]:/g, ':').replace(':', '\\:');
    }
    var $re$$ = new RegExp(/\[([^\[\]]*)\]/g);
    try {
      var $rulestring$$ = '',
        $csstext$$ = '',
        $ssrules$$ = $i$$.cssRules || $i$$.rules;
      for ($i$$ = 0; $i$$ < $ssrules$$.length; $i$$++) {
        ($csstext$$ = $ssrules$$[$i$$].cssText),
          ($csstext$$ = $csstext$$.replace($re$$, $escapeCSSSelector$$)),
          ($rulestring$$ += $csstext$$ + ' ');
      }
      return $rulestring$$;
    } catch ($e$$) {
      return (
        GLANCE.Lib.log(
          'Exception getting csstext for stylesheet:' + $e$$.toString()
        ),
        ''
      );
    }
  };
  GLANCE.Lib.DomDiff = function () {
    this.differences = [];
    this.htmlfilter = function () {
      return !0;
    };
    this.renderedhtmlfilter = function ($html$$) {
      return $html$$;
    };
    this.attrfilter = function ($elem$$, $attr$$) {
      return $elem$$.getAttribute($attr$$);
    };
    this.contentfilter = function () {
      return !0;
    };
    this.nogids = [];
  };
  GLANCE.Lib.DomDiff.prototype.setNoGids = function ($nogids$$) {
    this.nogids = $nogids$$;
  };
  GLANCE.Lib.DomDiff.prototype.removeGIDs = function ($elem$$) {
    delete $elem$$.gid;
    if (
      1 === $elem$$.nodeType &&
      ($elem$$.removeAttribute(GLANCE.Lib.Const.GID),
      $elem$$.removeAttribute(GLANCE.Lib.Const.SDID),
      $elem$$.removeAttribute(GLANCE.Lib.Const.GCID),
      GLANCE.Lib.GElement.nativeGetProperty('children', $elem$$))
    ) {
      for (
        var $n$$ = 0;
        $n$$ <
        GLANCE.Lib.GElement.nativeGetProperty('children', $elem$$).length;
        $n$$++
      ) {
        this.removeGIDs(
          GLANCE.Lib.GElement.nativeGetProperty('children', $elem$$)[$n$$]
        );
      }
      if (GLANCE.Lib.toElem($elem$$).hasNativeShadowRoot()) {
        for (
          $elem$$ = GLANCE.Lib.GElement.nativeGetProperty(
            'children',
            $elem$$.shadowRoot
          ),
            $n$$ = 0;
          $n$$ < $elem$$.length;
          $n$$++
        ) {
          this.removeGIDs($elem$$[$n$$]);
        }
      }
    }
  };
  GLANCE.Lib.DomDiff.prototype._assignGIDs = function ($elem$$, $sdidpath$$) {
    $sdidpath$$ = $sdidpath$$ || '';
    if (1 === $elem$$.nodeType) {
      if (this.gidless) {
        for (
          var $elemchildren$$ = 0;
          $elemchildren$$ < this.gidless.length;
          $elemchildren$$++
        ) {
          if (
            $elem$$ == this.gidless[$elemchildren$$] ||
            GLANCE.Lib.toElem($elem$$).isDescendantOf(
              this.gidless[$elemchildren$$]
            )
          ) {
            this.removeGIDs($elem$$);
            return;
          }
        }
      }
      $elem$$.gid ||
        (($elemchildren$$ = $sdidpath$$
          ? [$sdidpath$$, GLANCE.Lib.nextGID].join('-')
          : GLANCE.Lib.nextGID),
        ($elem$$.gid = $elemchildren$$),
        $elem$$.setAttribute(GLANCE.Lib.Const.GID, $elemchildren$$),
        'CANVAS' === $elem$$.tagName &&
          $elem$$.setAttribute(GLANCE.Lib.Const.GCID, $elemchildren$$),
        GLANCE.Lib.toElem($elem$$).hasNativeShadowRoot() &&
          $elem$$.setAttribute(GLANCE.Lib.Const.SDID, $elemchildren$$),
        GLANCE.Lib.nextGID++);
      $elemchildren$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'children',
        $elem$$
      );
      !$elemchildren$$ &&
        GLANCE.Lib.Browser.ie11 &&
        ($elemchildren$$ = GLANCE.Lib.GElement.nativeGetProperty(
          'childNodes',
          $elem$$
        ));
      if ($elemchildren$$) {
        for (var $n$$ = 0; $n$$ < $elemchildren$$.length; $n$$++) {
          this._assignGIDs($elemchildren$$[$n$$], $sdidpath$$);
        }
      }
      if (GLANCE.Lib.toElem($elem$$).hasNativeShadowRoot()) {
        for (
          $elemchildren$$ = GLANCE.Lib.getChildrenOrShadowChildren($elem$$),
            $n$$ = 0;
          $n$$ < $elemchildren$$.length;
          $n$$++
        ) {
          this._assignGIDs($elemchildren$$[$n$$], $elem$$.gid);
        }
      }
    }
  };
  GLANCE.Lib.DomDiff.prototype.assignGIDs = function ($elem$$, $sdid$$) {
    diffdetlog(
      'assignGIDs next GID:',
      GLANCE.Lib.nextGID,
      'current GID:',
      $elem$$.getAttribute(GLANCE.Lib.Const.GID),
      this.getPath($elem$$)
    );
    this.gidless =
      0 < this.nogids.length
        ? GLANCE.Lib.GElement.nativeMethod(
            document,
            'querySelectorAll',
            this.nogids.join(',')
          )
        : [];
    this._assignGIDs($elem$$, $sdid$$);
    delete this.gidless;
  };
  GLANCE.Lib.DomDiff.prototype.log = function ($s$$, $o$$) {};
  GLANCE.Lib.DomDiff.prototype.getPath = function ($e$$) {
    var $path$$ = GLANCE.Lib.toElem($e$$).getPath();
    return null === $path$$
      ? null
      : $e$$._idchanged && !/^(head|body)$/i.test($e$$.tagName)
      ? '[' +
        GLANCE.Lib.Const.GID +
        '="' +
        $e$$.getAttribute(GLANCE.Lib.Const.GID) +
        '"]'
      : $path$$;
  };
  GLANCE.Lib.DomDiff.prototype.diff = function ($d_elem1$$, $elem2$$) {
    this._diff($d_elem1$$, $elem2$$);
    $d_elem1$$ = this.differences;
    this.differences = [];
    return $d_elem1$$;
  };
  GLANCE.Lib.DomDiff.prototype.createDiffForDisabledChange = function (
    $elem$$,
    $attr$jscomp$5_path$$
  ) {
    $attr$jscomp$5_path$$ = this.getPath($elem$$);
    this.differences.push({
      diff: $elem$$.disabled ? 'SETATTR' : 'REMATTR',
      path: $attr$jscomp$5_path$$,
      attr: 'disabled',
      value: '',
    });
    diffslog(
      'ATTR diff: ' +
        GLANCE.Lib.JSONStringify(this.differences[this.differences.length - 1])
    );
    return this._returnMyDiffs();
  };
  GLANCE.Lib.DomDiff.prototype.createDiffsForStyleChange = function (
    $elem1$$,
    $elem2$$,
    $recursed$$
  ) {
    $elem1$$.getAttribute('style') === $elem2$$.getAttribute('style') ||
      $elem1$$.getAttribute('glance_cobrowse_suppress') ||
      this._addAttrDiffFromMutation($elem1$$, 'style');
    $elem1$$ = GLANCE.Lib.GElement.nativeGetProperty('children', $elem1$$);
    $elem2$$ = GLANCE.Lib.GElement.nativeGetProperty('children', $elem2$$);
    for (var $n$$ = 0; $elem1$$ && $n$$ < $elem1$$.length; $n$$++) {
      if (
        $n$$ < $elem2$$.length &&
        $elem1$$[$n$$].getAttribute(GLANCE.Lib.Const.GID) ===
          $elem2$$[$n$$].getAttribute(GLANCE.Lib.Const.GID)
      ) {
        this.createDiffsForStyleChange($elem1$$[$n$$], $elem2$$[$n$$], !0);
      } else {
        for (var $i$$ = 0; $i$$ < $elem2$$.length; $i$$++) {
          if (
            $elem2$$[$i$$].getAttribute(GLANCE.Lib.Const.GID) ===
            $elem1$$[$n$$].getAttribute(GLANCE.Lib.Const.GID)
          ) {
            this.createDiffsForStyleChange($elem1$$[$n$$], $elem2$$[$i$$], !0);
            break;
          }
        }
      }
    }
    if (void 0 === $recursed$$) {
      return this._returnMyDiffs();
    }
  };
  GLANCE.Lib.DomDiff.prototype._diff = function (
    $elem1$jscomp$2_elem1children$$,
    $elem2$jscomp$2_i$$
  ) {
    this._diffElemAttrs($elem1$jscomp$2_elem1children$$, $elem2$jscomp$2_i$$);
    if (
      !this._diffChildList(
        $elem1$jscomp$2_elem1children$$,
        $elem2$jscomp$2_i$$
      ) &&
      !this._diffNodeList($elem1$jscomp$2_elem1children$$, $elem2$jscomp$2_i$$)
    ) {
      $elem1$jscomp$2_elem1children$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'children',
        $elem1$jscomp$2_elem1children$$
      );
      var $elem2children$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'children',
        $elem2$jscomp$2_i$$
      );
      for (
        $elem2$jscomp$2_i$$ = 0;
        void 0 !== $elem1$jscomp$2_elem1children$$ &&
        $elem2$jscomp$2_i$$ < $elem1$jscomp$2_elem1children$$.length;
        $elem2$jscomp$2_i$$++
      ) {
        this._diff(
          $elem1$jscomp$2_elem1children$$[$elem2$jscomp$2_i$$],
          $elem2children$$[$elem2$jscomp$2_i$$]
        );
      }
    }
  };
  GLANCE.Lib.DomDiff.prototype.mergeDiffs = function ($src$$, $dest$$) {
    var $i$$, $j$$;
    for ($i$$ = 0; $i$$ < $src$$.length; $i$$++) {
      var $merged$$ = !1;
      switch ($src$$[$i$$].diff) {
        case 'CONTENT':
          for ($j$$ = 0; $j$$ < $dest$$.length; $j$$++) {
            if (
              $dest$$[$j$$].path === $src$$[$i$$].path &&
              $dest$$[$j$$].node === $src$$[$i$$].node
            ) {
              $dest$$[$j$$].data = $src$$[$i$$].data;
              $merged$$ = !0;
              break;
            }
          }
          break;
        case 'ATTR':
          for ($j$$ = 0; $j$$ < $dest$$.length; $j$$++) {
            if ($dest$$[$j$$].path === $src$$[$i$$].path) {
              $dest$$[$j$$].data = $src$$[$i$$].data;
              $merged$$ = !0;
              break;
            }
          }
          break;
        case 'SETATTR':
        case 'REMATTR':
          for ($j$$ = 0; $j$$ < $dest$$.length; $j$$++) {
            if (
              ('SETATTR' === $dest$$[$j$$].diff ||
                'REMATTR' === $dest$$[$j$$].diff) &&
              $dest$$[$j$$].path === $src$$[$i$$].path &&
              $dest$$[$j$$].attr === $src$$[$i$$].attr
            ) {
              $dest$$[$j$$] = $src$$[$i$$];
              $merged$$ = !0;
              break;
            }
          }
          break;
        case 'REPLACE':
          for ($j$$ = 0; $j$$ < $dest$$.length; $j$$++) {
            if (
              $dest$$[$j$$].path === $src$$[$i$$].path &&
              'REPLACE' === $dest$$[$j$$].diff
            ) {
              $dest$$[$j$$].data = $src$$[$i$$].data;
              $merged$$ = !0;
              break;
            }
          }
      }
      $merged$$ || $dest$$.push($src$$[$i$$]);
    }
  };
  GLANCE.Lib.DomDiff.prototype._diffElemAttrs = function ($elem1$$, $elem2$$) {
    var $i$$,
      $attrs1$$ = $elem1$$.attributes,
      $attrs2$$ = $elem2$$.attributes;
    $elem1$$.id !== $elem2$$.id && ($elem2$$._idchanged = !0);
    for ($i$$ = 0; $i$$ < $attrs1$$.length; $i$$++) {
      $attrs1$$.item($i$$).nodeName !== GLANCE.Lib.Const.GID &&
        $elem2$$.getAttribute($attrs1$$.item($i$$).nodeName) !=
          $attrs1$$.item($i$$).nodeValue &&
        this._addAttrDiffFromMutation($elem2$$, $attrs1$$.item($i$$).nodeName);
    }
    for ($i$$ = 0; $i$$ < $attrs2$$.length; $i$$++) {
      $attrs2$$.item($i$$).nodeName === GLANCE.Lib.Const.GID ||
        $elem1$$.getAttribute($attrs2$$.item($i$$).nodeName) ||
        this._addAttrDiffFromMutation($elem2$$, $attrs2$$.item($i$$).nodeName);
    }
  };
  GLANCE.Lib.DomDiff.prototype._diffNodeList = function ($elem1$$, $elem2$$) {
    var $elem1children$$ = GLANCE.Lib.GElement.nativeGetProperty(
      'children',
      $elem1$$
    );
    var $elem1childNodes_elem2children$$ =
      GLANCE.Lib.GElement.nativeGetProperty('children', $elem2$$);
    if (
      $elem1children$$ &&
      $elem1childNodes_elem2children$$ &&
      0 === $elem1children$$.length &&
      0 === $elem1childNodes_elem2children$$.length
    ) {
      return (
        $elem1$$.textContent !== $elem2$$.textContent &&
          this._addContentDiff($elem2$$),
        !0
      );
    }
    $elem1childNodes_elem2children$$ = GLANCE.Lib.GElement.nativeGetProperty(
      'childNodes',
      $elem1$$
    );
    let $elem2childNodes$$ = GLANCE.Lib.GElement.nativeGetProperty(
      'childNodes',
      $elem2$$
    );
    if ($elem1childNodes_elem2children$$.length !== $elem2childNodes$$.length) {
      return this._addHTMLDiff($elem2$$), !0;
    }
    for (var $i$$ = 0; $i$$ < $elem1childNodes_elem2children$$.length; $i$$++) {
      if (
        (($elem1$$ = $elem1childNodes_elem2children$$[$i$$]),
        ($elem1children$$ = $elem2childNodes$$[$i$$]),
        $elem1$$.nodeType !== $elem1children$$.nodeType ||
          $elem1$$.nodeValue !== $elem1children$$.nodeValue)
      ) {
        return this._addHTMLDiff($elem2$$), !0;
      }
    }
  };
  GLANCE.Lib.DomDiff.prototype._diffChildList = function (
    $elem1$jscomp$5_i$$,
    $elem2$$
  ) {
    let $elem1children$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'children',
        $elem1$jscomp$5_i$$
      ),
      $elem2children$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'children',
        $elem2$$
      );
    if (void 0 === $elem1children$$ || void 0 === $elem2children$$) {
      return (void 0 === $elem1children$$) !== (void 0 === $elem2children$$);
    }
    if ($elem1children$$.length != $elem2children$$.length) {
      return this._addHTMLDiff($elem2$$);
    }
    for (
      $elem1$jscomp$5_i$$ = 0;
      $elem1$jscomp$5_i$$ < $elem1children$$.length;
      $elem1$jscomp$5_i$$++
    ) {
      if (
        $elem1children$$[$elem1$jscomp$5_i$$].tagName !==
        $elem2children$$[$elem1$jscomp$5_i$$].tagName
      ) {
        return this._addHTMLDiff($elem2$$);
      }
    }
    return !1;
  };
  GLANCE.Lib.DomDiff.prototype._addAttrDiff = function ($elem$$) {
    var $i$$,
      $attrs$$ = {};
    for ($i$$ = 0; $i$$ < $elem$$.attributes.length; $i$$++) {
      this.attrfilter($elem$$, $elem$$.attributes[$i$$].name) &&
        ($attrs$$[$elem$$.attributes[$i$$].name] =
          $elem$$.attributes[$i$$].value);
    }
    diffslog(
      'ATTR diff: ' +
        this.getPath($elem$$) +
        ' ' +
        GLANCE.Lib.JSONStringify($attrs$$),
      $elem$$
    );
    this.differences.push({
      diff: 'ATTR',
      path: this.getPath($elem$$),
      data: $attrs$$,
    });
  };
  GLANCE.Lib.DomDiff.prototype.createMediaDiffs = function () {
    if (void 0 !== window.matchMedia) {
      for (
        var $linkels$$ = GLANCE.Lib.GElement.nativeMethod(
            document.head,
            'getElementsByTagName',
            'link'
          ),
          $n$$ = 0;
        $n$$ < $linkels$$.length;
        $n$$++
      ) {
        this.differences.push({
          diff: 'SETATTR',
          path: this.getPath($linkels$$[$n$$]),
          attr: 'media',
          value:
            '' === $linkels$$[$n$$].media ||
            window.matchMedia($linkels$$[$n$$].media).matches
              ? 'all'
              : 'none',
        });
      }
    }
    return this._returnMyDiffs();
  };
  GLANCE.Lib.DomDiff.prototype.createHTMLAttrDiff = function () {
    this._addAttrDiff(document.documentElement);
    return this._returnMyDiffs();
  };
  GLANCE.Lib.DomDiff.prototype._addAttrDiffFromMutation = function (
    $elem$$,
    $attr$$
  ) {
    var $path$$ = this.getPath($elem$$);
    if (null === $path$$) {
      diffslog(
        'Ignoring attr diff for ',
        $attr$$,
        '=',
        $elem$$.getAttribute($attr$$) + ' of elem ',
        $elem$$,
        ' not in DOM'
      );
    } else {
      var $attrval$$ = this.attrfilter($elem$$, $attr$$);
      !1 === $attrval$$
        ? diffslog(
            'Ignoring attr diff for ',
            $attr$$,
            '=',
            $elem$$.getAttribute($attr$$) + ' of elem ',
            $elem$$,
            ' filtered out'
          )
        : (this.differences.push({
            diff: $attrval$$ || '' === $attrval$$ ? 'SETATTR' : 'REMATTR',
            path: $path$$,
            attr: $attr$$,
            value: $attrval$$,
          }),
          diffslog(
            'ATTR diff: ' + $path$$ + ' ' + $attr$$ + ' ' + $attrval$$,
            $elem$$
          ));
    }
  };
  GLANCE.Lib.DomDiff.prototype.addContentDiff = function ($elem$$, $content$$) {
    var $path$$ = this.getPath($elem$$);
    null !== $path$$ &&
      (this.differences.push({
        diff: 'CONTENT',
        path: $path$$,
        data: $content$$,
      }),
      diffslog('CONTENT diff: ' + $path$$, $elem$$));
  };
  GLANCE.Lib.DomDiff.prototype._addContentDiff = function ($elem$$) {
    this.contentfilter($elem$$) &&
      (diffslog('CONTENT diff: ' + this.getPath($elem$$)),
      this.addContentDiff($elem$$, $elem$$.textContent));
  };
  GLANCE.Lib.getChildNodesOrShadowChildNodes = function ($el$$) {
    return GLANCE.Lib.toElem($el$$).hasNativeShadowRoot()
      ? GLANCE.Lib.GElement.nativeGetProperty(
          'childNodes',
          GLANCE.Lib.GElement.nativeGetProperty('shadowRoot', $el$$)
        )
      : GLANCE.Lib.GElement.nativeGetProperty('childNodes', $el$$);
  };
  GLANCE.Lib.getChildrenOrShadowChildren = function ($el$$) {
    return GLANCE.Lib.toElem($el$$).hasNativeShadowRoot()
      ? GLANCE.Lib.GElement.nativeGetProperty(
          'children',
          GLANCE.Lib.GElement.nativeGetProperty('shadowRoot', $el$$)
        )
      : GLANCE.Lib.GElement.nativeGetProperty('children', $el$$);
  };
  GLANCE.Lib.DomDiff.prototype._addContentDiffFromMutation = function (
    $node$$
  ) {
    var $n$$,
      $parent$$ = $node$$.parentNode;
    for (
      $n$$ = 0;
      $n$$ <
      GLANCE.Lib.GElement.nativeGetProperty('childNodes', $parent$$).length;
      $n$$++
    ) {
      if (
        GLANCE.Lib.GElement.nativeGetProperty('childNodes', $parent$$)[$n$$] ===
        $node$$
      ) {
        var $cn$$ = $n$$;
        break;
      }
    }
    void 0 === $cn$$
      ? GLANCE.Lib.log('Node not found in _addContentDiffFromMutation')
      : this.contentfilter($parent$$) &&
        (ShadowRoot &&
          $parent$$ instanceof ShadowRoot &&
          ($parent$$ = $parent$$.host),
        this.differences.push({
          diff: 'CONTENT',
          path: this.getPath($parent$$),
          data: $node$$.textContent,
          node: $cn$$,
        }),
        diffslog(
          'CONTENT diff: ' + this.getPath($parent$$),
          $node$$.textContent,
          $cn$$,
          'out of',
          GLANCE.Lib.GElement.nativeGetProperty('childNodes', $parent$$).length
        ));
  };
  GLANCE.Lib.DomDiff.prototype._addHTMLDiff = function ($elem$$) {
    diffslog('HTML diff: ' + this.getPath($elem$$));
    this.htmlfilter($elem$$);
    this.differences.push({
      diff: 'HTML',
      path: this.getPath($elem$$),
      data: this.renderedhtmlfilter($elem$$.innerHTML),
    });
    return !0;
  };
  GLANCE.Lib.DomDiff.prototype._getOuterHTML = function ($e$$) {
    var $newdiv_outerhtml$$ = GLANCE.Lib.GElement.nativeGetProperty(
      'outerHTML',
      $e$$
    );
    $newdiv_outerhtml$$ ||
      (($newdiv_outerhtml$$ = document.createElement('div')),
      $newdiv_outerhtml$$.appendChild($e$$),
      ($newdiv_outerhtml$$ = $newdiv_outerhtml$$.innerHTML));
    return this.renderedhtmlfilter($newdiv_outerhtml$$);
  };
  GLANCE.Lib.DomDiff.prototype._getElemHtml = function ($elem$$) {
    var $clone$$ = GLANCE.Lib.toElem($elem$$).deepClone();
    if (this.htmlfilter($elem$$, $clone$$)) {
      return this._getOuterHTML($clone$$);
    }
    diffslog('Ignoring filtered element of type: ' + $elem$$.tagName);
    return GLANCE.Lib.toElem($clone$$).dummyOuterHTML();
  };
  GLANCE.Lib.DomDiff.prototype._addChildOrderDiff = function (
    $children$jscomp$3_elem$$
  ) {
    var $path$$ = this.getPath($children$jscomp$3_elem$$);
    if ($path$$ && this.contentfilter($children$jscomp$3_elem$$)) {
      diffslog('CHILDORDER diff: ' + $path$$, $children$jscomp$3_elem$$);
      $children$jscomp$3_elem$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'childNodes',
        $children$jscomp$3_elem$$
      );
      for (
        var $data$$ = [], $i$$ = 0;
        $i$$ < $children$jscomp$3_elem$$.length;
        $i$$++
      ) {
        switch ($children$jscomp$3_elem$$[$i$$].nodeType) {
          case 1:
            $data$$.push({
              gid: $children$jscomp$3_elem$$[$i$$].getAttribute(
                GLANCE.Lib.Const.GID
              ),
            });
            break;
          case 3:
            $data$$.push({ text: $children$jscomp$3_elem$$[$i$$].textContent });
            break;
          case 8:
            $data$$.push({ comment: $children$jscomp$3_elem$$[$i$$].data });
        }
      }
      this.differences.push({
        diff: 'CHILDORDER',
        path: $path$$,
        data: $data$$,
      });
    }
  };
  GLANCE.Lib.DomDiff.prototype._addReplaceNodeDiff = function (
    $data$jscomp$87_elem$$
  ) {
    var $path$$ = this.getPath($data$jscomp$87_elem$$);
    if (
      $path$$ &&
      (1 !== $data$jscomp$87_elem$$.nodeType ||
        !$data$jscomp$87_elem$$.tagName.match(/textarea/i))
    ) {
      diffslog(
        'REPLACE diff: ' + $path$$,
        'gid:',
        $data$jscomp$87_elem$$.getAttribute(GLANCE.Lib.Const.GID),
        $data$jscomp$87_elem$$
      );
      $data$jscomp$87_elem$$.getAttribute(GLANCE.Lib.Const.GID) ||
        diffslog(
          'No gid for replace node diff on ' +
            this.getPath($data$jscomp$87_elem$$)
        );
      for (
        var $elemchildren$$ = GLANCE.Lib.GElement.nativeGetProperty(
            'children',
            $data$jscomp$87_elem$$
          ),
          $n$$ = 0;
        $elemchildren$$ && $n$$ < $elemchildren$$.length;
        $n$$++
      ) {
        this.assignGIDs($elemchildren$$[$n$$]);
      }
      ($data$jscomp$87_elem$$ = this._getElemHtml($data$jscomp$87_elem$$))
        ? (this.differences.push({
            diff: 'REPLACE',
            path: $path$$,
            data: $data$jscomp$87_elem$$,
          }),
          'html' !== $path$$ ||
            GLANCE.Lib.GElement.USE_CHILDORDER ||
            this._addReplaceNodeDiff(document.head),
          diffdetlog(this.differences.length + ' differences'))
        : diffslog('Ingoring filtered replace diff for ', $path$$);
    }
  };
  GLANCE.Lib.DomDiff.prototype._addChildListDiff = function ($mutation$$) {
    var $elem$$ = $mutation$$.target,
      $added$$ = $mutation$$._addedNodes,
      $removed$$ = $mutation$$._removedNodes,
      $nextSibling$$ = $mutation$$.nextSibling;
    $nextSibling$$ &&
      1 === $nextSibling$$.nodeType &&
      (GLANCE.Lib.toElem($nextSibling$$).isDescendantOf(
        document.documentElement
      ) &&
      GLANCE.Lib.GElement.nativeGetProperty('parentElement', $nextSibling$$) ===
        $elem$$
        ? $nextSibling$$.getAttribute(GLANCE.Lib.Const.GID) ||
          diffslog(
            'No data-gid for nextSibling. removedgid:',
            $nextSibling$$.removedgid
          )
        : (diffdetlog(
            'nextSibling not in dom or in different parent, not sending:',
            $nextSibling$$
          ),
          ($nextSibling$$ = null)));
    diffdetlog('CHILDLIST diff for element: ' + this.getPath($elem$$), $elem$$);
    var $n$jscomp$22_path$$ = this.getPath($elem$$);
    if (null !== $n$jscomp$22_path$$) {
      var $diff$$ = {
        diff: 'CHILDLIST',
        path: $n$jscomp$22_path$$,
        nsib: $nextSibling$$ && $added$$ ? this.getPath($nextSibling$$) : null,
        added: [],
        removed: [],
      };
      if ($added$$) {
        for (
          $n$jscomp$22_path$$ = 0;
          $n$jscomp$22_path$$ < $added$$.length;
          $n$jscomp$22_path$$++
        ) {
          if (!(0 <= $mutation$$.ignoreAdded.indexOf($n$jscomp$22_path$$))) {
            var $parentnode$$ = GLANCE.Lib.GElement.nativeGetProperty(
              'parentNode',
              $added$$[$n$jscomp$22_path$$]
            );
            if ($parentnode$$ !== $elem$$) {
              diffdetlog(
                '==> Ignoring add element no longer in same parent. gid=',
                $added$$[$n$jscomp$22_path$$].gid
              ),
                $parentnode$$ ||
                  (diffdetlog(
                    '==> Ignored add element no longer in dom, removing gid'
                  ),
                  delete $added$$[$n$jscomp$22_path$$].gid,
                  1 === $added$$[$n$jscomp$22_path$$].nodeType &&
                    $added$$[$n$jscomp$22_path$$].removeAttribute(
                      GLANCE.Lib.Const.GID
                    ));
            } else {
              if (1 === $added$$[$n$jscomp$22_path$$].nodeType) {
                this.assignGIDs($added$$[$n$jscomp$22_path$$]);
                var $value$$ = this._getElemHtml($added$$[$n$jscomp$22_path$$]);
                if (!$value$$) {
                  diffdetlog(
                    '==> Not adding filtered element:',
                    $added$$[$n$jscomp$22_path$$]
                  );
                  continue;
                }
                diffdetlog(
                  '==> Added element node gid=' +
                    $added$$[$n$jscomp$22_path$$].getAttribute(
                      GLANCE.Lib.Const.GID
                    ) +
                    ' before ' +
                    $diff$$.nsib,
                  $added$$[$n$jscomp$22_path$$],
                  'htmllength',
                  $value$$.length,
                  'html:',
                  $value$$.substr(0, 100)
                );
              } else if (3 === $added$$[$n$jscomp$22_path$$].nodeType) {
                ($value$$ = this.contentfilter($elem$$)
                  ? $added$$[$n$jscomp$22_path$$].nodeValue
                  : ''),
                  diffdetlog('==> added text node ', "'" + $value$$ + "'");
              } else if (8 === $added$$[$n$jscomp$22_path$$].nodeType) {
                ($value$$ = $added$$[$n$jscomp$22_path$$].nodeValue),
                  diffdetlog('==> added comment node ', "'" + $value$$ + "'");
              } else {
                diffdetlog(
                  '==> ignoring added node type ',
                  $added$$[$n$jscomp$22_path$$].nodeType
                );
                continue;
              }
              $diff$$.added.push({
                nodeType: $added$$[$n$jscomp$22_path$$].nodeType,
                tagName: $added$$[$n$jscomp$22_path$$].tagName,
                value: $value$$,
              });
            }
          }
        }
      }
      if ($removed$$) {
        for (
          $n$jscomp$22_path$$ = 0;
          $n$jscomp$22_path$$ < $removed$$.length;
          $n$jscomp$22_path$$++
        ) {
          if (!(0 <= $mutation$$.ignoreRemoved.indexOf($n$jscomp$22_path$$))) {
            switch ($removed$$[$n$jscomp$22_path$$].nodeType) {
              case 1:
                diffdetlog(
                  '==> Removed node gid=',
                  $removed$$[$n$jscomp$22_path$$].removedgid
                );
                $value$$ = $removed$$[$n$jscomp$22_path$$].removedgid;
                if (!$value$$) {
                  diffdetlog('==> Ignoring remove Element with no gid');
                  continue;
                }
                break;
              case 3:
                diffdetlog(
                  '==> removed text node with value ' +
                    $removed$$[$n$jscomp$22_path$$].nodeValue
                );
                $value$$ = $removed$$[$n$jscomp$22_path$$].nodeValue;
                break;
              default:
                GLANCE.Lib.log(
                  '==> Ignoring remove node type ' +
                    $removed$$[$n$jscomp$22_path$$].nodeType
                );
            }
            $diff$$.removed.push({
              nodeType: $removed$$[$n$jscomp$22_path$$].nodeType,
              value: $value$$,
            });
          }
        }
      }
      if (0 === $diff$$.removed.length && 0 === $diff$$.added.length) {
        return !1;
      }
      this.differences.push($diff$$);
      $nextSibling$$ &&
        8 === $nextSibling$$.nodeType &&
        (diffdetlog(
          'Found comment node as nextSibling, adding childorder diff',
          $elem$$
        ),
        this._addChildOrderDiff($elem$$));
      return !0;
    }
  };
  GLANCE.Lib.DomDiff.prototype._mergeMutations = function ($mutations$$) {
    function $addReplacedNodeMutation$$($target$$) {
      $mutations$$.push({ target: $target$$, type: 'replacedNode' });
    }
    function $addOrderFixingMutation$$($target$$) {
      if ($target$$ instanceof HTMLHtmlElement) {
        diffslog('No order fixing mutation needed for HTML element');
      } else {
        if (
          !$target$$.getAttribute(GLANCE.Lib.Const.GID) ||
          (!GLANCE.Lib.GElement.USE_CHILDORDER &&
            GLANCE.Lib.toElem($target$$).hasGIDlessDescendants())
        ) {
          $addReplacedNodeMutation$$($target$$);
        } else {
          a: {
            for (var $i$$ = 0; $i$$ < $childordermutations$$.length; $i$$++) {
              if ($childordermutations$$[$i$$].target === $target$$) {
                break a;
              }
            }
            $childordermutations$$.push({
              target: $target$$,
              type: 'childOrder',
            });
          }
        }
      }
    }
    function $hasConsecutiveTextNodes$$($elem$$) {
      $elem$$ = GLANCE.Lib.GElement.nativeGetProperty('childNodes', $elem$$);
      for (var $i$$ = 1; $i$$ < $elem$$.length; $i$$++) {
        if (
          $elem$$[$i$$].nodeType === $elem$$[$i$$ - 1].nodeType &&
          (3 === $elem$$[$i$$].nodeType || 8 === $elem$$[$i$$].nodeType)
        ) {
          return !0;
        }
      }
      return !1;
    }
    function $redundantAttributeMutation$$($mutation$$) {
      for (var $i$$ = 0; $i$$ < $mutations$$.length; $i$$++) {
        if (
          $mutations$$[$i$$] !== $mutation$$ &&
          'attributes' === $mutation$$.type &&
          'attributes' === $mutations$$[$i$$].type &&
          $mutation$$.target === $mutations$$[$i$$].target &&
          $mutation$$.attributeName === $mutations$$[$i$$].attributeName
        ) {
          return $mutation$$.target;
        }
      }
      return !1;
    }
    function $targetsDescendantOfAddedNode$$($mutation$$) {
      var $i$$,
        $j$$,
        $emutationtarget$$ = GLANCE.Lib.toElem($mutation$$.target);
      for ($i$$ = 0; $i$$ < $mutations$$.length; $i$$++) {
        if (
          $mutations$$[$i$$] !== $mutation$$ &&
          'childList' === $mutations$$[$i$$].type
        ) {
          for (
            $j$$ = 0;
            $mutations$$[$i$$]._addedNodes &&
            $j$$ < $mutations$$[$i$$]._addedNodes.length;
            $j$$++
          ) {
            if (
              $mutation$$.target === $mutations$$[$i$$]._addedNodes[$j$$] ||
              $emutationtarget$$.isDescendantOf(
                $mutations$$[$i$$]._addedNodes[$j$$]
              )
            ) {
              return $mutations$$[$i$$]._addedNodes[$j$$];
            }
          }
        }
      }
      return !1;
    }
    function $targetsDescendantOfReplacedNode$$($mutation$$) {
      var $i$$;
      for ($i$$ = 0; $i$$ < $mutations$$.length; $i$$++) {
        if (
          $mutations$$[$i$$] !== $mutation$$ &&
          'replacedNode' === $mutations$$[$i$$].type &&
          ($mutation$$.target === $mutations$$[$i$$].target ||
            GLANCE.Lib.toElem($mutation$$.target).isDescendantOf(
              $mutations$$[$i$$].target
            ))
        ) {
          return $mutations$$[$i$$].target;
        }
      }
      return !1;
    }
    var $self$$ = this,
      $headchanged_timer$$ = new GLANCE.Lib.Timer();
    $headchanged_timer$$.set();
    var $childordermutations$$ = [];
    diffslog('Merging ' + $mutations$$.length + ' mutations');
    if (500 < $mutations$$.length) {
      GLANCE.Lib.log('Mutation overflow');
      $headchanged_timer$$ = !1;
      for (
        var $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length && !$headchanged_timer$$;
        $i$jscomp$38_n$$++
      ) {
        if (
          $mutations$$[$i$jscomp$38_n$$].target === document.head ||
          GLANCE.Lib.GElement.nativeGetProperty(
            'parentElement',
            $mutations$$[$i$jscomp$38_n$$].target
          ) === document.head
        ) {
          $headchanged_timer$$ = !0;
        }
      }
      $mutations$$.length = 0;
      $headchanged_timer$$ && this._addReplaceNodeDiff(document.head);
      this._addReplaceNodeDiff(document.body);
    } else {
      $mutations$$.forEach(function ($mutation$$) {
        'attributes' === $mutation$$.type &&
          'id' === $mutation$$.attributeName &&
          $mutation$$.target.id &&
          ($mutation$$.target._idchanged = !0);
        'childList' === $mutation$$.type &&
          (($mutation$$.ignoreAdded = []), ($mutation$$.ignoreRemoved = []));
      });
      for (
        $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length;
        $i$jscomp$38_n$$++
      ) {
        var $iAdded_redundantto$$ = $targetsDescendantOfAddedNode$$(
            $mutations$$[$i$jscomp$38_n$$]
          ),
          $addedNode_parentelem$$ = GLANCE.Lib.GElement.nativeGetProperty(
            'parentElement',
            $mutations$$[$i$jscomp$38_n$$].target
          );
        $iAdded_redundantto$$
          ? (diffdetlog(
              'Ignoring redundant mutation ' +
                $mutations$$[$i$jscomp$38_n$$].type +
                ' to target ',
              $mutations$$[$i$jscomp$38_n$$].target.tagName,
              ' descendant of added node ',
              $iAdded_redundantto$$.tagName
            ),
            $mutations$$.splice($i$jscomp$38_n$$, 1),
            $i$jscomp$38_n$$--)
          : 'characterData' === $mutations$$[$i$jscomp$38_n$$].type &&
            $addedNode_parentelem$$ &&
            $hasConsecutiveTextNodes$$($addedNode_parentelem$$) &&
            (diffslog(
              'Using child order diff instead of content diff for',
              this.getPath($mutations$$[$i$jscomp$38_n$$].target),
              'due to consecutive text elements in parent',
              this.getPath($addedNode_parentelem$$)
            ),
            $addOrderFixingMutation$$($addedNode_parentelem$$),
            $mutations$$.splice($i$jscomp$38_n$$, 1),
            $i$jscomp$38_n$$--);
      }
      $mutations$$.forEach(function ($mutation$$) {
        if ('childList' === $mutation$$.type) {
          var $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$;
          a: {
            for (
              $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ = 0;
              $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ <
              $mutations$$.length;
              $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$++
            ) {
              if (
                $mutations$$[$JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$]
                  .target === $mutation$$.target &&
                'replacedNode' ===
                  $mutations$$[
                    $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$
                  ].type
              ) {
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ = !0;
                break a;
              }
            }
            $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ = !1;
          }
          if (!$JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$) {
            if (0 < $mutation$$._addedNodes.length) {
              for (
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ = 0;
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ <
                $mutations$$.length;
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$++
              ) {
                if (
                  'childList' ===
                    $mutations$$[
                      $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$
                    ].type &&
                  $mutations$$[
                    $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$
                  ].target === $mutation$$.target &&
                  0 <
                    $mutations$$[
                      $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$
                    ]._removedNodes.length
                ) {
                  diffslog(
                    'Creating order-fixing mutation for ' +
                      $self$$.getPath($mutation$$.target) +
                      ' due to adds and removes in child list'
                  );
                  $addOrderFixingMutation$$($mutation$$.target);
                  return;
                }
              }
            }
            if (
              $mutation$$.nextSibling &&
              3 === $mutation$$.nextSibling.nodeType
            ) {
              GLANCE.Lib.GElement.USE_CHILDORDER
                ? (diffslog(
                    'Creating order fixing mutation for ' +
                      $self$$.getPath($mutation$$.target) +
                      ' due to add before text node'
                  ),
                  $addOrderFixingMutation$$($mutation$$.target))
                : (diffslog(
                    'Creating replaceNode mutation for ' +
                      $self$$.getPath($mutation$$.target) +
                      ' due to add before text node'
                  ),
                  $addReplacedNodeMutation$$($mutation$$.target));
            } else {
              for (
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ = 0;
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$ <
                $mutation$$._removedNodes.length;
                $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$++
              ) {
                if (
                  3 ===
                  $mutation$$._removedNodes[
                    $JSCompiler_inline_result$jscomp$6_n$jscomp$25_n$$
                  ].nodeType
                ) {
                  diffslog(
                    'Creating replaceNode mutation for ' +
                      $self$$.getPath($mutation$$.target) +
                      ' due to remove text node'
                  );
                  $addReplacedNodeMutation$$($mutation$$.target);
                  break;
                }
              }
            }
          }
        }
      });
      for (
        $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length;
        $i$jscomp$38_n$$++
      ) {
        GLANCE.Lib.toElem($mutations$$[$i$jscomp$38_n$$].target).isDescendantOf(
          document.documentElement
        ) ||
          (diffdetlog(
            'Ignoring mutation type=',
            $mutations$$[$i$jscomp$38_n$$].type,
            ' to target ',
            $mutations$$[$i$jscomp$38_n$$].target,
            ' no longer in dom'
          ),
          $mutations$$.splice($i$jscomp$38_n$$, 1),
          $i$jscomp$38_n$$--);
      }
      for (
        $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length;
        $i$jscomp$38_n$$++
      ) {
        if (
          'childList' === $mutations$$[$i$jscomp$38_n$$].type &&
          0 !== $mutations$$[$i$jscomp$38_n$$]._addedNodes.length
        ) {
          for (
            $iAdded_redundantto$$ = 0;
            $iAdded_redundantto$$ <
            $mutations$$[$i$jscomp$38_n$$]._addedNodes.length;
            $iAdded_redundantto$$++
          ) {
            $addedNode_parentelem$$ =
              $mutations$$[$i$jscomp$38_n$$]._addedNodes[$iAdded_redundantto$$];
            for (
              var $nodeRemoved$$ = !1, $o$$ = $i$jscomp$38_n$$ + 1;
              !$nodeRemoved$$ && $o$$ < $mutations$$.length;
              $o$$++
            ) {
              if ('childList' === $mutations$$[$o$$].type) {
                for (
                  var $iRemoved$$ = 0;
                  $iRemoved$$ < $mutations$$[$o$$]._removedNodes.length;
                  $iRemoved$$++
                ) {
                  if (
                    $addedNode_parentelem$$ ===
                    $mutations$$[$o$$]._removedNodes[$iRemoved$$]
                  ) {
                    diffdetlog(
                      'Ignoring add and remove for same node: (',
                      $i$jscomp$38_n$$,
                      $iAdded_redundantto$$,
                      ') and (',
                      $o$$,
                      $iRemoved$$,
                      ') node:',
                      $addedNode_parentelem$$.tagName
                    );
                    $mutations$$[$i$jscomp$38_n$$].ignoreAdded.push(
                      $iAdded_redundantto$$
                    );
                    $mutations$$[$o$$].ignoreRemoved.push($iRemoved$$);
                    $nodeRemoved$$ = !0;
                    break;
                  }
                }
              }
            }
          }
        }
      }
      Array.prototype.push.apply($mutations$$, $childordermutations$$);
      for (
        $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length;
        $i$jscomp$38_n$$++
      ) {
        if (
          ($iAdded_redundantto$$ = $targetsDescendantOfReplacedNode$$(
            $mutations$$[$i$jscomp$38_n$$]
          ))
        ) {
          diffdetlog(
            'Ignoring redundant mutation ' +
              $mutations$$[$i$jscomp$38_n$$].type +
              ' to target ',
            $mutations$$[$i$jscomp$38_n$$].target.tagName,
            $mutations$$[$i$jscomp$38_n$$].target.gid,
            ' descendant of replaced node ',
            $iAdded_redundantto$$.tagName,
            $iAdded_redundantto$$.gid
          ),
            $mutations$$.splice($i$jscomp$38_n$$, 1),
            $i$jscomp$38_n$$--;
        }
      }
      for (
        $i$jscomp$38_n$$ = 0;
        $i$jscomp$38_n$$ < $mutations$$.length;
        $i$jscomp$38_n$$++
      ) {
        if (
          ($iAdded_redundantto$$ = $redundantAttributeMutation$$(
            $mutations$$[$i$jscomp$38_n$$]
          ))
        ) {
          diffdetlog(
            'Ignoring redundant attribute mutation ' +
              $mutations$$[$i$jscomp$38_n$$].attributeName +
              ' to target ' +
              this.getPath($iAdded_redundantto$$)
          ),
            $mutations$$.splice($i$jscomp$38_n$$, 1),
            $i$jscomp$38_n$$--;
        }
      }
      diffslog(
        'Merged mutations to:' +
          $mutations$$.length +
          ' in ' +
          $headchanged_timer$$.elapsed() +
          ' ms'
      );
    }
  };
  GLANCE.Lib.DomDiff.prototype._addDiffsFromMutationObserver = function (
    $mutations$$
  ) {
    var $self$$ = this;
    $mutations$$.forEach(function ($mutation$$) {
      if ('childList' === $mutation$$.type) {
        for (var $n$$ = 0; $n$$ < $mutation$$._removedNodes.length; $n$$++) {
          1 === $mutation$$._removedNodes[$n$$].nodeType &&
            ($mutation$$._removedNodes[$n$$].gid &&
              delete $mutation$$._removedNodes[$n$$].removedgid,
            $mutation$$._removedNodes[$n$$].gid &&
              (($mutation$$._removedNodes[$n$$].removedgid =
                $mutation$$._removedNodes[$n$$].gid),
              delete $mutation$$._removedNodes[$n$$].gid,
              $mutation$$._removedNodes[$n$$].removeAttribute(
                GLANCE.Lib.Const.GID
              )));
        }
      }
    });
    this._mergeMutations($mutations$$);
    $mutations$$.forEach(function ($mutation$$) {
      switch ($mutation$$.type) {
        case 'attributes':
          $self$$._addAttrDiffFromMutation(
            $mutation$$.target,
            $mutation$$.attributeName
          );
          break;
        case 'characterData':
          $self$$._addContentDiffFromMutation($mutation$$.target);
          break;
        case 'childList':
          $self$$._addChildListDiff($mutation$$);
          break;
        case 'replacedNode':
          $self$$._addReplaceNodeDiff($mutation$$.target);
          break;
        case 'childOrder':
          $self$$._addChildOrderDiff($mutation$$.target);
          break;
        default:
          GLANCE.Lib.log(
            'Unrecognized mutation record type ' + $mutation$$.type
          );
      }
    });
  };
  GLANCE.Lib.DomDiff.prototype.setHtmlFilter = function ($fn$$) {
    this.htmlfilter = $fn$$;
  };
  GLANCE.Lib.DomDiff.prototype.setRenderedHtmlFilter = function ($fn$$) {
    this.renderedhtmlfilter = $fn$$;
  };
  GLANCE.Lib.DomDiff.prototype.setAttrFilter = function ($fn$$) {
    this.attrfilter = $fn$$;
  };
  GLANCE.Lib.DomDiff.prototype.setContentFilter = function ($fn$$) {
    this.contentfilter = $fn$$;
  };
  GLANCE.Lib.DomDiff.prototype.diffsFromMutations = function ($mutations$$) {
    if (0 !== $mutations$$.length) {
      return (
        -1 !== $mutations$$[0].toString().indexOf('MutationRecord') &&
          this._addDiffsFromMutationObserver($mutations$$),
        diffslog('Got ' + this.differences.length + ' differences'),
        this._returnMyDiffs()
      );
    }
  };
  GLANCE.Lib.DomDiff.prototype._returnMyDiffs = function () {
    var $d$$ = this.differences;
    this.differences = [];
    return $d$$;
  };
  GLANCE.Lib.DomDiffApplier = function () {};
  GLANCE.Lib.DomDiffApplier.prototype._applyAttrDiff = function (
    $difference_i$$,
    $e$$
  ) {
    var $newattrs$$ = $difference_i$$.data,
      $oldattrs$$ = [];
    for (
      $difference_i$$ = 0;
      $difference_i$$ < $e$$.attributes.length;
      $difference_i$$++
    ) {
      $oldattrs$$.push($e$$.attributes[$difference_i$$].name);
    }
    for (
      $difference_i$$ = 0;
      $difference_i$$ < $oldattrs$$.length;
      $difference_i$$++
    ) {
      void 0 === $newattrs$$[$oldattrs$$[$difference_i$$]] &&
        (diffslog('   -' + $oldattrs$$[$difference_i$$]),
        $e$$.removeAttribute($oldattrs$$[$difference_i$$]));
    }
    for (var $attr$$ in $newattrs$$) {
      $newattrs$$.hasOwnProperty($attr$$) &&
        (diffslog('   +' + $attr$$ + '=' + $newattrs$$[$attr$$]),
        $e$$.setAttribute($attr$$, $newattrs$$[$attr$$]));
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype._hashHrefsToAbsolute = function (
    $element$$
  ) {
    $element$$ = ($element$$.parentElement || document.body).querySelectorAll(
      "svg [*|href^='#']"
    );
    for (
      var $pageurl$$ = window.location.href.replace(/#.*/, ''), $i$$ = 0;
      $i$$ < $element$$.length;
      $i$$++
    ) {
      var $hrefattr$$ =
        $element$$[$i$$].attributes.getNamedItem('href') ||
        $element$$[$i$$].attributes.getNamedItem('xlink:href');
      if ($hrefattr$$) {
        var $hrefval$$ = $hrefattr$$.value;
        diffslog(
          'Page-relative href to absolute. Element:',
          $element$$[$i$$],
          'namespace:',
          $hrefattr$$.namespaceURI,
          'href:',
          $pageurl$$ + $hrefval$$
        );
        $element$$[$i$$].attributes.removeNamedItem($hrefattr$$.name);
        $element$$[$i$$].setAttributeNS(
          $hrefattr$$.namespaceURI || 'http://www.w3.org/1999/xlink',
          'href',
          $pageurl$$ + $hrefval$$
        );
      } else {
        GLANCE.Lib.log('ERR_HREFNOTFOUND');
      }
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype._removeObjectUrlImages = function (
    $element$$
  ) {
    if (!GLANCE.Lib.Browser.ie) {
      $element$$ = ($element$$.parentElement || document.body).querySelectorAll(
        "svg image[*|href^='blob']"
      );
      for (var $i$$ = 0; $i$$ < $element$$.length; $i$$++) {
        var $image$$ = $element$$[$i$$];
        $image$$.href &&
          $image$$.href.baseVal &&
          ($image$$.href.baseVal =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAQSURBVBhXYziMA9Be4vBhAFKrW2mB3kkXAAAAAElFTkSuQmCC');
      }
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype.processAddedElem = function ($element$$) {
    this._hashHrefsToAbsolute($element$$);
    null !== document.getElementById('glance-pdf') &&
      this._removeObjectUrlImages($element$$);
  };
  GLANCE.Lib.DomDiffApplier.prototype._processAddedHeadElem = function (
    $basetag_basetagnext_html$$
  ) {
    var $doc$$ = GLANCE.Lib.GElement.nativeGetProperty(
      'childNodes',
      document.head
    );
    for (let $i$$ = 0; $i$$ < $doc$$.length; ) {
      document.head.removeChild($doc$$[$i$$]);
    }
    $doc$$ = document.implementation.createHTMLDocument('');
    $doc$$.head.outerHTML = $basetag_basetagnext_html$$;
    $basetag_basetagnext_html$$ = document.head.getElementsByTagName('BASE');
    for (
      $basetag_basetagnext_html$$ = ($basetag_basetagnext_html$$ =
        $basetag_basetagnext_html$$.length
          ? $basetag_basetagnext_html$$[0]
          : null)
        ? $basetag_basetagnext_html$$.nextSibling
        : null;
      0 < $doc$$.head.childNodes.length;

    ) {
      document.head.insertBefore(
        $doc$$.head.firstChild,
        $basetag_basetagnext_html$$
      );
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype._setOuterHTML = function ($e$$, $html$$) {
    $html$$ = $html$$
      .replace(/<script\s/gi, '<template ')
      .replace(/<script>/gi, '<template>')
      .replace(/\/script>/gi, '/template>');
    $html$$ = $html$$.replace(/http-equiv\s*=\s*['"]?refresh['"]?/gi, '');
    try {
      $e$$.outerHTML = $html$$;
    } catch ($ex$$) {
      GLANCE.Lib.errlog(
        'Exception setting outer HTML:' +
          $ex$$.toString() +
          ' for element:' +
          $e$$.toString() +
          ' to ' +
          $html$$.substr(0, 200)
      );
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype._applyChildOrderDiff = function (
    $j$jscomp$3_path$$,
    $target$$,
    $childlist$$
  ) {
    var $targetchildnodes$$ = GLANCE.Lib.GElement.nativeGetProperty(
        'childNodes',
        $target$$
      ),
      $i$$;
    if (/^(head|body)$/i.test($target$$.tagName)) {
      for ($i$$ = 0; $i$$ < $targetchildnodes$$.length; ) {
        1 !== $targetchildnodes$$[$i$$].nodeType ||
        $targetchildnodes$$[$i$$].getAttribute(GLANCE.Lib.Const.GID) ||
        'BASE' === $targetchildnodes$$[$i$$].tagName ||
        'glance_open_sel' === $targetchildnodes$$[$i$$].id
          ? $i$$++
          : (diffslog(
              'ChildOrder: Removing gidless ' +
                $targetchildnodes$$[$i$$].tagName +
                ' id:' +
                $targetchildnodes$$[$i$$].id +
                ' index:' +
                $i$$ +
                ' in ' +
                $j$jscomp$3_path$$
            ),
            $target$$.removeChild($targetchildnodes$$[$i$$]));
      }
    }
    for (
      $j$jscomp$3_path$$ = $i$$ = 0;
      $i$$ < $childlist$$.length;
      $i$$++, $j$jscomp$3_path$$++
    ) {
      if (
        (diffslog(
          'ChildOrder: Entry ' + $i$$ + '=' + JSON.stringify($childlist$$[$i$$])
        ),
        $childlist$$[$i$$])
      ) {
        if ($j$jscomp$3_path$$ >= $targetchildnodes$$.length) {
          diffslog('ChildOrder: Append empty text node'),
            $target$$.appendChild(document.createTextNode(''));
        } else {
          if (
            1 !== $targetchildnodes$$[$j$jscomp$3_path$$].nodeType ||
            $targetchildnodes$$[$j$jscomp$3_path$$].getAttribute(
              GLANCE.Lib.Const.GID
            )
          ) {
            if (void 0 !== $childlist$$[$i$$].text) {
              3 !== $targetchildnodes$$[$j$jscomp$3_path$$].nodeType
                ? (diffslog(
                    'ChildOrder: Inserting text node ' +
                      JSON.stringify($childlist$$[$i$$].text) +
                      ' at ' +
                      $j$jscomp$3_path$$
                  ),
                  $target$$.insertBefore(
                    document.createTextNode($childlist$$[$i$$].text),
                    $targetchildnodes$$[$j$jscomp$3_path$$]
                  ))
                : $targetchildnodes$$[$j$jscomp$3_path$$].textContent !==
                  $childlist$$[$i$$].text
                ? (diffslog(
                    'ChildOrder: Fixing up text ' +
                      JSON.stringify($childlist$$[$i$$].text) +
                      ' in node ' +
                      $j$jscomp$3_path$$
                  ),
                  ($targetchildnodes$$[$j$jscomp$3_path$$].textContent =
                    $childlist$$[$i$$].text))
                : diffslog(
                    'ChildOrder: Text ' +
                      JSON.stringify(
                        $targetchildnodes$$[$j$jscomp$3_path$$].textContent
                      ) +
                      ' correct in node ' +
                      $j$jscomp$3_path$$
                  );
            } else if (void 0 !== $childlist$$[$i$$].comment) {
              8 !== $targetchildnodes$$[$j$jscomp$3_path$$].nodeType &&
                (diffslog(
                  'ChildOrder: Adding comment node at ' + $j$jscomp$3_path$$
                ),
                $target$$.insertBefore(
                  document.createComment($childlist$$[$i$$].comment),
                  $targetchildnodes$$[$j$jscomp$3_path$$]
                ));
            } else {
              if (
                1 === $targetchildnodes$$[$j$jscomp$3_path$$].nodeType &&
                $targetchildnodes$$[$j$jscomp$3_path$$].getAttribute(
                  GLANCE.Lib.Const.GID
                ) === $childlist$$[$i$$].gid
              ) {
                diffslog(
                  'ChildOrder: Found ' +
                    $childlist$$[$i$$].gid +
                    ' in correct location at ' +
                    $j$jscomp$3_path$$
                );
              } else {
                diffslog(
                  'ChildOrder: Moving ' +
                    $childlist$$[$i$$].gid +
                    ' to correct location at ' +
                    $j$jscomp$3_path$$
                );
                var $e$$ = $target$$.querySelector(
                  "[data-gid='" + $childlist$$[$i$$].gid + "']"
                );
                $e$$
                  ? $target$$.insertBefore(
                      $e$$,
                      $targetchildnodes$$[$j$jscomp$3_path$$]
                    )
                  : (diffslog(
                      'ChildOrder: Element missing gid:' +
                        $childlist$$[$i$$].gid
                    ),
                    $j$jscomp$3_path$$--);
              }
            }
          } else {
            'BASE' !== $targetchildnodes$$[$j$jscomp$3_path$$].tagName &&
              errorlog(
                'ERR_MISSING_GID',
                $target$$.tagName,
                $target$$.id,
                $target$$.className
              ),
              $i$$--;
          }
        }
      }
    }
    for (; $j$jscomp$3_path$$ < $targetchildnodes$$.length; ) {
      3 === $targetchildnodes$$[$j$jscomp$3_path$$].nodeType
        ? $target$$.removeChild($targetchildnodes$$[$j$jscomp$3_path$$])
        : $j$jscomp$3_path$$++;
    }
  };
  GLANCE.Lib.DomDiffApplier.prototype.applyDiffs = function ($differences$$) {
    var $i$$,
      $doc$$ = GLANCE.Lib.toElem(document.documentElement),
      $replaced$$ = {};
    if (!$differences$$) {
      return $replaced$$;
    }
    diffslog('=== Applying Diffs ===');
    for ($i$$ = 0; $i$$ < $differences$$.length; $i$$++) {
      var $e$$ = $doc$$.getUniqueElement($differences$$[$i$$].path, !1);
      if (null === $e$$) {
        GLANCE.Lib.log(
          'Element not found applying diff: ' +
            $differences$$[$i$$].diff +
            ' to ' +
            $differences$$[$i$$].path
        );
      } else {
        switch (
          (diffslog(
            'Applying diff ' +
              $differences$$[$i$$].diff +
              ' to ' +
              $e$$.tagName +
              ' ' +
              $differences$$[$i$$].path
          ),
          $differences$$[$i$$].diff)
        ) {
          case 'ATTR':
            this._applyAttrDiff($differences$$[$i$$], $e$$);
            break;
          case 'SETATTR':
            diffslog(
              'SETATTR attr on: ' +
                $differences$$[$i$$].path +
                ' attr:' +
                $differences$$[$i$$].attr +
                ' value:' +
                $differences$$[$i$$].value
            );
            GLANCE.Lib.Browser.firefox &&
              'disabled' === $differences$$[$i$$].attr &&
              $e$$.tagName.match(/link/i) &&
              ($e$$.disabled = !0);
            'style' === $differences$$[$i$$].attr &&
              window.PrefixFree &&
              ($differences$$[$i$$].value +=
                ';' +
                PrefixFree.prefixCSS(
                  $differences$$[$i$$].value.replace(/-webkit-/, '')
                ));
            'class' === $differences$$[$i$$].attr
              ? $e$$.setAttribute('class', $differences$$[$i$$].value)
              : $e$$.setAttribute(
                  $differences$$[$i$$].attr,
                  $differences$$[$i$$].value
                );
            'CANVAS' === $e$$.tagName && ($replaced$$.canvas = !0);
            break;
          case 'REMATTR':
            diffslog(
              'REMATTR attr on: ' +
                $differences$$[$i$$].path +
                ' attr:' +
                $differences$$[$i$$].attr
            );
            GLANCE.Lib.Browser.firefox &&
              'disabled' === $differences$$[$i$$].attr &&
              $e$$.tagName.match(/link/i) &&
              ($e$$.disabled = !1);
            'class' === $differences$$[$i$$].attr
              ? $e$$.setAttribute('class', '')
              : $e$$.removeAttribute($differences$$[$i$$].attr);
            break;
          case 'CONTENT':
            0 === $differences$$[$i$$].node &&
              0 ===
                GLANCE.Lib.GElement.nativeGetProperty('childNodes', $e$$)
                  .length &&
              ($differences$$[$i$$].node = void 0);
            if (
              void 0 !== $differences$$[$i$$].node &&
              $differences$$[$i$$].node >=
                GLANCE.Lib.GElement.nativeGetProperty('childNodes', $e$$).length
            ) {
              GLANCE.Lib.log(
                'Child node out of range applying CONTENT diff to ' +
                  $differences$$[$i$$].path
              );
              break;
            }
            void 0 !== $differences$$[$i$$].node
              ? (GLANCE.Lib.GElement.nativeGetProperty('childNodes', $e$$)[
                  $differences$$[$i$$].node
                ].textContent = $differences$$[$i$$].data)
              : ($e$$.textContent = $differences$$[$i$$].data);
            break;
          case 'REPLACE':
            diffslog(
              'REPLACE ' +
                $differences$$[$i$$].path +
                ' with ' +
                $differences$$[$i$$].data.substr(0, 100)
            );
            if ($e$$ instanceof HTMLHtmlElement) {
              var $bodies_heads_j$jscomp$4_parsed$$ =
                new DOMParser().parseFromString(
                  $differences$$[$i$$].data,
                  'text/html'
                );
              $e$$.querySelector('body').innerHTML =
                $bodies_heads_j$jscomp$4_parsed$$.querySelector(
                  'body'
                ).innerHTML;
            } else {
              this._setOuterHTML($e$$, $differences$$[$i$$].data);
            }
            this.processAddedElem($e$$);
            /^(head|body|canvas)$/i.test($e$$.tagName) &&
              ($replaced$$[$e$$.tagName.toLowerCase()] = !0);
            0 < $e$$.getElementsByTagName('canvas').length &&
              ($replaced$$.canvas = !0);
            /^head$/i.test($e$$.tagName) &&
              (($bodies_heads_j$jscomp$4_parsed$$ =
                document.getElementsByTagName('body')),
              1 < $bodies_heads_j$jscomp$4_parsed$$.length &&
                0 ==
                  GLANCE.Lib.GElement.nativeGetProperty(
                    'children',
                    $bodies_heads_j$jscomp$4_parsed$$[0]
                  ).length &&
                document.documentElement.removeChild(
                  $bodies_heads_j$jscomp$4_parsed$$[0]
                ));
            /^body$/i.test($e$$.tagName) &&
              (($bodies_heads_j$jscomp$4_parsed$$ =
                document.getElementsByTagName('head')),
              1 < $bodies_heads_j$jscomp$4_parsed$$.length &&
                0 ==
                  GLANCE.Lib.GElement.nativeGetProperty(
                    'children',
                    $bodies_heads_j$jscomp$4_parsed$$[1]
                  ).length &&
                document.documentElement.removeChild(
                  $bodies_heads_j$jscomp$4_parsed$$[1]
                ));
            diffdetlog(
              '==> replaced element with gid:',
              $e$$.getAttribute(GLANCE.Lib.Const.GID)
            );
            break;
          case 'CHILDLIST':
            var $beforeelem_k_removedelem$$ = $differences$$[$i$$].nsib
              ? GLANCE.Lib.toElem($e$$).getUniqueElement(
                  $differences$$[$i$$].nsib,
                  !1
                )
              : null;
            for (
              $bodies_heads_j$jscomp$4_parsed$$ = 0;
              $bodies_heads_j$jscomp$4_parsed$$ <
              $differences$$[$i$$].added.length;
              $bodies_heads_j$jscomp$4_parsed$$++
            ) {
              switch (
                (diffslog(
                  'Adding node type: ' +
                    $differences$$[$i$$].added[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].nodeType +
                    ' to ' +
                    GLANCE.Lib.toElem($e$$).getPath()
                ),
                $differences$$[$i$$].added[$bodies_heads_j$jscomp$4_parsed$$]
                  .nodeType)
              ) {
                case 1:
                  if (
                    'HEAD' ===
                    $differences$$[$i$$].added[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].tagName
                  ) {
                    diffdetlog('Added HEAD element');
                    $replaced$$.head = !0;
                    this._processAddedHeadElem(
                      $differences$$[$i$$].added[
                        $bodies_heads_j$jscomp$4_parsed$$
                      ].value
                    );
                    break;
                  }
                  var $newelem$$ = document.createElement('x');
                  $e$$.insertBefore($newelem$$, $beforeelem_k_removedelem$$);
                  this._setOuterHTML(
                    $newelem$$,
                    $differences$$[$i$$].added[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].value
                  );
                  this.processAddedElem($newelem$$);
                  diffdetlog(
                    'Added node gid:',
                    $newelem$$.getAttribute(GLANCE.Lib.Const.GID)
                  );
                  break;
                case 3:
                  $newelem$$ = document.createTextNode(
                    $differences$$[$i$$].added[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].value
                  );
                  $e$$.insertBefore($newelem$$, $beforeelem_k_removedelem$$);
                  break;
                case 8:
                  $newelem$$ = document.createComment(
                    $differences$$[$i$$].added[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].value
                  );
                  $e$$.insertBefore($newelem$$, $beforeelem_k_removedelem$$);
                  break;
                default:
                  GLANCE.Lib.errlog(
                    'Unexpected node type ' +
                      $differences$$[$i$$].added[
                        $bodies_heads_j$jscomp$4_parsed$$
                      ].nodeType +
                      ' added in applyDiffs'
                  );
              }
            }
            for (
              $bodies_heads_j$jscomp$4_parsed$$ = 0;
              $bodies_heads_j$jscomp$4_parsed$$ <
              $differences$$[$i$$].removed.length;
              $bodies_heads_j$jscomp$4_parsed$$++
            ) {
              switch (
                (diffslog(
                  'Removing node type: ' +
                    $differences$$[$i$$].removed[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].nodeType +
                    ' value ' +
                    $differences$$[$i$$].removed[
                      $bodies_heads_j$jscomp$4_parsed$$
                    ].value
                ),
                $differences$$[$i$$].removed[$bodies_heads_j$jscomp$4_parsed$$]
                  .nodeType)
              ) {
                case 1:
                  $beforeelem_k_removedelem$$ = GLANCE.Lib.toElem(
                    $e$$
                  ).getElements(
                    '[' +
                      GLANCE.Lib.Const.GID +
                      '="' +
                      $differences$$[$i$$].removed[
                        $bodies_heads_j$jscomp$4_parsed$$
                      ].value +
                      '"]'
                  );
                  if (
                    0 === $beforeelem_k_removedelem$$.length ||
                    (GLANCE.Lib.GElement.nativeGetProperty(
                      'parentElement',
                      $beforeelem_k_removedelem$$[0]
                    ) !== $e$$ &&
                      $beforeelem_k_removedelem$$[0].parentNode !== $e$$)
                  ) {
                    diffslog(
                      'Ignoring removed Element gid ' +
                        $differences$$[$i$$].removed[
                          $bodies_heads_j$jscomp$4_parsed$$
                        ].value +
                        ' not in parent'
                    );
                    break;
                  }
                  $e$$.removeChild($beforeelem_k_removedelem$$[0]);
                  break;
                case 3:
                  for (
                    $beforeelem_k_removedelem$$ = 0;
                    $beforeelem_k_removedelem$$ < $e$$.childNodes.length;
                    $beforeelem_k_removedelem$$++
                  ) {
                    if (
                      3 ===
                        $e$$.childNodes[$beforeelem_k_removedelem$$].nodeType &&
                      $e$$.childNodes[$beforeelem_k_removedelem$$].nodeValue ===
                        $differences$$[$i$$].removed[
                          $bodies_heads_j$jscomp$4_parsed$$
                        ].value
                    ) {
                      $e$$.removeChild(
                        $e$$.childNodes[$beforeelem_k_removedelem$$]
                      );
                      break;
                    }
                  }
              }
            }
            break;
          case 'CHILDORDER':
            /^(head|body)$/i.test($e$$.tagName) &&
              ($replaced$$[$e$$.tagName.toLowerCase()] = !0);
            this._applyChildOrderDiff(
              $differences$$[$i$$].path,
              $e$$,
              $differences$$[$i$$].data
            );
            break;
          case 'HTML':
            ($e$$.innerHTML = $differences$$[$i$$].data),
              this.processAddedElem($e$$);
        }
      }
    }
    return $replaced$$;
  };
  var _GLANCE = _GLANCE || {};
  _GLANCE.Config = {};
  _GLANCE.Config.Params = {};
  _GLANCE.Config.Params.copy = function ($from$$, $to$$, $whichparams$$) {
    if (void 0 !== $from$$) {
      return (
        ($whichparams$$ = $whichparams$$ || Object.keys($from$$)),
        $whichparams$$.forEach(function ($p$$) {
          void 0 !== $from$$[$p$$] && ($to$$[$p$$] = $from$$[$p$$]);
        }),
        $to$$
      );
    }
  };
  _GLANCE.Config.Params.getDataAttrs = function ($attrs$jscomp$1_elem$$) {
    var $params$$ = {};
    if (!$attrs$jscomp$1_elem$$) {
      return $params$$;
    }
    var $i$$ = 0;
    for (
      $attrs$jscomp$1_elem$$ = $attrs$jscomp$1_elem$$.attributes;
      $i$$ < $attrs$jscomp$1_elem$$.length;
      $i$$++
    ) {
      var $result$$ = $attrs$jscomp$1_elem$$[$i$$].nodeName.match(/data-(.*)/);
      $result$$ &&
        2 === $result$$.length &&
        ($params$$[$result$$[1]] = $attrs$jscomp$1_elem$$[$i$$].nodeValue);
    }
    return $params$$;
  };
  _GLANCE.Config.getCobrowseConfigData = function () {
    var $configdata$$ = window.GLANCE_COBROWSE ? window.GLANCE_COBROWSE : {},
      $elem1$$ = document.getElementById('cobrowsescript'),
      $elem2$$ = document.getElementById('glance-cobrowse');
    $elem1$$ = _GLANCE.Config.Params.getDataAttrs($elem1$$);
    $elem2$$ = _GLANCE.Config.Params.getDataAttrs($elem2$$);
    _GLANCE.Config.Params.copy($elem1$$, $configdata$$);
    _GLANCE.Config.Params.copy($elem2$$, $configdata$$);
    return $configdata$$;
  };
  var CONST = {
    VISITORID: 'visitorid',
    UNIQUEID: 'uniqueid',
    GUESTTOKEN: 'guesttoken',
    GROUPID: 'groupid',
    SITE: 'site',
    PRESENCESERVER: 'presenceserver',
    WEBSERVER: 'ws',
    DIRECT: 'directserver',
    HTTPSPORT: 'httpsport',
    URL: 'url',
    BROWSER: 'browser',
    BROWSERVER: 'browserver',
    PLATFORM: 'platform',
    DATA: 'data',
    CONNECT: 'connect',
    FUNC: 'func',
    ARGS: 'args',
    CREDENTIALS: 'credentials',
    DURATION: 'duration',
    ONSUCCESS: 'onsuccess',
    ONFAIL: 'onfail',
    ONDONE: 'ondone',
    ONALWAYS: 'onalways',
    ONAUTHFAIL: 'onauthfail',
    SERVICE: 'service',
    TYPE: 'type',
    MTYPE: 'mtype',
    PRESENCE: 'presence',
    REMOTEINVOKE: 'remote',
    TIMEOUT: 'timeout',
  };
  GLANCE.Authorization = {};
  goog.exportSymbol('GLANCE.Authorization', GLANCE.Authorization);
  GLANCE.Authorization.setToken = function ($tok$$) {
    GLANCE.Authorization._token = $tok$$;
  };
  goog.exportProperty(
    GLANCE.Authorization,
    'setToken',
    GLANCE.Authorization.setToken
  );
  GLANCE.Authorization.gettoken = function () {
    var $scriptdata$$ = _GLANCE.Config.getCobrowseConfigData();
    return $scriptdata$$.authtoken
      ? $scriptdata$$.authtoken
      : GLANCE.Authorization._token ||
          (GLANCE.Authorization._ls && GLANCE.Authorization._ls.getObj());
  };
  GLANCE.Authorization.clearToken = function () {
    delete GLANCE.Authorization._token;
    GLANCE.Authorization._ls &&
      (GLANCE.Authorization._ls.del(), delete GLANCE.Authorization._ls);
  };
  goog.exportProperty(
    GLANCE.Authorization,
    'clearToken',
    GLANCE.Authorization.clearToken
  );
  GLANCE.Authorization.authorized = function () {
    return GLANCE.Authorization.gettoken() ? !0 : !1;
  };
  goog.exportProperty(
    GLANCE.Authorization,
    'authorized',
    GLANCE.Authorization.authorized
  );
  GLANCE.Authorization.authorize = async function ($params$$) {
    GLANCE.Authorization._ls =
      GLANCE.Authorization._ls || new GLANCE.Lib.lsCookie('glanceauth');
    if (!GLANCE.Authorization.authorized()) {
      var $url$$ = `https://${
        $params$$[CONST.WEBSERVER] || 'www.glance.net'
      }/services/AuthorizationService.svc/rest/${
        $params$$[CONST.CREDENTIALS] ? 'Authorize' : 'AuthorizeFromWebSession'
      }?groupid=${$params$$[CONST.GROUPID]}&service=${
        $params$$[CONST.SERVICE]
      }&duration=${$params$$[CONST.DURATION]}&site=${
        $params$$[CONST.SITE] || 'production'
      }`;
      var $fetchparams$$ = $params$$[CONST.CREDENTIALS]
        ? { method: 'post', mode: 'cors', body: $params$$[CONST.CREDENTIALS] }
        : { method: 'post', mode: 'same-origin', credentials: 'include' };
      try {
        var $data$$ = await GLANCE.Lib.JSONFetch($url$$, $fetchparams$$);
      } catch ($reason$$) {
        $params$$[CONST.ONFAIL]($reason$$);
        return;
      }
      GLANCE.Authorization._ls.setObj($data$$);
      GLANCE.Authorization._ls.setExp($params$$[CONST.DURATION]);
    }
    if ($params$$[CONST.ONSUCCESS]) {
      $params$$[CONST.ONSUCCESS]();
    }
  };
  goog.exportProperty(
    GLANCE.Authorization,
    'authorize',
    GLANCE.Authorization.authorize
  );
  var GLANCE_COBROWSE = window.GLANCE_COBROWSE;
  function PresenceBase() {}
  PresenceBase.prototype._init = function ($params$$) {
    this._usesockjs = 'undefined' === typeof WebSocket;
    this._params = {};
    this._params[CONST.WEBSERVER] = 'www.glance.net';
    this._params[CONST.SITE] = 'production';
    this._page = new GLANCE.Lib.Page(window);
    GLANCE.Lib.Params.copy(
      _GLANCE.Config.getCobrowseConfigData(),
      this._params
    );
    GLANCE.Lib.Params.copy($params$$, this._params);
    delete this._params[CONST.PRESENCESERVER];
    this._messagequeue = [];
    this._connstate = PresenceBase.CONNSTATE.NOTCONNECTED;
    this.ls = new GLANCE.Lib.lsCookie('glance_presence');
    var $lsobj$$ = this.ls.getObj();
    $lsobj$$ &&
      (0 ===
      [CONST.VISITORID, CONST.WEBSERVER, CONST.GROUPID].filter(
        ($k$$) => $lsobj$$[$k$$] !== this._params[$k$$]
      ).length
        ? (this._directserver = $lsobj$$[CONST.DIRECT])
        : preslog(
            'Ignoring glance_presence entry for different visitor',
            $lsobj$$[CONST.GROUPID],
            $lsobj$$[CONST.VISITORID]
          ));
    preslog('direct server from local storage:', this._directserver);
  };
  PresenceBase.CONNSTATE = { NOTCONNECTED: 1, CONNECTING: 2, CONNECTED: 3 };
  PresenceBase.prototype._cacheDirectServer = function () {};
  PresenceBase.prototype._makeurl = function (
    $direct$$,
    $path$$,
    $ajax$$,
    $proto$$
  ) {
    if ($direct$$ && !this._directserver) {
      GCommon.Log.log('ERR_NODIRECTSERVER');
    } else {
      var $url$$ =
          ($proto$$ || 'https') +
          '://' +
          ($direct$$
            ? this._directserver
            : this._params[CONST.PRESENCESERVER]) +
          '/' +
          $path$$,
        $self$$ = this;
      $ajax$$ &&
        (($url$$ += '?'),
        [CONST.GROUPID, CONST.VISITORID].forEach(function ($p$$) {
          $url$$ += $p$$ + '=' + encodeURIComponent($self$$._params[$p$$]) + '&';
        }),
        ($url$$ += `&ver=${GCommon.Defs.Version}`));
      return $url$$;
    }
  };
  PresenceBase.prototype._findvisitor = function ($params$$) {
    this._ajaxrequest(!1, 'findvisitor', 'GET', $params$$);
  };
  PresenceBase.prototype._openwebsocket = function () {
    GCommon.Log.log('connecting to ' + this._directserver);
    var $self$$ = this,
      $sockjsadded$$ = !1;
    this._usesockjs && !window.SockJS
      ? this._page.addScript(
          [['src', '//www.glancecdn.net/cobrowse/js/sockjs1.0.2.min.js']],
          function () {
            $sockjsadded$$ ||
              (preslog('sockjs script added'),
              ($sockjsadded$$ = !0),
              window.SockJS
                ? $self$$._openwebsocket()
                : GCommon.Log.log('ERR_NOSOCKJS'));
          }
        )
      : (this._sock && this._sock.close(),
        (this._sock = this._createwebsocket()),
        (this._sock.server = this._directserver),
        (this._sock.onopen = function () {
          preslog('sock onopen, sending connect');
          $self$$._sock.sendobj({
            type: CONST.CONNECT,
            authorization:
              $self$$._authorizer && $self$$._authorizer.gettoken(),
            groupid: $self$$._params[CONST.GROUPID],
            visitorid: $self$$._params[CONST.VISITORID],
            guesttoken: $self$$._params[CONST.GUESTTOKEN],
            version: GCommon.Defs.Version,
          });
          preslog('sending message queue');
          $self$$._messagequeue.forEach(function ($msg$$) {
            $self$$._sock.sendobj($msg$$);
          });
          $self$$._messagequeue = [];
          $self$$._connstate = PresenceBase.CONNSTATE.CONNECTED;
        }),
        (this._sock.onreceiveobj = function ($msg$$) {
          GCommon.Log.log('received:' + GLANCE.Lib.JSONStringify($msg$$));
          if ($self$$._sock) {
            var $mtype$$ = $msg$$[CONST.MTYPE] || $msg$$[CONST.TYPE],
              $data$$ = $msg$$.data;
            switch ($mtype$$) {
              case 'connected':
                if ($self$$._params.nokeepalive) {
                  break;
                }
                preslog('Keepalive interval: ' + $msg$$.keepalive);
                $self$$._keepalivetimer ||
                  ($self$$._keepalivetimer = window.setInterval(function () {
                    $self$$._sock.sendobj({ type: 'k' });
                  }, 1000 * $msg$$.keepalive));
                break;
              case 'invoke':
                'visitor' === $self$$._type &&
                  GLANCE.Lib.invokeFunction($data$$);
                break;
              case 'redirect':
              case 'serverclose':
                $data$$ || ($data$$ = $msg$$);
              default:
                if ($self$$['on' + $mtype$$]) {
                  $self$$['on' + $mtype$$]($data$$);
                }
            }
          } else {
            preslog('Ignoring message received after socket close');
          }
        }),
        (this._sock.onclose = function ($e$$) {
          $self$$._sock === this &&
            (GCommon.Log.log(
              `presence connection closed ${this.getcode(
                $e$$
              )} ${this.getreason($e$$)}`
            ),
            $self$$._socketclosed(),
            $self$$._delayedconnect());
        }),
        (this._sock.onerror = function ($e$$) {
          $self$$._sock === this &&
            (preslog('socket error'),
            ($self$$._usesockjs = !0),
            $self$$._sock.onclose($e$$));
        }));
  };
  PresenceBase.prototype._authorizer = void 0;
  PresenceBase.prototype._ajaxrequest = function (
    $direct$$,
    $requestname$$,
    $method$$,
    $params$$
  ) {
    function $onsuccess$$($response$$) {
      var $directserver$$ =
        $response$$ && ($response$$[CONST.DIRECT] || $response$$.direct);
      !$direct$$ &&
        $directserver$$ &&
        (($self$$._directserver = $directserver$$),
        $response$$[CONST.HTTPSPORT] &&
          ($self$$._directserver += ':' + $response$$[CONST.HTTPSPORT]),
        $self$$._cacheDirectServer());
      $self$$._sock &&
        $self$$._directserver != $self$$._sock.server &&
        (preslog(
          'switching connection from ' +
            $self$$._sock.server +
            ' to ' +
            $self$$._directserver
        ),
        $self$$._openwebsocket());
      if ($params$$ && $params$$[CONST.ONSUCCESS]) {
        $params$$[CONST.ONSUCCESS]($response$$);
      }
    }
    function $onfail$$($retriable$$, $reason$$, $httpstatus$$) {
      GCommon.Log.log(
        `Presence request: ${$requestname$$} failed reason: ${$reason$$} http status: ${
          $httpstatus$$ || 0
        }`
      );
      503 === $httpstatus$$ &&
        (GCommon.Log.error('Presence service unavailable'),
        ($self$$._serviceunavailable = !0),
        ($reason$$ = 'serviceunavailable'));
      if ($params$$[CONST.ONFAIL]) {
        $params$$[CONST.ONFAIL]($reason$$);
      } else {
        $self$$._fireerror({ error: 'connfail', detail: $reason$$ });
      }
    }
    if (!this._serviceunavailable) {
      var $self$$ = this,
        $request$$ = new GLANCE.Lib.Request('JSON');
      $request$$.setAuthorizer(this._authorizer);
      $request$$.method = $method$$;
      GCommon.Log.log($requestname$$, JSON.stringify($params$$));
      (function ($oncomplete$$) {
        if ($self$$._params[CONST.PRESENCESERVER]) {
          return $oncomplete$$();
        }
        var $lspresenceservice$$ = new GLANCE.Lib.lsCookie(
            'glance_visitor_settings_' +
              $self$$._params[CONST.GROUPID] +
              '_' +
              $self$$._params[CONST.SITE]
          ),
          $presenceserviceinfo_request$$ = $lspresenceservice$$.getObj();
        if ($presenceserviceinfo_request$$) {
          return (
            ($self$$._params[CONST.PRESENCESERVER] =
              $presenceserviceinfo_request$$[CONST.PRESENCESERVER]),
            $self$$._params[CONST.PRESENCESERVER] ||
              GCommon.Log.log('PRES_DISABLED (from cache)'),
            $oncomplete$$()
          );
        }
        $presenceserviceinfo_request$$ = new GLANCE.Lib.Request('JSON');
        var $url$$ =
          'https://' +
          $self$$._params[CONST.WEBSERVER] +
          '/services/authorizationservice/GetVisitorSettings3?groupid=' +
          $self$$._params[CONST.GROUPID] +
          '&site=' +
          $self$$._params[CONST.SITE] +
          '&service=presence';
        $presenceserviceinfo_request$$.method = 'GET';
        $presenceserviceinfo_request$$.post(
          $url$$,
          null,
          !0,
          !1,
          function ($response$$) {
            $self$$._params[CONST.PRESENCESERVER] = $response$$.presenceUrl;
            preslog(
              'presence service: ' + $self$$._params[CONST.PRESENCESERVER]
            );
            $self$$._params[CONST.PRESENCESERVER] ||
              GCommon.Log.log('PRES_DISABLED');
            var $o$$ = {};
            $o$$[CONST.PRESENCESERVER] = $self$$._params[CONST.PRESENCESERVER];
            $o$$.presencesettings = $response$$;
            $lspresenceservice$$.setObj($o$$);
            $lspresenceservice$$.setExp(1440);
            return $oncomplete$$();
          },
          function ($retriable$$, $reason$$) {
            GCommon.Log.log('PRES_UNAVAILABLE ' + $reason$$);
            $oncomplete$$();
          }
        );
      })(function () {
        $self$$._params[CONST.PRESENCESERVER] &&
          $request$$.post(
            $self$$._makeurl($direct$$, $requestname$$, !0),
            $params$$[CONST.DATA] ? $params$$[CONST.DATA] : {},
            !0,
            !1,
            $onsuccess$$,
            $onfail$$
          );
      });
    }
  };
  PresenceBase.prototype._closewebsocket = function () {
    preslog('closewebsocket');
    this._sock && this._sock.close();
    this._socketclosed();
  };
  PresenceBase.prototype._socketclosed = function () {
    this._keepalivetimer &&
      (window.clearInterval(this._keepalivetimer), delete this._keepalivetimer);
    this._connstate = PresenceBase.CONNSTATE.NOTCONNECTED;
    delete this._sock;
    delete this._directserver;
  };
  PresenceBase.prototype._sendmsg = function ($msg$$) {
    GCommon.Log.log('sending', $msg$$[CONST.TYPE], this._connstate);
    this._connstate === PresenceBase.CONNSTATE.CONNECTED
      ? (preslog('sending message: ' + JSON.stringify($msg$$)),
        this._sock.sendobj($msg$$))
      : (preslog('queuing message: ' + JSON.stringify($msg$$)),
        this._messagequeue.push($msg$$),
        this.connect());
  };
  PresenceBase.prototype.setVisitorId = function ($visitorId$$) {
    let $connected$$ = this._connstate === PresenceBase.CONNSTATE.CONNECTED;
    $connected$$ && this.disconnect();
    this._params[CONST.VISITORID] = $visitorId$$;
    ($connected$$ || 'api' !== this._params.presence) && this.connect();
  };
  goog.exportProperty(
    PresenceBase.prototype,
    'setVisitorId',
    PresenceBase.prototype.setVisitorId
  );
  PresenceBase.prototype.connect = function () {
    if (!this._serviceunavailable) {
      if (this._params[CONST.VISITORID]) {
        if (this._connstate !== PresenceBase.CONNSTATE.NOTCONNECTED) {
          preslog('connect() called when already connecting or connected');
        } else {
          this._connstate = PresenceBase.CONNSTATE.CONNECTING;
          preslog('connect');
          var $self$$ = this;
          this.onscaledown = function () {
            $self$$.disconnect();
            $self$$.connect();
          };
          this.onredirect = function ($data$$) {
            preslog(
              'Connected to wrong instance:',
              JSON.stringify($data$$),
              'current direct server:',
              this._directserver
            );
            this.ls &&
              $data$$.direct !== this._directserver &&
              (this.ls.del(),
              (this.ls = new GLANCE.Lib.lsCookie('glance_presence')),
              this.disconnect(),
              this._delayedconnect());
          };
          this.onserverclose = function ($data$$) {
            $self$$.disconnect();
            if ($self$$.onclose) {
              $self$$.onclose();
            }
          };
          this._directserver
            ? this._openwebsocket()
            : this._findvisitor({
                onsuccess: function () {
                  GCommon.Log.log('found visitor, connect');
                  $self$$._openwebsocket();
                },
                onfail: function ($e$$) {
                  $self$$._connstate = PresenceBase.CONNSTATE.NOTCONNECTED;
                  $self$$._fireerror({ error: 'connfail', detail: $e$$ });
                },
              });
        }
      } else {
        GCommon.Log.log('CONN_NOVISITORID');
      }
    }
  };
  goog.exportProperty(
    PresenceBase.prototype,
    'connect',
    PresenceBase.prototype.connect
  );
  PresenceBase.prototype.disconnect = function () {
    this._closewebsocket();
  };
  goog.exportProperty(
    PresenceBase.prototype,
    'disconnect',
    PresenceBase.prototype.disconnect
  );
  PresenceBase.prototype._delayedconnect = function () {
    preslog(
      `delayed reconnect.  count: ${this._reconnectcount || 0} connstate: ${
        this._connstate
      }`
    );
    this._connecttimer ||
      ((this._reconnectcount = this._reconnectcount || 0),
      this._reconnectcount++,
      (this._connecttimer = window.setTimeout(
        () => {
          delete this._connecttimer;
          this.connect();
        },
        3 >= this._reconnectcount ? 5000 : 60000
      )));
  };
  PresenceBase.prototype.isconnected = function () {
    return this._connstate === PresenceBase.CONNSTATE.CONNECTED;
  };
  PresenceBase.prototype._fireerror = function ($errorinfo$$) {
    GCommon.Log.log('Error: ', JSON.stringify($errorinfo$$));
    this._onerror && this._onerror($errorinfo$$);
    if (this.onerror) {
      this.onerror($errorinfo$$);
    }
  };
  PresenceBase.prototype.fire = function ($eventname$$, $eventdata$$) {
    this._sendmsg({ type: $eventname$$, data: $eventdata$$ });
  };
  goog.exportProperty(
    PresenceBase.prototype,
    'fire',
    PresenceBase.prototype.fire
  );
  GLANCE.Presence = GLANCE.Presence || {};
  GLANCE.Presence.Visitor = function ($params$$) {
    this._init($params$$);
    this._type = 'visitor';
    this._page = new GLANCE.Lib.Page(window);
    this._uniqueconnection = !1;
    var $self$$ = this;
    GLANCE.Lib.Window.addEventListener('focus', function () {
      $self$$._onfocus();
    });
    this._page.onVisibilityChange(function () {
      $self$$._onvisiblitychange();
    });
    GLANCE.Presence.Visitor.instance = this;
  };
  goog.exportSymbol('GLANCE.Presence.Visitor', GLANCE.Presence.Visitor);
  GLANCE.Presence.Visitor.prototype = new PresenceBase();
  GLANCE.Presence.Visitor.prototype._cacheDirectServer = function () {
    preslog('caching direct server:', this._directserver);
    var $lsdata$$ = {};
    $lsdata$$[CONST.DIRECT] = this._directserver;
    $lsdata$$[CONST.GROUPID] = this._params[CONST.GROUPID];
    $lsdata$$[CONST.VISITORID] = this._params[CONST.VISITORID];
    $lsdata$$[CONST.WEBSERVER] = this._params[CONST.WEBSERVER];
    this.ls.setObj($lsdata$$);
    this.ls.setExp(20);
  };
  GLANCE.Presence.Visitor.prototype._onfocus = function () {
    preslog('presence visitor got focus event');
    this._blurred = !1;
    this._sentpresence && this.presence();
  };
  GLANCE.Presence.Visitor.prototype._onvisiblitychange = function () {
    if (
      !this._uniqueconnection &&
      (preslog('visibility:', this._page.isHidden() ? 'hidden' : 'visible'),
      (this._sentpresence || this.isconnected()) && !this._blurred)
    ) {
      var $visibilitymsg$$ = {};
      $visibilitymsg$$[CONST.TYPE] = 'visibility';
      $visibilitymsg$$[CONST.DATA] = {
        visibility: this._page.isHidden() ? 'hidden' : 'visible',
      };
      this._sendmsg($visibilitymsg$$);
      this._page.isHidden() && this._closewebsocket();
    }
  };
  GLANCE.Presence.Visitor.prototype.presence = function ($params$$) {
    preslog('presence');
    if (this._params[CONST.VISITORID]) {
      var $presence$$ = {};
      GLANCE.Lib.Params.copy(this._params, $presence$$, [
        CONST.GROUPID,
        CONST.VISITORID,
      ]);
      var $pdata_presencemsg$$ = {},
        $p$$;
      for ($p$$ in this._params) {
        0 === $p$$.indexOf('user-') &&
          ($pdata_presencemsg$$[$p$$.substring(5)] = this._params[$p$$]);
      }
      $pdata_presencemsg$$[CONST.URL] = window.location.href;
      $pdata_presencemsg$$[CONST.BROWSER] = GLANCE.Lib.Browser.name;
      $pdata_presencemsg$$[CONST.BROWSERVER] = GLANCE.Lib.Browser.version;
      $pdata_presencemsg$$[CONST.PLATFORM] = GLANCE.Lib.Browser.Platform.name;
      ($params$$ = $params$$ && $params$$[CONST.DATA]) &&
        GLANCE.Lib.Params.copy($params$$, $pdata_presencemsg$$);
      $presence$$[CONST.DATA] = $pdata_presencemsg$$;
      this._blurred ||
        (($pdata_presencemsg$$ = {}),
        ($pdata_presencemsg$$[CONST.TYPE] = CONST.PRESENCE),
        ($pdata_presencemsg$$[CONST.DATA] = $presence$$[CONST.DATA]),
        this._sendmsg($pdata_presencemsg$$),
        (this._sentpresence = !0));
      this._onerror = function ($e$$) {
        'connfail' === $e$$.error && this._delayedconnect();
      };
    } else {
      GCommon.Log.log('PRES_NOVISITORID');
    }
  };
  goog.exportProperty(
    GLANCE.Presence.Visitor.prototype,
    'presence',
    GLANCE.Presence.Visitor.prototype.presence
  );
  GLANCE.Presence.Visitor.prototype.connectUnique = function ($params$$) {
    var $self$$ = this;
    this._uniqueconnection = !0;
    this._ajaxrequest(!1, 'uniquevisitor', 'GET', {
      onsuccess: function ($response$$) {
        GCommon.Log.log('got unique visitor id', $response$$[CONST.VISITORID]);
        $self$$._params[CONST.VISITORID] = $response$$[CONST.VISITORID];
        $self$$._params[CONST.GUESTTOKEN] = $response$$[CONST.GUESTTOKEN];
        $self$$._params[CONST.TIMEOUT] = $response$$[CONST.TIMEOUT] || 300;
        if ($self$$.onuniqueid) {
          $self$$.onuniqueid(
            $response$$.uniqueid,
            $self$$._params[CONST.TIMEOUT]
          );
        }
        $self$$.connect();
        $params$$ &&
          $params$$.data &&
          $self$$.presence({ data: $params$$.data });
      },
      onfail: function ($e$$) {
        $self$$._fireerror({ error: 'connfail', detail: $e$$ });
      },
    });
  };
  goog.exportProperty(
    GLANCE.Presence.Visitor.prototype,
    'connectUnique',
    GLANCE.Presence.Visitor.prototype.connectUnique
  );
  GLANCE.Presence.Visitor.prototype.extendUnique = function () {
    this._uniqueconnection
      ? this.isconnected()
        ? (this.disconnect(), this.connect())
        : this._fireerror({ error: 'connfail', detail: 'extend' })
      : console.error('ERR_EXTEND_UNIQUE');
  };
  goog.exportProperty(
    GLANCE.Presence.Visitor.prototype,
    'extendUnique',
    GLANCE.Presence.Visitor.prototype.extendUnique
  );
  GLANCE.Presence.Visitor.prototype._createwebsocket = function () {
    return this._usesockjs
      ? GLANCE.Lib.GSockJS(this._makeurl(!0, 'visitor'), 15000)
      : GLANCE.Lib.GWebSocket(this._makeurl(!0, 'visitorws', !1, 'wss'));
  };
  GLANCE.Presence.Visitor.setVisitorId = function ($visitorId$$) {
    GLANCE.Presence.Visitor.instance &&
      GLANCE.Presence.Visitor.instance.setVisitorId($visitorId$$);
  };
  GLANCE.Presence.Visitor.prototype._findvisitor = function ($params$$) {
    $params$$[CONST.DATA] = {};
    this._ajaxrequest(!1, 'presence', 'POST', $params$$);
  };
  GLANCE.Presence.Visitor.prototype.onblur = function () {
    GCommon.Log.log('BLURRED');
    this._blurred = !0;
    this._closewebsocket();
  };
  var loadFired = !1,
    thePage = new GLANCE.Lib.Page(window);
  thePage.addLoadListener(function () {
    if (!loadFired) {
      loadFired = !0;
      var $scriptdata$$ = _GLANCE.Config.getCobrowseConfigData();
      $scriptdata$$.presence &&
        'api' !== $scriptdata$$.presence &&
        new GLANCE.Presence.Visitor().presence();
    }
  });
  /*
 Copyright (c) 2020-2021 Glance Networks, Inc.
 The GlanceAgent JavaScript can be included in a customer or partner page to join and control
 sessions as an agent, by opening and communicating with /agentjoin/AgentView.aspx
*/
  GLANCE.Presence.Agent = function ($params$$) {
    $params$$.uniqueid && ($params$$.visitorid = 'UNQ-' + $params$$.uniqueid);
    this._init($params$$);
    this._type = 'agent';
  };
  GLANCE.Presence.Agent.prototype = new PresenceBase();
  GLANCE.Presence.Agent.prototype._authorizer = GLANCE.Authorization;
  GLANCE.Presence.Agent.prototype._createwebsocket = function () {
    return GLANCE.Lib.GWebSocket(this._makeurl(!0, this._type, !1, 'wss'));
  };
  GLANCE.Presence.Agent.prototype._send = function (
    $mtype$$,
    $mdata$$,
    $onsuccess$$,
    $onfail$$
  ) {
    $onfail$$ =
      $onfail$$ ||
      function ($e$$) {
        GLANCE.Lib.log('Unhandled error:' + JSON.stringify($e$$));
      };
    var $self$$ = this;
    this._findvisitor({
      onsuccess: function ($response$$) {
        $response$$.visitorfound
          ? $self$$._ajaxrequest(!0, 'signalvisitor', 'POST', {
              data: { mtype: $mtype$$, data: $mdata$$ },
              onsuccess: $onsuccess$$,
              onfail: $onfail$$,
            })
          : (GLANCE.Lib.log('ERR_VISITORNOTPRESENT'),
            $onfail$$('visitornotpresent'));
      },
      onfail: $onfail$$,
    });
  };
  GLANCE.Presence.Agent.prototype.signalVisitor = function ($params$$) {
    this._send(
      'signal',
      $params$$[CONST.DATA],
      $params$$[CONST.ONSUCCESS],
      $params$$[CONST.ONFAIL]
    );
  };
  goog.exportProperty(
    GLANCE.Presence.Agent.prototype,
    'signalVisitor',
    GLANCE.Presence.Agent.prototype.signalVisitor
  );
  GLANCE.Presence.Agent.prototype.invokeVisitor = function ($params$$) {
    var $data$$ = {};
    GLANCE.Lib.Params.copy($params$$, $data$$, [CONST.FUNC, CONST.ARGS]);
    this._send(
      'invoke',
      $data$$,
      $params$$[CONST.ONSUCCESS],
      $params$$[CONST.ONFAIL]
    );
  };
  goog.exportProperty(
    GLANCE.Presence.Agent.prototype,
    'invokeVisitor',
    GLANCE.Presence.Agent.prototype.invokeVisitor
  );
  GLANCE.Presence.Agent.prototype.lookupVisitor = function ($params$$) {
    const $orig_onsuccess$$ = $params$$[CONST.ONSUCCESS];
    $params$$[CONST.ONSUCCESS] = function ($data$$) {
      Object.keys($data$$).forEach(function ($k$$) {
        if (
          'string' === typeof $data$$[$k$$] &&
          0 === $data$$[$k$$].indexOf("{'")
        ) {
          try {
            preslog('Converting python object to json:', $data$$[$k$$]),
              ($data$$[$k$$] = JSON.parse($data$$[$k$$].replace(/'/g, '"')));
          } catch ($e$$) {
            GLANCE.Lib.log('Could not convert ' + $data$$[$k$$] + ' to json');
          }
        }
      });
      $orig_onsuccess$$($data$$);
    };
    this._ajaxrequest(!1, 'lookupvisitor', 'GET', $params$$);
  };
  goog.exportProperty(
    GLANCE.Presence.Agent.prototype,
    'lookupVisitor',
    GLANCE.Presence.Agent.prototype.lookupVisitor
  );
  GLANCE.Presence.Agent.prototype.query = function ($params$$) {
    this._ajaxrequest(!1, 'query', 'GET', $params$$);
  };
  goog.exportProperty(
    GLANCE.Presence.Agent.prototype,
    'query',
    GLANCE.Presence.Agent.prototype.query
  );
  GLANCE.Agent = GLANCE.Agent || {};
  goog.exportSymbol('GLANCE.Agent', GLANCE.Agent);
  GLANCE.Agent.webserver = 'https://www.glance.net';
  GLANCE.Agent.postParametersToViewer = !0;
  var glanceCredentials = {},
    presenceAgent = {},
    DefaultViewerWindowFeatures =
      'referrerpolicy==no-referrer,location=no,menubar=0,titlebar=0,status=0,toolbar=0,height=800,width=800,top=10,left=10,scrollbars=1,resizable=1',
    eventlisteners = new GCommon.EventListeners(),
    lastLookup,
    isSamlResponsePending = !1;
  window.addEventListener('message', function ($e$$) {
    const $name$$ = $e$$.data.glanceEvent;
    $name$$ &&
      ($e$$.origin !== GLANCE.Agent.webserver
        ? GCommon.Log.log(
            'Glance Agent not handling message from ' +
              $e$$.origin +
              ' not matching ' +
              GLANCE.Agent.webserver
          )
        : (eventlisteners.fire($name$$, $e$$.data.data),
          eventlisteners.fire('*', $e$$.data)));
  });
  function _fireEvent($name$$, $data$$) {
    eventlisteners.fire($name$$, $data$$);
    eventlisteners.fire('*', { glanceEvent: $name$$, data: $data$$ });
  }
  GLANCE.Agent.openViewer = function ($key$$, $params$$ = {}) {
    GCommon.Log.log('GLANCE.Agent.openViewer');
    var $creds$$ = '';
    glanceCredentials &&
      glanceCredentials.partnerid &&
      glanceCredentials.partneruserid &&
      glanceCredentials.loginkey &&
      ($creds$$ =
        'partnerid=' +
        encodeURIComponent(glanceCredentials.partnerid) +
        '&partneruserid=' +
        encodeURIComponent(glanceCredentials.partneruserid) +
        '&loginkey=' +
        encodeURIComponent(glanceCredentials.loginkey));
    return GLANCE.Agent.openAgentJoinURL(
      GLANCE.Agent.webserver +
        '/agentjoin/AgentView.aspx?SessionKey=' +
        encodeURIComponent($key$$) +
        '&' +
        $creds$$,
      $params$$
    );
  };
  goog.exportProperty(GLANCE.Agent, 'openViewer', GLANCE.Agent.openViewer);
  GLANCE.Agent.openAgentJoinURL = function ($url$$, $params$$ = {}) {
    GCommon.Log.log('GLANCE.Agent.openAgentJoinURL');
    if ($params$$ && $params$$.iframe) {
      var $iframe$$ =
          'string' === typeof $params$$.iframe
            ? document.getElementById($params$$.iframe)
            : $params$$.iframe,
        $resf$$,
        $rejf$$,
        $p$$ = new Promise(($resolve$$, $reject$$) => {
          $resf$$ = $resolve$$;
          $rejf$$ = $reject$$;
        });
      $iframe$$.onload = function () {
        let $viewer$$ = $iframe$$.contentWindow;
        $viewer$$
          ? $resf$$($viewer$$)
          : (_fireEvent('iframeblocked', { service: 'agent' }), $rejf$$());
      };
      GLANCE.Agent.postParametersToViewer
        ? _postAgentViewParams($iframe$$.contentWindow, $url$$, $params$$)
        : ($iframe$$.src = $url$$);
      return $p$$;
    }
    let $viewer$jscomp$0$$;
    GLANCE.Agent.postParametersToViewer
      ? (($viewer$jscomp$0$$ = window.open(
          '',
          $params$$.windowName || '_blank',
          $params$$.windowFeatures || DefaultViewerWindowFeatures
        )),
        _postAgentViewParams($viewer$jscomp$0$$, $url$$, $params$$))
      : ($viewer$jscomp$0$$ = window.open(
          $url$$,
          $params$$.windowName || '_blank',
          $params$$.windowFeatures || DefaultViewerWindowFeatures
        ));
    $viewer$jscomp$0$$
      ? _fireEvent('viewerOpened', {
          service: 'agent',
          close: () => GLANCE.Agent.close($viewer$jscomp$0$$),
        })
      : _fireEvent('popupblocked', { service: 'agent' });
    return new Promise(($resolve$$, $reject$$) => {
      $viewer$jscomp$0$$ ? $resolve$$($viewer$jscomp$0$$) : $reject$$();
    });
  };
  goog.exportProperty(
    GLANCE.Agent,
    'openAgentJoinURL',
    GLANCE.Agent.openAgentJoinURL
  );
  function _getUrlParams($kvpairs_url$$) {
    var $result$$ = {};
    if ($kvpairs_url$$) {
      $kvpairs_url$$ = $kvpairs_url$$.split('?')[1].split('&');
      for (var $kv$$ in $kvpairs_url$$) {
        let [$key$$, $value$$] = $kvpairs_url$$[$kv$$].split('=');
        $result$$[$key$$] = $value$$;
      }
      return $result$$;
    }
    return {};
  }
  function _getCredentialsFromUrl($params$jscomp$23_url$$) {
    $params$jscomp$23_url$$ = _getUrlParams($params$jscomp$23_url$$);
    return [
      $params$jscomp$23_url$$.partnerid
        ? $params$jscomp$23_url$$.partnerid
        : '',
      $params$jscomp$23_url$$.partneruserid
        ? $params$jscomp$23_url$$.partneruserid
        : '',
      $params$jscomp$23_url$$.loginkey ? $params$jscomp$23_url$$.loginkey : '',
    ];
  }
  function _postAgentViewParams($viewer$$, $i$jscomp$52_url$$, $params$$ = {}) {
    ('undefined' == typeof $i$jscomp$52_url$$ ||
      0 > $i$jscomp$52_url$$.toLowerCase().indexOf('sessionkey=')) &&
      GCommon.Log.log('No session key');
    var $form$$ = document.createElement('form');
    $form$$.method = 'POST';
    $form$$.action = GLANCE.Agent.webserver + '/agentjoin/AgentView.aspx';
    var $agentVideo_contains_loginkey$jscomp$1_script$$ = _createHiddenElement(
      'wait',
      '1'
    );
    'false' === $params$$.wait &&
      ($agentVideo_contains_loginkey$jscomp$1_script$$ = _createHiddenElement(
        'wait',
        '0'
      ));
    $form$$.appendChild($agentVideo_contains_loginkey$jscomp$1_script$$);
    null != $params$$.agentVideo &&
      (($agentVideo_contains_loginkey$jscomp$1_script$$ = _createHiddenElement(
        'agentVideo',
        'true' === $params$$.agentVideo ? '1' : '0'
      )),
      $form$$.appendChild($agentVideo_contains_loginkey$jscomp$1_script$$));
    if (
      glanceCredentials &&
      glanceCredentials.partnerid &&
      glanceCredentials.partneruserid &&
      glanceCredentials.loginkey
    ) {
      $agentVideo_contains_loginkey$jscomp$1_script$$ = _createHiddenElement(
        'loginkey',
        glanceCredentials.loginkey
      );
      var $i$jscomp$51_partnerid$$ = _createHiddenElement(
          'partnerid',
          glanceCredentials.partnerid
        ),
        $partneruserid$$ = _createHiddenElement(
          'partneruserid',
          glanceCredentials.partneruserid
        );
      $form$$.appendChild($agentVideo_contains_loginkey$jscomp$1_script$$);
      $form$$.appendChild($i$jscomp$51_partnerid$$);
      $form$$.appendChild($partneruserid$$);
    }
    $agentVideo_contains_loginkey$jscomp$1_script$$ =
      document.createElement('script');
    $agentVideo_contains_loginkey$jscomp$1_script$$.innerText =
      'document.forms[0].submit()';
    $form$$.appendChild($agentVideo_contains_loginkey$jscomp$1_script$$);
    $i$jscomp$52_url$$ = _getUrlParams($i$jscomp$52_url$$);
    for (var $contains$jscomp$1_p$$ in $i$jscomp$52_url$$) {
      $agentVideo_contains_loginkey$jscomp$1_script$$ = !1;
      for (
        $i$jscomp$51_partnerid$$ = 0;
        $i$jscomp$51_partnerid$$ < $form$$.elements.length;
        $i$jscomp$51_partnerid$$++
      ) {
        $agentVideo_contains_loginkey$jscomp$1_script$$ =
          $agentVideo_contains_loginkey$jscomp$1_script$$ ||
          $form$$.elements[$i$jscomp$51_partnerid$$].name.toUpperCase() ===
            $contains$jscomp$1_p$$.toUpperCase();
      }
      $agentVideo_contains_loginkey$jscomp$1_script$$
        ? ($form$$[$contains$jscomp$1_p$$.toUpperCase()].value =
            $i$jscomp$52_url$$[$contains$jscomp$1_p$$])
        : $form$$.appendChild(
            _createHiddenElement(
              $contains$jscomp$1_p$$,
              $i$jscomp$52_url$$[$contains$jscomp$1_p$$]
            )
          );
    }
    for (let $p$$ in $params$$) {
      $contains$jscomp$1_p$$ = !1;
      for (
        $i$jscomp$52_url$$ = 0;
        $i$jscomp$52_url$$ < $form$$.elements.length;
        $i$jscomp$52_url$$++
      ) {
        $contains$jscomp$1_p$$ =
          $contains$jscomp$1_p$$ ||
          $form$$.elements[$i$jscomp$52_url$$].name.toUpperCase() ===
            $p$$.toUpperCase();
      }
      $contains$jscomp$1_p$$ ||
        $form$$.appendChild(_createHiddenElement($p$$, $params$$[$p$$]));
    }
    $viewer$$.document.body.appendChild($form$$);
  }
  function _createHiddenElement($name$$, $value$$) {
    var $element$$ = document.createElement('input');
    $element$$.type = 'hidden';
    $element$$.name = $name$$.toUpperCase();
    $element$$.value = 'undefined' == typeof $value$$ ? '' : $value$$;
    return $element$$;
  }
  GLANCE.Agent.end = function ($viewer$$) {
    GCommon.Log.log('GLANCE.Agent.end not implemented');
  };
  goog.exportProperty(GLANCE.Agent, 'end', GLANCE.Agent.end);
  GLANCE.Agent.addEventListener = function ($name$$, $handler$$) {
    eventlisteners.add($name$$, $handler$$);
  };
  goog.exportProperty(
    GLANCE.Agent,
    'addEventListener',
    GLANCE.Agent.addEventListener
  );
  GLANCE.Agent.addEventListenerAll = function ($handler$$) {
    eventlisteners.add('*', function ($data$$) {
      $handler$$($data$$.glanceEvent, $data$$.data);
    });
  };
  goog.exportProperty(
    GLANCE.Agent,
    'addEventListenerAll',
    GLANCE.Agent.addEventListenerAll
  );
  GLANCE.Agent.removeEventListener = function ($name$$, $handler$$) {
    eventlisteners.remove($name$$, $handler$$);
  };
  goog.exportProperty(
    GLANCE.Agent,
    'removeEventListener',
    GLANCE.Agent.removeEventListener
  );
  GLANCE.Agent.authenticate = function ($credentials$$) {
    GCommon.Log.log('GLANCE.Agent.authenticate');
    glanceCredentials = $credentials$$;
    for (var $param$$ of ['idpid', 'idpname', 'idptoken', 'idpusername']) {
      if ('undefined' != typeof glanceCredentials[$param$$]) {
        _doSamlAuth($param$$, glanceCredentials[$param$$]);
        break;
      }
    }
  };
  goog.exportProperty(GLANCE.Agent, 'authenticate', GLANCE.Agent.authenticate);
  function _doSamlAuth($idpParamName$$, $idpParamValue$$) {
    _createIframe(
      GLANCE.Agent.webserver +
        '/account/getloginkey.aspx?sso=1&mode=embedded&fmt=html&' +
        ($idpParamName$$ + '=' + $idpParamValue$$)
    );
    var $attempts$$ = 0;
    isSamlResponsePending = !0;
    var $getLoginKeyInterval$$ = setInterval(function () {
      isSamlResponsePending
        ? 3 < $attempts$$
          ? ((isSamlResponsePending = !1),
            eventlisteners.fire('authenticateFailed', {}),
            clearInterval($getLoginKeyInterval$$))
          : ($attempts$$++,
            GCommon.Log.log(
              'SAML authentication pending attmept: ' + $attempts$$
            ))
        : clearInterval($getLoginKeyInterval$$);
    }, 3000);
    GLANCE.Agent.removeEventListener(
      'authenticateSucceeded',
      _authSucceededHandler
    );
    GLANCE.Agent.addEventListener(
      'authenticateSucceeded',
      _authSucceededHandler
    );
    GLANCE.Agent.removeEventListener('authenticateFailed', _authFailedHandler);
    GLANCE.Agent.addEventListener('authenticateFailed', _authFailedHandler);
  }
  function _createIframe($url$$) {
    var $ssoIframe$$ = document.createElement('iframe');
    $ssoIframe$$.src = $url$$;
    $ssoIframe$$.style.display = 'none';
    $ssoIframe$$.style.height = '0';
    $ssoIframe$$.style.width = '0';
    $ssoIframe$$.id = 'glanceSsoIframe';
    document.body.appendChild($ssoIframe$$);
  }
  function _authSucceededHandler($data$$) {
    isSamlResponsePending = !1;
    _parseSsoCredentials($data$$.loginKey);
    null != document.getElementById('glanceSsoIframe') &&
      document.getElementById('glanceSsoIframe').remove();
    GCommon.Log.log('SAML authentication succeed');
  }
  function _parseSsoCredentials($credStr_data$$) {
    'undefined' != typeof $credStr_data$$ && 0 < $credStr_data$$.indexOf('~')
      ? (($credStr_data$$ = $credStr_data$$.split('~')),
        (glanceCredentials.loginkey = $credStr_data$$[1]),
        0 < $credStr_data$$[0].indexOf('&')
          ? (($credStr_data$$ = $credStr_data$$[0].split('&')),
            0 == $credStr_data$$[0].indexOf('partnerid')
              ? ((glanceCredentials.partnerid =
                  $credStr_data$$[0].split('=')[1]),
                (glanceCredentials.partneruserid =
                  $credStr_data$$[1].split('=')[1]))
              : 0 == $credStr_data$$[0].indexOf('partneruserid')
              ? ((glanceCredentials.partnerid =
                  $credStr_data$$[1].split('=')[1]),
                (glanceCredentials.partneruserid =
                  $credStr_data$$[0].split('=')[1]))
              : GCommon.Log.log('Wrong Login Key format'))
          : GCommon.Log.log('Wrong Login Key format'))
      : GCommon.Log.log('Wrong Login Key format');
  }
  function _authFailedHandler($data$$) {
    isSamlResponsePending = !1;
    null != document.getElementById('glanceSsoIframe') &&
      document.getElementById('glanceSsoIframe').remove();
    GCommon.Log.log('SAML authentication failed');
  }
  GLANCE.Agent.logout = function () {
    GCommon.Log.log('GLANCE.Agent.logout');
    glanceCredentials = {};
  };
  goog.exportProperty(GLANCE.Agent, 'logout', GLANCE.Agent.logout);
  GLANCE.Agent.lookupSession = function ($sessionkey$$, $wait$$ = !0) {
    GCommon.Log.log('GLANCE.Agent.lookupSession');
    if (0 === Object.keys(glanceCredentials || {}).length) {
      return new Promise(($resolve$$, $reject$$) => $reject$$());
    }
    var $lookupState$$ = { index: 0, canceled: !1 };
    let $cancelLookup$$ = () => {
      lastLookup = null;
      $lookupState$$.index = 0;
      $lookupState$$.canceled = !0;
    };
    lastLookup = $lookupState$$;
    const $url$$ =
      GLANCE.Agent.webserver +
      '/services/SessionService.asmx/LookupPartnerSession2';

    function fixAgentJoinUrl(url) {
      const uri = new URL(url);
      // NOTE: here we manually parsing the agentJoinUrl and properly url-encode it with UrlSearchParams
      uri.search = (uri.search + uri.hash)
        // NOTE: removing starting ?
        .slice(1)
        .split('&')
        .reduce((params, param) => {
          let equalSignDivider = '=';
          let equalSignPosition = param.indexOf(equalSignDivider);
          let key = param.substring(0, equalSignPosition);
          let value = param.substring(equalSignPosition + 1);
          params.set(key, decodeURIComponent(value));
          return params;
        }, new URLSearchParams())
        .toString();
      return uri;
    }

    let $data$$ =
      'partnerid=' +
      encodeURIComponent(glanceCredentials.partnerid) +
      '&partneruserid=' +
      encodeURIComponent(glanceCredentials.partneruserid) +
      '&loginkey=' +
      encodeURIComponent(glanceCredentials.loginkey) +
      '&ssnkey=' +
      encodeURIComponent($sessionkey$$);
    return new Promise(($resolve$$, $reject$$) => {
      function $_lookup$$() {
        if ($lookupState$$.canceled) {
          _fireEvent('lookupCanceled', {
            service: 'agent',
            ssnkey: $sessionkey$$,
          }),
            $reject$$();
        } else {
          if (12 <= $lookupState$$.index) {
            _fireEvent('lookupFailed', {
              service: 'agent',
              ssnkey: $sessionkey$$,
              reason: 'timedout',
            }),
              $reject$$();
          } else {
            _fireEvent('lookupWaiting', {
              service: 'agent',
              ssnkey: $sessionkey$$,
              cancel: $cancelLookup$$,
            });
            var $resp$$ = '';
            fetch($url$$, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: $data$$,
            })
              .then(($response$$) => $response$$.text())
              .then(($xml$$) => {
                $resp$$ = $xml$$;
                return new window.DOMParser().parseFromString(
                  $xml$$,
                  'text/xml'
                );
              })
              .then(($d$jscomp$3_data$$) => {
                $d$jscomp$3_data$$.getElementsByTagName('agentjoinurl')[0]
                  ? (($d$jscomp$3_data$$ = {
                      service: 'agent',
                      id: $d$jscomp$3_data$$.getElementsByTagName('id')[0]
                        .textContent,
                      ssnid:
                        $d$jscomp$3_data$$.getElementsByTagName('ssnid')[0]
                          .textContent,
                      serverip:
                        $d$jscomp$3_data$$.getElementsByTagName('serverip')[0]
                          .textContent,
                      servername:
                        $d$jscomp$3_data$$.getElementsByTagName('servername')[0]
                          .textContent,
                      personid:
                        $d$jscomp$3_data$$.getElementsByTagName('personid')[0]
                          .textContent,
                      grpupid:
                        $d$jscomp$3_data$$.getElementsByTagName('groupid')[0]
                          .textContent,
                      passcode:
                        $d$jscomp$3_data$$.getElementsByTagName('passcode')[0]
                          .textContent,
                      agentjoinurl:
                        fixAgentJoinUrl($d$jscomp$3_data$$.getElementsByTagName(
                          'agentjoinurl'
                        )[0].textContent).toString(),
                      clientjoinurl:
                        $d$jscomp$3_data$$.getElementsByTagName(
                          'clientjoinurl'
                        )[0].textContent,
                      visitorversion:
                        $d$jscomp$3_data$$.getElementsByTagName(
                          'visitorversion'
                        )[0].textContent,
                    }),
                    _fireEvent('lookupFound', $d$jscomp$3_data$$),
                    $resolve$$($d$jscomp$3_data$$))
                  : '0' ===
                    $d$jscomp$3_data$$.getElementsByTagName('id')[0].textContent
                  ? $wait$$
                    ? setTimeout(
                        $_lookup$$,
                        1000 * (6 >= ++$lookupState$$.index ? 3 : 5)
                      )
                    : (_fireEvent('lookupFailed', {
                        service: 'agent',
                        reason: 'not found',
                      }),
                      $reject$$())
                  : (_fireEvent('lookupFailed', {
                      service: 'agent',
                      reason: $resp$$,
                    }),
                    $reject$$());
              })
              .catch(($e$$) => {
                _fireEvent('lookupFailed', {
                  service: 'agent',
                  reason: $resp$$ || $e$$.toString(),
                });
                $reject$$();
              });
          }
        }
      }
      $_lookup$$();
    });
  };
  goog.exportProperty(
    GLANCE.Agent,
    'lookupSession',
    GLANCE.Agent.lookupSession
  );
  GLANCE.Agent.inSession = function ($sessionkey$$) {
    GCommon.Log.log('GLANCE.Agent.inSession');
    if (0 === Object.keys(glanceCredentials || {}).length) {
      return new Promise(($resolve$$, $reject$$) => $reject$$());
    }
    const $url$$ =
      GLANCE.Agent.webserver + '/services/SessionService.asmx/AgentInSession';
    let $data$jscomp$0$$ =
      'partnerid=' +
      encodeURIComponent(glanceCredentials.partnerid) +
      '&partneruserid=' +
      encodeURIComponent(glanceCredentials.partneruserid) +
      '&loginkey=' +
      encodeURIComponent(glanceCredentials.loginkey) +
      '&ssnkey=' +
      (null != $sessionkey$$ ? encodeURIComponent($sessionkey$$) : '');
    return new Promise(($resolve$$, $reject$$) => {
      (function () {
        _fireEvent('inSession', { service: 'agent', ssnkey: $sessionkey$$ });
        fetch($url$$, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: $data$jscomp$0$$,
        })
          .then(($response$$) => $response$$.text())
          .then(($xml$$) =>
            new window.DOMParser().parseFromString($xml$$, 'text/xml')
          )
          .then(($data$$) => {
            if ($sessionkey$$) {
              $resolve$$(
                'true' ===
                  $data$$.getElementsByTagName('inSession')[0].textContent
              );
            } else {
              $data$$ = $data$$.getElementsByTagName('session2');
              let $sessionsResult$$ = 0 === $data$$.length ? !1 : [];
              for (let $i$$ = 0; $i$$ < $data$$.length; $i$$++) {
                $sessionsResult$$.push({
                  id: $data$$[$i$$].getElementsByTagName('id')[0].textContent,
                  ssnkey:
                    $data$$[$i$$].getElementsByTagName('passcode')[0]
                      .textContent,
                });
              }
              $resolve$$($sessionsResult$$);
            }
          });
      })();
    });
  };
  goog.exportProperty(GLANCE.Agent, 'inSession', GLANCE.Agent.inSession);
  GLANCE.Agent.joinSession = function ($sessionkey$$, $params$$ = {}) {
    GCommon.Log.log('GLANCE.Agent.joinSession');
    return new Promise(($resolve$$, $reject$$) => {
      let $$jscomp$nullish$tmp1$$;
      GLANCE.Agent.lookupSession(
        $sessionkey$$,
        null != ($$jscomp$nullish$tmp1$$ = $params$$.wait)
          ? $$jscomp$nullish$tmp1$$
          : !0
      ).then(($d$$) => {
        GLANCE.Agent.openAgentJoinURL($d$$.agentjoinurl, $params$$).then(
          ($viewer$$) => {
            $resolve$$($viewer$$);
          }
        );
      }, $reject$$);
    });
  };
  goog.exportProperty(GLANCE.Agent, 'joinSession', GLANCE.Agent.joinSession);
  GLANCE.Agent.cancelLookup = function () {
    lastLookup &&
      (GCommon.Log.log('GLANCE.Agent.cancelLookup'),
      (lastLookup.canceled = !0));
  };
  goog.exportProperty(GLANCE.Agent, 'cancelLookup', GLANCE.Agent.cancelLookup);
  GLANCE.Agent.close = function ($viewer$$) {
    GCommon.Log.log('GLANCE.Agent.close');
    $viewer$$ && $viewer$$.close();
    _fireEvent('viewerClosed', { service: 'agent' });
  };
  goog.exportProperty(GLANCE.Agent, 'close', GLANCE.Agent.close);
  GLANCE.Agent.presenceConnect = function ($visitorid$$) {
    GCommon.Log.log('GLANCE.Agent.presenceConnect');
    return new Promise(($resolve$$, $reject$$) => {
      GLANCE.Presence.Agent || $reject$$('Glance Presence Agent undefined');
      if (0 === Object.keys(glanceCredentials || {}).length) {
        let $data$$ = { service: 'presence', reason: 'no credentials' };
        _fireEvent('presenceFailed', $data$$);
        $reject$$($data$$);
      }
      try {
        console.log(glanceCredentials),
          GLANCE.Authorization.authorize({
            ws: new URL(GLANCE.Agent.webserver).host,
            service: 'presence',
            credentials: {
              partneruserid: glanceCredentials.partneruserid,
              loginkey: glanceCredentials.loginkey,
              partnerid: glanceCredentials.partnerid,
            },
            groupid: glanceCredentials.partnerid,
            duration: 120,
            onsuccess: ($data$jscomp$1$$) => {
              _fireEvent('presenceAuthorized', {
                service: 'presence',
                data: $data$jscomp$1$$,
              });
              presenceAgent = new GLANCE.Presence.Agent({
                ws: new URL(GLANCE.Agent.webserver).host,
                groupid: glanceCredentials.partnerid,
                visitorid: $visitorid$$,
              });
              presenceAgent.onvisitorconn = ($data$jscomp$0$$) => {
                console.log('onvisitorconn', 'Agent.js');
                _fireEvent('visitorConnected', $data$jscomp$0$$);
                presenceAgent.lookupVisitor({
                  onsuccess: ($data$$) => {
                    _fireEvent('visitorData', $data$$);
                    $resolve$$($data$$);
                  },
                  onfail: ($error$$) => {
                    _fireEvent('lookupFailed', $error$$);
                    $reject$$($error$$);
                  },
                });
              };
              presenceAgent.onpresence = ($data$$) => {
                _fireEvent('presence', $data$$);
              };
              presenceAgent.onterms = ($data$$) => {
                _fireEvent('presenceOnTerms', $data$$);
              };
              presenceAgent.onvisitorsessionend = ($data$$) => {
                _fireEvent('presenceSessionEnd', $data$$);
              };
              presenceAgent.onerror = ($error$$) => {
                _fireEvent('presenceError', $error$$);
              };
              presenceAgent.onvisibility = ($data$$) => {
                _fireEvent('presenceVisibility', $data$$);
              };
              presenceAgent.onvisitorsock = ($data$$) => {
                _fireEvent('visitorSock', $data$$);
              };
              presenceAgent.connect();
            },
            onfail: ($error$$) => {
              _fireEvent('presenceFailed', {
                service: 'presence',
                reason: $error$$,
              });
              $reject$$($error$$);
            },
          });
      } catch ($error$$) {
        _fireEvent('presenceFailed', { service: 'presence', reason: $error$$ }),
          $reject$$($error$$);
      }
    });
  };
  goog.exportProperty(
    GLANCE.Agent,
    'presenceConnect',
    GLANCE.Agent.presenceConnect
  );
  GLANCE.Agent.presenceStartSession = function (
    $sessionKey$$,
    $invokeParams$$,
    $joinParams$$
  ) {
    GCommon.Log.log('GLANCE.Agent.presenceStartSession');
    let $params$$ = $invokeParams$$ || {};
    $params$$.func = $params$$.func || 'GLANCE.Cobrowse.VisitorUI.showTerms';
    $params$$.args = $params$$.args || {};
    let $key$$ =
      $sessionKey$$ ||
      $params$$.args.sessionKey ||
      Math.floor(10000 * Math.random());
    return new Promise(function ($resolve$$, $reject$$) {
      GLANCE.Presence.Agent || $reject$$('Glance Presence Agent undefined');
      $params$$.args.sessionKey = $key$$;
      $params$$.onfail = function ($data$$) {
        _fireEvent('presenceInvokeFailed', {
          service: 'presence',
          reason: $data$$,
        });
        $reject$$($data$$);
      };
      presenceAgent.onvisitorsessionstart = () => {
        _fireEvent('presenceSessionStart', {});
      };
      presenceAgent.invokeVisitor($params$$);
    });
  };
  goog.exportProperty(
    GLANCE.Agent,
    'presenceStartSession',
    GLANCE.Agent.presenceStartSession
  );
  GLANCE.Agent.presenceDisconnect = function () {
    GCommon.Log.log('GLANCE.Agent.presenceDisconnect');
    presenceAgent.disconnect();
  };
  GLANCE.Agent.setPresenceVisitorId = function ($visitorId$$) {
    presenceAgent.setVisitorId($visitorId$$);
  };
  GLANCE.Agent.disconnectVisitor = function () {
    _fireEvent('visitorConnected', { connected: !1 });
  };
  window.addEventListener('beforeunload', function () {
    console.log('unload');
  });
  
  // class GlanceAgent {
  //   constructor() {
  //     // Set the name to 'GLANCE.Agent' as per your requirement
  //     this.name = 'GLANCE.Agent';
  //   }
  // }

  // // Export the GlanceAgent as a module so Vite can resolve it correctly
  // if (typeof module !== 'undefined' && module.exports) {
  //   // For Node.js/CommonJS environments (if needed)
  //   module.exports = GlanceAgent;
  // } else {
  //   // For global/window access (in browser)
  //   window.GlanceAgent = GlanceAgent;
  // }

  return GLANCE.Agent;
}).call(window);

// For CommonJS (Node.js), export it
if (typeof module !== 'undefined' && module.exports) {
  module.exports = GlanceAgent;
} else {
  // For global/window access in the browser (via IIFE)
  window.GlanceAgent = GlanceAgent;
}
// Make it also an ES module export (for bundlers like Vite)
export { GlanceAgent };
